// @ts-nocheck
/* eslint-disable */
/**
 THIS IS GENERATED FILE. DO NOT MODIFY IT DIRECTLY, RUN 'npm run codegen' INSTEAD. 
*/
import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigDecimal: number;
  Date: string;
  DateTime: string;
  NonNegativeInt: number;
  Object: unknown;
  PositiveInt: number;
  Upload: unknown;
}

export interface AccessDetailsForSupplier {
  readonly __typename?: 'AccessDetailsForSupplier';
  readonly text: Maybe<Scalars['String']>;
}

export interface AccessDetailsForSupplierInput {
  readonly text?: InputMaybe<Scalars['String']>;
}

export enum ActivityState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export interface AddContainerInput {
  readonly customerId?: InputMaybe<Scalars['ID']>;
  readonly owner: ContainerOwner;
  readonly productContainerTypeCode: Scalars['String'];
  readonly quantity: Scalars['NonNegativeInt'];
  readonly serviceLocationId: Scalars['ID'];
  readonly startDate: Scalars['Date'];
  readonly supplierId?: InputMaybe<Scalars['ID']>;
  readonly wasteTypeCode: Scalars['String'];
}

export interface AdditionalLine {
  readonly __typename?: 'AdditionalLine';
  readonly additionalServiceCategoryCode: Scalars['String'];
  readonly requestedQuantity: Scalars['PositiveInt'];
}

export interface AdditionalServiceCategory {
  readonly __typename?: 'AdditionalServiceCategory';
  readonly code: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly id: Scalars['ID'];
  readonly presentedName: Scalars['String'];
}

export interface Agent {
  readonly __typename?: 'Agent';
  readonly id: Scalars['ID'];
  readonly mainAgent: Scalars['Boolean'];
  readonly organization: Organization;
}

export interface AgentInProcessGql {
  readonly __typename?: 'AgentInProcessGql';
  readonly organization: OrganizationInProcessGql;
}

export interface AgentInput {
  readonly locale: Locale;
}

export interface AgentsFiltersInput {
  readonly limit: Scalars['PositiveInt'];
  readonly locale?: InputMaybe<ReadonlyArray<Locale>>;
  readonly offset: Scalars['NonNegativeInt'];
}

export interface Aggregate {
  readonly events: ReadonlyArray<EventRepresentation>;
  readonly id: Scalars['ID'];
}

export interface Amendment {
  readonly __typename?: 'Amendment';
  readonly pendingProposals: ReadonlyArray<OrderProposal>;
  readonly permittedProposers: ReadonlyArray<OrganizationSummary>;
  readonly requestedContainerQuantity: Maybe<Scalars['PositiveInt']>;
  readonly requestedServiceDate: Maybe<Scalars['Date']>;
  readonly startedAt: Scalars['DateTime'];
  readonly startedBy: OrganizationSummary;
}

export interface ArbitrationInput {
  readonly failureId: Scalars['ID'];
}

export interface AvailableContainerActions {
  readonly __typename?: 'AvailableContainerActions';
  readonly createNewOrder: Scalars['Boolean'];
  readonly delete: Scalars['Boolean'];
  readonly edit: Scalars['Boolean'];
}

export interface AvailableCustomerActions {
  readonly __typename?: 'AvailableCustomerActions';
  readonly delete: Scalars['Boolean'];
}

export interface AvailableDocumentActions {
  readonly __typename?: 'AvailableDocumentActions';
  readonly documentRollback: DocumentRollback;
}

export interface AvailableOrderActions {
  readonly __typename?: 'AvailableOrderActions';
  readonly cancelSchedule: Scalars['Boolean'];
  readonly cancelSingleOrder: Scalars['Boolean'];
  readonly confirmDelivery: Scalars['Boolean'];
  readonly creditMemo: Scalars['Boolean'];
  readonly edit: Scalars['Boolean'];
  readonly editWithoutNegotiation: Scalars['Boolean'];
  readonly reportServiceFailure: Scalars['Boolean'];
}

export interface AvailableScheduledOrderActions {
  readonly __typename?: 'AvailableScheduledOrderActions';
  readonly cancel: Scalars['Boolean'];
  readonly edit: Scalars['Boolean'];
}

export interface AvailableSiteActions {
  readonly __typename?: 'AvailableSiteActions';
  readonly delete: Scalars['Boolean'];
}

export interface AvailableSupplierActions {
  readonly __typename?: 'AvailableSupplierActions';
  readonly delete: Scalars['Boolean'];
}

export interface BigDecimalInput {
  readonly value?: InputMaybe<Scalars['BigDecimal']>;
}

export enum BuildingType {
  Airport = 'AIRPORT',
  Bank = 'BANK',
  DataCenter = 'DATA_CENTER',
  DistributionCenter = 'DISTRIBUTION_CENTER',
  EducationalInstitution = 'EDUCATIONAL_INSTITUTION',
  Hospital = 'HOSPITAL',
  Hotel = 'HOTEL',
  Office = 'OFFICE',
  Other = 'OTHER',
  Production = 'PRODUCTION',
  Retail = 'RETAIL'
}

export enum BusinessUnit {
  Education = 'EDUCATION',
  Finance = 'FINANCE',
  Government = 'GOVERNMENT',
  Healthcare = 'HEALTHCARE',
  Infrastructure = 'INFRASTRUCTURE',
  Insurance = 'INSURANCE',
  Internal = 'INTERNAL',
  Other = 'OTHER',
  Technology = 'TECHNOLOGY'
}

export interface CancelFailureInput {
  readonly failureId: Scalars['ID'];
}

export interface CancelOrderInput {
  readonly orderId: Scalars['ID'];
}

export interface CancelRequestInput {
  readonly requestId: Scalars['ID'];
}

export interface CancelScheduleInput {
  readonly effectiveFrom: Scalars['Date'];
  readonly scheduleId: Scalars['ID'];
}

export interface CatalogProductType {
  readonly __typename?: 'CatalogProductType';
  readonly category: Scalars['String'];
  readonly frequency: Maybe<FrequencyFeature>;
  readonly id: Scalars['ID'];
  readonly isCategoryRecommended: Scalars['Boolean'];
  readonly isSupplierRecommended: Scalars['Boolean'];
  readonly resource: Maybe<Scalars['String']>;
  readonly resourceCategory: Maybe<Scalars['String']>;
  readonly supplierId: Scalars['ID'];
  readonly wasteType: Maybe<Scalars['String']>;
}

export interface CatalogSearchCriteriaInput {
  readonly frequencyFeature?: InputMaybe<FrequencyFeature>;
  readonly productCategory?: InputMaybe<Scalars['String']>;
  readonly resource?: InputMaybe<Scalars['String']>;
  readonly resourceCategory?: InputMaybe<Scalars['String']>;
  readonly serviceLocationId?: InputMaybe<Scalars['ID']>;
  readonly siteId?: InputMaybe<Scalars['ID']>;
  readonly supplierId?: InputMaybe<Scalars['ID']>;
  readonly wasteTypeFeature?: InputMaybe<Scalars['String']>;
}

export interface ChangeHistory {
  readonly __typename?: 'ChangeHistory';
  readonly newValue: Maybe<Scalars['String']>;
  readonly oldValue: Maybe<Scalars['String']>;
  readonly parameter: Scalars['String'];
}

export interface ChangeOrdersStateIntoDeliveredProcessGql extends ProcessGql {
  readonly __typename?: 'ChangeOrdersStateIntoDeliveredProcessGql';
  readonly createdAt: Scalars['DateTime'];
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly finalStatus: ProcessStatusGql;
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly initiator: Maybe<User>;
  readonly lastProcessedEvent: Scalars['Int'];
  readonly numUpdatedOrders: Scalars['Int'];
  readonly parentId: Maybe<Scalars['ID']>;
  readonly parentSpanId: Maybe<Scalars['String']>;
  readonly rootId: Scalars['ID'];
  readonly selfStatus: ProcessStatusGql;
  readonly spanId: Maybe<Scalars['String']>;
  readonly subProcesses: ReadonlyArray<Scalars['Object']>;
  readonly traceId: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export interface ChangeRequestsStateIntoExpiredProcessGql extends ProcessGql {
  readonly __typename?: 'ChangeRequestsStateIntoExpiredProcessGql';
  readonly createdAt: Scalars['DateTime'];
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly finalStatus: ProcessStatusGql;
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly initiator: Maybe<User>;
  readonly lastProcessedEvent: Scalars['Int'];
  readonly numUpdatedRequests: Scalars['Int'];
  readonly parentId: Maybe<Scalars['ID']>;
  readonly parentSpanId: Maybe<Scalars['String']>;
  readonly rootId: Scalars['ID'];
  readonly selfStatus: ProcessStatusGql;
  readonly spanId: Maybe<Scalars['String']>;
  readonly subProcesses: ReadonlyArray<Scalars['Object']>;
  readonly traceId: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export interface ChangeStateInput {
  readonly customerId?: InputMaybe<Scalars['ID']>;
  readonly fromServiceDate: Scalars['Date'];
  readonly supplierId?: InputMaybe<Scalars['ID']>;
  readonly toServiceDate?: InputMaybe<Scalars['Date']>;
}

export interface ChargeLine {
  readonly __typename?: 'ChargeLine';
  readonly amount: Maybe<Scalars['BigDecimal']>;
  readonly code: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy: Maybe<User>;
  readonly currency: Maybe<Scalars['String']>;
  readonly id: Scalars['ID'];
  readonly priceRuleDescription: Maybe<Scalars['String']>;
  readonly quantity: Maybe<Scalars['Int']>;
  readonly unitType: Maybe<UnitType>;
}

export interface CleanCatalogProcessGql extends ProcessGql {
  readonly __typename?: 'CleanCatalogProcessGql';
  readonly createdAt: Scalars['DateTime'];
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly finalStatus: ProcessStatusGql;
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly initiator: Maybe<User>;
  readonly lastProcessedEvent: Scalars['Int'];
  readonly numDeletedEntries: Scalars['Int'];
  readonly parentId: Maybe<Scalars['ID']>;
  readonly parentSpanId: Maybe<Scalars['String']>;
  readonly rootId: Scalars['ID'];
  readonly selfStatus: ProcessStatusGql;
  readonly spanId: Maybe<Scalars['String']>;
  readonly subProcesses: ReadonlyArray<Scalars['Object']>;
  readonly traceId: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export enum CompanySpecification {
  CollectorWithoutProcessing = 'COLLECTOR_WITHOUT_PROCESSING',
  CollectorWithProcessing = 'COLLECTOR_WITH_PROCESSING',
  Leasing = 'LEASING',
  PublicProcessingPlant = 'PUBLIC_PROCESSING_PLANT',
  RecyclingPlant = 'RECYCLING_PLANT'
}

export enum CompanyType {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export interface ContactPerson {
  readonly __typename?: 'ContactPerson';
  readonly email: Scalars['String'];
  readonly firstName: Maybe<Scalars['String']>;
  readonly phoneNumber: Maybe<Scalars['String']>;
  readonly role: Scalars['String'];
  readonly surname: Maybe<Scalars['String']>;
}

export interface ContactPersonInput {
  readonly email: Scalars['String'];
  readonly firstName?: InputMaybe<Scalars['String']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']>;
  readonly role: Scalars['String'];
  readonly surname?: InputMaybe<Scalars['String']>;
}

export enum ContainerOwner {
  Customer = 'CUSTOMER',
  Supplier = 'SUPPLIER'
}

export interface ContainerTypeOnServiceLocation {
  readonly __typename?: 'ContainerTypeOnServiceLocation';
  readonly productContainerCode: Scalars['String'];
  readonly productContainerTypeName: Scalars['String'];
  readonly quantity: Scalars['NonNegativeInt'];
  readonly quantityInDelivery: Scalars['Int'];
}

export interface ContainerTypeOnSite {
  readonly __typename?: 'ContainerTypeOnSite';
  readonly activeSchedules: Maybe<ReadonlyArray<ScheduleForContainer>>;
  readonly availableActions: AvailableContainerActions;
  readonly customerId: Scalars['ID'];
  readonly endDate: Maybe<Scalars['Date']>;
  readonly isOnSite: Scalars['Boolean'];
  readonly nearestOneOffOrder: Maybe<OrderForContainer>;
  readonly ownerBusinessId: Scalars['String'];
  readonly ownerId: Scalars['ID'];
  readonly ownerName: Scalars['String'];
  readonly productContainerTypeCode: Scalars['String'];
  readonly productContainerTypeName: Scalars['String'];
  readonly quantity: Scalars['Int'];
  readonly serviceLocationCode: Scalars['String'];
  readonly serviceLocationId: Scalars['ID'];
  readonly serviceLocationName: Scalars['String'];
  readonly siteId: Scalars['ID'];
  readonly startDate: Maybe<Scalars['Date']>;
  readonly supplierName: Maybe<Scalars['String']>;
  readonly wasteTypeCode: Scalars['String'];
  readonly wasteTypeEwcCode: Scalars['String'];
  readonly wasteTypePresentedName: Scalars['String'];
}

export interface ContainerTypesOnSiteResponse {
  readonly __typename?: 'ContainerTypesOnSiteResponse';
  readonly items: ReadonlyArray<ContainerTypeOnSite>;
  readonly totalCount: Scalars['NonNegativeInt'];
}

export interface ContainerWasteTypesFiltersInput {
  readonly serviceLocationId?: InputMaybe<Scalars['ID']>;
  readonly siteId?: InputMaybe<Scalars['ID']>;
}

export interface ContainersFiltersInput {
  readonly limit: Scalars['PositiveInt'];
  readonly offset: Scalars['NonNegativeInt'];
  readonly productContainerCodes?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly serviceLocationIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly showOnlyActive: Scalars['Boolean'];
  readonly showOnlyOnSite?: InputMaybe<Scalars['Boolean']>;
  readonly showWithFrequency?: InputMaybe<Scalars['Boolean']>;
  readonly siteId: Scalars['ID'];
  readonly wasteTypeCodes?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface CountryConfigGql {
  readonly __typename?: 'CountryConfigGql';
  readonly currency: Scalars['String'];
  readonly helpdeskUrl: Scalars['String'];
  readonly organizationIdentifierTypes: ReadonlyArray<IdentifierName>;
  readonly postalCodeValidationPattern: Scalars['String'];
  readonly requireServiceConfirmationForOrdersWithoutDisposal: Scalars['Boolean'];
  readonly timeZone: Scalars['String'];
  readonly useOrderConfirmationFlowByDefault: Scalars['Boolean'];
}

export interface CountryGql {
  readonly __typename?: 'CountryGql';
  readonly code: Locale;
  readonly config: CountryConfigGql;
  readonly id: Scalars['ID'];
  readonly presentedName: Scalars['String'];
}

export interface CreateAdditionalLineInput {
  readonly actualQuantity?: InputMaybe<IntegerInput>;
  readonly additionalServiceCategoryCode: Scalars['String'];
  readonly requestedQuantity?: InputMaybe<IntegerInput>;
}

export interface CreateGroupOrdersFromScheduleProcessGql extends ProcessGql {
  readonly __typename?: 'CreateGroupOrdersFromScheduleProcessGql';
  readonly createdAt: Scalars['DateTime'];
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly finalStatus: ProcessStatusGql;
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly initiator: Maybe<User>;
  readonly lastProcessedEvent: Scalars['Int'];
  readonly numCreatedGroupOrders: Scalars['Int'];
  readonly parentId: Maybe<Scalars['ID']>;
  readonly parentSpanId: Maybe<Scalars['String']>;
  readonly rootId: Scalars['ID'];
  readonly selfStatus: ProcessStatusGql;
  readonly spanId: Maybe<Scalars['String']>;
  readonly subProcesses: ReadonlyArray<Scalars['Object']>;
  readonly traceId: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export interface CreateOnceOffManualRequestInput {
  readonly accessDetails?: InputMaybe<AccessDetailsForSupplierInput>;
  readonly additionalRequestLines?: InputMaybe<ReadonlyArray<CreateAdditionalLineInput>>;
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly customerId: Scalars['ID'];
  readonly customerReferenceNo?: InputMaybe<Scalars['String']>;
  readonly date: Scalars['Date'];
  readonly destinationServiceLocationId?: InputMaybe<Scalars['ID']>;
  readonly requestLineParams: ReadonlyArray<RequestLineParamsInput>;
  readonly serviceLocationId: Scalars['ID'];
  readonly siteId: Scalars['ID'];
  readonly withConfirmation: Scalars['Boolean'];
}

export interface CreateOnceOffManualRequestsInput {
  readonly requests: ReadonlyArray<CreateOnceOffManualRequestInput>;
}

export interface CreateOnceOffRequestInput {
  readonly accessDetails?: InputMaybe<AccessDetailsForSupplierInput>;
  readonly additionalRequestLines?: InputMaybe<ReadonlyArray<CreateAdditionalLineInput>>;
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly customerId: Scalars['ID'];
  readonly customerReferenceNo?: InputMaybe<Scalars['String']>;
  readonly date: Scalars['Date'];
  readonly destinationServiceLocationId?: InputMaybe<Scalars['ID']>;
  readonly requestLines: ReadonlyArray<CreateRequestLineInput>;
  readonly serviceLocationId: Scalars['ID'];
  readonly siteId: Scalars['ID'];
  readonly withConfirmation: Scalars['Boolean'];
}

export interface CreateOnceOffRequestsInput {
  readonly requests: ReadonlyArray<CreateOnceOffRequestInput>;
}

export interface CreateRequestLineInput {
  readonly productTypeId: Scalars['ID'];
  readonly quantity: Scalars['PositiveInt'];
}

export interface CreateRequestResponse {
  readonly __typename?: 'CreateRequestResponse';
  readonly createdOrderIds: ReadonlyArray<Scalars['ID']>;
  readonly createdRequestIds: ReadonlyArray<Scalars['ID']>;
  readonly createdScheduleIds: ReadonlyArray<Scalars['ID']>;
}

export interface CreateScheduledManualRequestInput {
  readonly accessDetails?: InputMaybe<AccessDetailsForSupplierInput>;
  readonly additionalRequestLines?: InputMaybe<ReadonlyArray<CreateAdditionalLineInput>>;
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly customerId: Scalars['ID'];
  readonly customerReferenceNo?: InputMaybe<Scalars['String']>;
  readonly requestLineParams: ReadonlyArray<RequestLineParamsInput>;
  readonly scheduleConfiguration: ScheduleConfigurationInput;
  readonly serviceLocationId: Scalars['ID'];
  readonly siteId: Scalars['ID'];
  readonly withConfirmation: Scalars['Boolean'];
}

export interface CreateScheduledManualRequestsInput {
  readonly requests: ReadonlyArray<CreateScheduledManualRequestInput>;
}

export interface CreateScheduledRequestInput {
  readonly accessDetails?: InputMaybe<AccessDetailsForSupplierInput>;
  readonly additionalRequestLines?: InputMaybe<ReadonlyArray<CreateAdditionalLineInput>>;
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly customerId: Scalars['ID'];
  readonly customerReferenceNo?: InputMaybe<Scalars['String']>;
  readonly requestLines: ReadonlyArray<CreateRequestLineInput>;
  readonly scheduleConfiguration: ScheduleConfigurationInput;
  readonly serviceLocationId: Scalars['ID'];
  readonly siteId: Scalars['ID'];
  readonly withConfirmation: Scalars['Boolean'];
}

export interface CreateScheduledRequestsInput {
  readonly requests: ReadonlyArray<CreateScheduledRequestInput>;
}

export interface CreditMemoInput {
  readonly groupOrderId: Scalars['ID'];
  readonly reconciledOrders: ReadonlyArray<ReconciledOrder>;
}

export interface Customer {
  readonly __typename?: 'Customer';
  readonly availableActions: AvailableCustomerActions;
  readonly businessUnit: BusinessUnit;
  readonly contractId: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly organization: Organization;
  readonly sites: ReadonlyArray<Site>;
}

export interface CustomerInProcessGql {
  readonly __typename?: 'CustomerInProcessGql';
  readonly contractId: Scalars['String'];
  readonly organization: OrganizationInProcessGql;
}

export interface CustomerInput {
  readonly businessUnit: BusinessUnit;
  readonly contractId?: InputMaybe<Scalars['String']>;
  readonly organization: OrganizationInput;
}

export interface CustomerReportInput {
  readonly customerIds: ReadonlyArray<Scalars['ID']>;
  readonly endDate: Scalars['Date'];
  readonly siteIds: ReadonlyArray<Scalars['ID']>;
  readonly startDate: Scalars['Date'];
}

export interface CustomersFiltersInput {
  readonly businessId?: InputMaybe<Scalars['String']>;
  readonly businessUnits?: InputMaybe<ReadonlyArray<BusinessUnit>>;
  readonly country?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly limit: Scalars['PositiveInt'];
  readonly offset: Scalars['NonNegativeInt'];
}

export interface CustomersResponse {
  readonly __typename?: 'CustomersResponse';
  readonly items: ReadonlyArray<Customer>;
  readonly totalCount: Scalars['NonNegativeInt'];
}

export enum DayOfWeek {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export interface Document {
  readonly __typename?: 'Document';
  readonly availableActions: Maybe<AvailableDocumentActions>;
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy: Maybe<User>;
  readonly documentType: DocumentType;
  readonly id: Scalars['ID'];
  readonly originalFileName: Scalars['String'];
  readonly process: Maybe<ProcessViewGql>;
  readonly siteIds: Maybe<ReadonlyArray<Scalars['ID']>>;
}

export interface DocumentInOrderSearchInput {
  readonly orderId?: InputMaybe<Scalars['ID']>;
}

export interface DocumentInProcessGql {
  readonly __typename?: 'DocumentInProcessGql';
  readonly id: Scalars['ID'];
  readonly originalFileName: Scalars['String'];
}

export interface DocumentRollback {
  readonly __typename?: 'DocumentRollback';
  readonly alreadyRolledBack: Scalars['Boolean'];
  readonly canRollback: Scalars['Boolean'];
}

export interface DocumentSearchCriteriaInput {
  readonly documentTypes?: InputMaybe<ReadonlyArray<DocumentType>>;
  readonly from?: InputMaybe<Scalars['DateTime']>;
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly limit: Scalars['PositiveInt'];
  readonly offset: Scalars['NonNegativeInt'];
  readonly organizationId?: InputMaybe<Scalars['ID']>;
  readonly siteId?: InputMaybe<Scalars['ID']>;
  readonly to?: InputMaybe<Scalars['DateTime']>;
}

export enum DocumentTemplate {
  EquipmentBulkUpload = 'EQUIPMENT_BULK_UPLOAD',
  ScheduleBulkUpload = 'SCHEDULE_BULK_UPLOAD',
  SiteBulkUpload = 'SITE_BULK_UPLOAD'
}

export enum DocumentType {
  CustomerCreditMemoStatement = 'CUSTOMER_CREDIT_MEMO_STATEMENT',
  CustomerInvoiceStatement = 'CUSTOMER_INVOICE_STATEMENT',
  OrderDocument = 'ORDER_DOCUMENT',
  OrderServiceFailureFile = 'ORDER_SERVICE_FAILURE_FILE',
  SalesPricingFile = 'SALES_PRICING_FILE',
  SupplierCreditMemoStatement = 'SUPPLIER_CREDIT_MEMO_STATEMENT',
  SupplierDataUpload = 'SUPPLIER_DATA_UPLOAD',
  SupplierDefaultTreatmentMethods = 'SUPPLIER_DEFAULT_TREATMENT_METHODS',
  SupplierInvoiceStatement = 'SUPPLIER_INVOICE_STATEMENT',
  SupplierMasterFile = 'SUPPLIER_MASTER_FILE'
}

export interface DocumentsResponse {
  readonly __typename?: 'DocumentsResponse';
  readonly items: ReadonlyArray<Document>;
  readonly totalCount: Scalars['NonNegativeInt'];
}

export interface DownloadMasterExcelInput {
  readonly supplierIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly useLastUploaded?: InputMaybe<Scalars['Boolean']>;
}

export interface DownloadSalesPriceExcelInput {
  readonly customerIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly useLastUploaded?: InputMaybe<Scalars['Boolean']>;
}

export interface EditChargeLineInput {
  readonly amount?: InputMaybe<BigDecimalInput>;
  readonly id: Scalars['ID'];
}

export interface EditOnceOffRequestProposalInput {
  readonly requestId?: InputMaybe<Scalars['ID']>;
  readonly serviceDates: ReadonlyArray<Scalars['Date']>;
}

export interface EditOrderInput {
  readonly accessDetailsForSupplier?: InputMaybe<Scalars['String']>;
  readonly actualServiceDate?: InputMaybe<Scalars['Date']>;
  readonly chargeLines?: InputMaybe<ReadonlyArray<EditChargeLineInput>>;
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly newAdditionalOrderLines?: InputMaybe<ReadonlyArray<CreateAdditionalLineInput>>;
  readonly orderId: Scalars['ID'];
  readonly orderLines?: InputMaybe<ReadonlyArray<EditOrderLineInput>>;
  readonly removedOrderLines?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly serviceDate?: InputMaybe<Scalars['Date']>;
  readonly state?: InputMaybe<OrderState>;
  readonly withoutNegotiation?: InputMaybe<Scalars['Boolean']>;
}

export interface EditOrderLineInput {
  readonly actualQuantity?: InputMaybe<IntegerInput>;
  readonly id: Scalars['ID'];
  readonly orderedProductData?: InputMaybe<EditOrderedProductData>;
  readonly requestedQuantity?: InputMaybe<IntegerInput>;
  readonly totalCost?: InputMaybe<BigDecimalInput>;
  readonly treatmentFacilityId?: InputMaybe<IdInput>;
  readonly unitPriceValue?: InputMaybe<Scalars['BigDecimal']>;
}

export interface EditOrderProposalInput {
  readonly containerQuantity?: InputMaybe<Scalars['PositiveInt']>;
  readonly proposingSide: Side;
  readonly serviceDates: ReadonlyArray<Scalars['Date']>;
  readonly urlMapId: Scalars['ID'];
}

export interface EditOrderedProductData {
  readonly resourceCode?: InputMaybe<Scalars['String']>;
  readonly wasteTypeCode?: InputMaybe<Scalars['String']>;
}

export interface EditOrdersInput {
  readonly orders: ReadonlyArray<EditOrderInput>;
}

export interface EditScheduledOrderInput {
  readonly accessDetailsForSupplier?: InputMaybe<AccessDetailsForSupplierInput>;
  readonly orderLines?: InputMaybe<ReadonlyArray<EditScheduledOrderLineInput>>;
  readonly scheduleConfiguration?: InputMaybe<ScheduleConfigurationInput>;
  readonly scheduledOrderId: Scalars['ID'];
  readonly withoutNegotiation?: InputMaybe<Scalars['Boolean']>;
}

export interface EditScheduledOrderLineInput {
  readonly containerQuantity?: InputMaybe<Scalars['PositiveInt']>;
  readonly id: Scalars['ID'];
}

export interface EditScheduledRequestProposalInput {
  readonly requestId?: InputMaybe<Scalars['ID']>;
  readonly scheduleConfigurations: ReadonlyArray<ScheduleConfigurationInput>;
}

export interface Email {
  readonly __typename?: 'Email';
  readonly attachments: ReadonlyArray<EmailAttachment>;
  readonly createdAt: Scalars['DateTime'];
  readonly html: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly plain: Scalars['String'];
  readonly recipient: Scalars['String'];
  readonly state: Scalars['String'];
  readonly subject: Scalars['String'];
}

export interface EmailAttachment {
  readonly __typename?: 'EmailAttachment';
  readonly blobContainer: Maybe<Scalars['String']>;
  readonly blobName: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly filename: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly mimeType: Scalars['String'];
}

export interface EmailAttachmentInProcessGql {
  readonly __typename?: 'EmailAttachmentInProcessGql';
  readonly blobContainer: Maybe<Scalars['String']>;
  readonly blobName: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly fileName: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly mimeType: Scalars['String'];
}

export interface EmailInProcessGql {
  readonly __typename?: 'EmailInProcessGql';
  readonly attachments: ReadonlyArray<EmailAttachmentInProcessGql>;
  readonly createdAt: Scalars['DateTime'];
  readonly html: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly recipient: Scalars['String'];
  readonly state: Scalars['String'];
  readonly subject: Scalars['String'];
}

export interface EmailSearchCriteriaInput {
  readonly from?: InputMaybe<Scalars['DateTime']>;
  readonly limit: Scalars['PositiveInt'];
  readonly offset: Scalars['NonNegativeInt'];
  readonly to?: InputMaybe<Scalars['DateTime']>;
}

export interface EmailsResponse {
  readonly __typename?: 'EmailsResponse';
  readonly items: ReadonlyArray<Email>;
  readonly totalCount: Scalars['NonNegativeInt'];
}

export interface Employee {
  readonly __typename?: 'Employee';
  readonly id: Scalars['ID'];
  readonly organizationId: Scalars['ID'];
  readonly roles: ReadonlyArray<Role>;
  readonly user: User;
}

export interface EmployeeRoleInput {
  readonly employeeRole: Role;
  readonly employerId: Scalars['ID'];
}

export interface EndFailureNegotiationInput {
  readonly negotiationId: Scalars['ID'];
}

export interface EntitiesGenericResponse {
  readonly __typename?: 'EntitiesGenericResponse';
  readonly ids: ReadonlyArray<Scalars['ID']>;
}

export interface EntityGenericResponse {
  readonly __typename?: 'EntityGenericResponse';
  readonly id: Scalars['ID'];
}

export interface EquipmentReportInput {
  readonly customerIds: ReadonlyArray<Scalars['ID']>;
  readonly raw: Scalars['Boolean'];
  readonly siteIds: ReadonlyArray<Scalars['ID']>;
}

export interface EquipmentReportInternalInput {
  readonly customerIds: ReadonlyArray<Scalars['ID']>;
  readonly siteIds: ReadonlyArray<Scalars['ID']>;
}

export interface EventRepresentation {
  readonly __typename?: 'EventRepresentation';
  readonly data: Scalars['String'];
  readonly id: Scalars['Int'];
  readonly meta: Scalars['String'];
  readonly streamId: Scalars['String'];
  readonly streamPosition: Scalars['Int'];
  readonly type: Scalars['String'];
}

export interface Failure {
  readonly __typename?: 'Failure';
  readonly code: Maybe<FailureCode>;
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy: User;
  readonly description: Maybe<Scalars['String']>;
  readonly documents: Maybe<ReadonlyArray<Document>>;
  readonly groupOrderId: Maybe<Scalars['ID']>;
  readonly id: Scalars['ID'];
  readonly negotiations: Maybe<ReadonlyArray<FailureNegotiation>>;
  readonly orderId: Scalars['ID'];
  readonly state: Maybe<FailureState>;
  readonly waitingTimeInMinutes: Maybe<Scalars['String']>;
}

export enum FailureCode {
  NoServiceCustomerResponsibility = 'NO_SERVICE_CUSTOMER_RESPONSIBILITY',
  NoServiceSupplierResponsibility = 'NO_SERVICE_SUPPLIER_RESPONSIBILITY',
  NoServiceSupplierResponsibilityAdmission = 'NO_SERVICE_SUPPLIER_RESPONSIBILITY_ADMISSION',
  WaitingTime = 'WAITING_TIME'
}

export interface FailureFiltersInput {
  readonly groupOrderIds: ReadonlyArray<Scalars['String']>;
  readonly states?: InputMaybe<ReadonlyArray<FailureState>>;
}

export interface FailureNegotiation {
  readonly __typename?: 'FailureNegotiation';
  readonly availableActions: Maybe<ReadonlyArray<Maybe<FailureNegotiationAction>>>;
  readonly isInArbitration: Maybe<Scalars['Boolean']>;
  readonly negotiationId: Scalars['ID'];
  readonly proposals: Maybe<ReadonlyArray<FailureProposal>>;
  readonly startedAt: Scalars['DateTime'];
  readonly startedBy: OrganizationSummary;
  readonly state: NegotiationState;
  readonly waitingFor: Maybe<OrganizationSummary>;
}

export enum FailureNegotiationAction {
  ApplyForArbitration = 'APPLY_FOR_ARBITRATION',
  CancelFailure = 'CANCEL_FAILURE',
  EndNegotiation = 'END_NEGOTIATION',
  SubmitProposal = 'SUBMIT_PROPOSAL'
}

export interface FailureProposal {
  readonly __typename?: 'FailureProposal';
  readonly approvingSide: OrganizationSummary;
  readonly canRespond: Maybe<Scalars['Boolean']>;
  readonly failureCode: Maybe<Scalars['String']>;
  readonly proposalId: Scalars['ID'];
  readonly proposingSide: OrganizationSummary;
  readonly response: Maybe<FailureProposalResponse>;
  readonly serviceDate: Maybe<Scalars['Date']>;
  readonly startedAt: Scalars['DateTime'];
  readonly waitingTimeInMinutes: Maybe<Scalars['String']>;
}

export interface FailureProposalResponse {
  readonly __typename?: 'FailureProposalResponse';
  readonly comment: Maybe<Scalars['String']>;
  readonly createdBy: User;
  readonly responseType: ResponseType;
}

export enum FailureState {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export interface FailureType {
  readonly __typename?: 'FailureType';
  readonly name: FailureCode;
  readonly presentedName: Scalars['String'];
  readonly submitProposalAction: Scalars['Boolean'];
}

export interface FailuresResponse {
  readonly __typename?: 'FailuresResponse';
  readonly failures: Maybe<ReadonlyArray<Failure>>;
}

export interface FeatureFlag {
  readonly __typename?: 'FeatureFlag';
  readonly name: Scalars['String'];
  readonly value: Scalars['Boolean'];
}

export enum FileFormat {
  Csv = 'CSV',
  Xlsx = 'XLSX'
}

export interface FileUrlGenericListResponse {
  readonly __typename?: 'FileUrlGenericListResponse';
  readonly url: Maybe<ReadonlyArray<Scalars['String']>>;
}

export interface FileUrlGenericResponse {
  readonly __typename?: 'FileUrlGenericResponse';
  readonly url: Scalars['String'];
}

export enum FinancialReportFilterField {
  ActualDate = 'ACTUAL_DATE',
  ClosedDate = 'CLOSED_DATE',
  ClosedPurchaseDate = 'CLOSED_PURCHASE_DATE',
  ClosedSalesDate = 'CLOSED_SALES_DATE',
  ReadyForInvoicingDate = 'READY_FOR_INVOICING_DATE',
  RequestedDate = 'REQUESTED_DATE'
}

export interface FinancialReportInput {
  readonly customerIds: ReadonlyArray<Scalars['ID']>;
  readonly endDate: Scalars['Date'];
  readonly filterField: FinancialReportFilterField;
  readonly siteIds: ReadonlyArray<Scalars['ID']>;
  readonly startDate: Scalars['Date'];
}

export interface FindProcessesGqlInput {
  readonly from?: InputMaybe<Scalars['DateTime']>;
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly initiator?: InputMaybe<Scalars['String']>;
  readonly limit: Scalars['PositiveInt'];
  readonly offset: Scalars['NonNegativeInt'];
  readonly onlyRoots?: InputMaybe<Scalars['Boolean']>;
  readonly parentId?: InputMaybe<Scalars['ID']>;
  readonly spanId?: InputMaybe<Scalars['String']>;
  readonly statuses?: InputMaybe<ReadonlyArray<ProcessStatusGql>>;
  readonly to?: InputMaybe<Scalars['DateTime']>;
  readonly traceId?: InputMaybe<Scalars['String']>;
  readonly types?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export enum Frequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum FrequencyFeature {
  OnceOff = 'ONCE_OFF',
  Schedule = 'SCHEDULE'
}

export interface GeographicAddress {
  readonly __typename?: 'GeographicAddress';
  readonly addressLine: Maybe<Scalars['String']>;
  readonly city: Maybe<Scalars['String']>;
  readonly locale: Maybe<Locale>;
  readonly regionOrState: Maybe<Scalars['String']>;
  readonly zipOrPostCode: Maybe<Scalars['String']>;
}

export interface GeographicAddressInput {
  readonly addressLine: Scalars['String'];
  readonly city: Scalars['String'];
  readonly locale: Locale;
  readonly regionOrState?: InputMaybe<Scalars['String']>;
  readonly zipOrPostCode: Scalars['String'];
}

export interface GroupOrder extends Aggregate {
  readonly __typename?: 'GroupOrder';
  readonly events: ReadonlyArray<EventRepresentation>;
  readonly id: Scalars['ID'];
}

export enum HistoryActionType {
  Cancelling = 'CANCELLING',
  Edition = 'EDITION',
  ExpectedFlow = 'EXPECTED_FLOW',
  Failure = 'FAILURE',
  NegotiationCancel = 'NEGOTIATION_CANCEL',
  NegotiationEnd = 'NEGOTIATION_END',
  NegotiationStart = 'NEGOTIATION_START',
  NegotiationStep = 'NEGOTIATION_STEP'
}

export interface HistoryRecord {
  readonly __typename?: 'HistoryRecord';
  readonly actionType: HistoryActionType;
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy: Maybe<User>;
  readonly description: Scalars['String'];
  readonly historyChanges: ReadonlyArray<ChangeHistory>;
  readonly id: Scalars['ID'];
  readonly originEventId: Scalars['Int'];
  readonly sideCreator: HistorySideCreator;
}

export enum HistorySideCreator {
  Agent = 'AGENT',
  Customer = 'CUSTOMER',
  Process = 'PROCESS',
  Supplier = 'SUPPLIER'
}

export interface IdInput {
  readonly value?: InputMaybe<Scalars['ID']>;
}

export interface IdToName {
  readonly __typename?: 'IdToName';
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
}

export interface Identifier {
  readonly __typename?: 'Identifier';
  readonly name: IdentifierName;
  readonly value: Scalars['String'];
}

export interface IdentifierInput {
  readonly name: IdentifierName;
  readonly value: Scalars['String'];
}

export enum IdentifierName {
  Nip = 'NIP',
  PNumber = 'P_NUMBER',
  SeNumber = 'SE_NUMBER',
  Trn = 'TRN',
  Utr = 'UTR',
  Xid = 'XID'
}

export interface IntegerInput {
  readonly value?: InputMaybe<Scalars['NonNegativeInt']>;
}

export interface InvoiceActionsInput {
  readonly customerIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly siteIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly supplierId?: InputMaybe<Scalars['ID']>;
  readonly to: Scalars['Date'];
  readonly type: StatementDocumentType;
}

export interface ListenToAllWoEventsProcessGql extends ProcessGql {
  readonly __typename?: 'ListenToAllWoEventsProcessGql';
  readonly createdAt: Scalars['DateTime'];
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly finalStatus: ProcessStatusGql;
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly initiator: Maybe<User>;
  readonly lastProcessedEvent: Scalars['Int'];
  readonly parentId: Maybe<Scalars['ID']>;
  readonly parentSpanId: Maybe<Scalars['String']>;
  readonly rootId: Scalars['ID'];
  readonly selfStatus: ProcessStatusGql;
  readonly spanId: Maybe<Scalars['String']>;
  readonly subProcesses: ReadonlyArray<Scalars['Object']>;
  readonly traceId: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export enum Locale {
  Dk = 'DK',
  Ie = 'IE',
  Pl = 'PL',
  Uk = 'UK',
  Xt = 'XT'
}

export interface MstReportInput {
  readonly endDate: Scalars['Date'];
  readonly startDate: Scalars['Date'];
}

export interface MonthlyRecurrenceConfig {
  readonly __typename?: 'MonthlyRecurrenceConfig';
  readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay;
  readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType;
}

export enum MonthlyRecurrenceConfigDay {
  Day = 'DAY',
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Weekday = 'WEEKDAY',
  WeekendDay = 'WEEKEND_DAY'
}

export interface MonthlyRecurrenceConfigInput {
  readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay;
  readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType;
}

export enum MonthlyRecurrenceConfigType {
  First = 'FIRST',
  Fourth = 'FOURTH',
  Last = 'LAST',
  Second = 'SECOND',
  Third = 'THIRD'
}

export interface Mutation {
  readonly __typename?: 'Mutation';
  readonly activateUser: EntityGenericResponse;
  readonly addContainer: Scalars['Boolean'];
  readonly applyForArbitration: EntityGenericResponse;
  readonly cancelFailure: EntityGenericResponse;
  readonly cancelOrder: EntityGenericResponse;
  readonly cancelRequest: EntityGenericResponse;
  readonly cancelSchedule: EntityGenericResponse;
  readonly changeStateIntoReadyForInvoicingIfPossibleOrToDelivered: Scalars['Boolean'];
  readonly confirmGroupOrderDelivery: EntityGenericResponse;
  readonly createCustomer: EntityGenericResponse;
  readonly createCustomerInvoiceStatement: Scalars['Boolean'];
  readonly createCustomerReport: FileUrlGenericResponse;
  readonly createCustomersSitesLocationsReport: FileUrlGenericResponse;
  readonly createEquipmentReport: FileUrlGenericResponse;
  readonly createEquipmentReportInternal: FileUrlGenericResponse;
  readonly createFinancialReport: FileUrlGenericResponse;
  readonly createMstReport: FileUrlGenericResponse;
  readonly createOnceOffManualRequests: CreateRequestResponse;
  readonly createOnceOffRequests: CreateRequestResponse;
  readonly createScheduledManualRequests: CreateRequestResponse;
  readonly createScheduledRequests: CreateRequestResponse;
  readonly createSite: EntityGenericResponse;
  readonly createSupplier: EntityGenericResponse;
  readonly createSupplierInvoiceStatement: Scalars['Boolean'];
  readonly creditMemo: EntityGenericResponse;
  readonly deleteCustomer: EntityGenericResponse;
  readonly deleteSite: EntityGenericResponse;
  readonly deleteSupplier: EntityGenericResponse;
  readonly deleteUser: EntityGenericResponse;
  readonly downloadMasterExcel: FileUrlGenericResponse;
  readonly downloadSalesPriceExcel: FileUrlGenericResponse;
  readonly dumpThreads: Scalars['String'];
  readonly editOrders: EntitiesGenericResponse;
  readonly editScheduledOrder: EntityGenericResponse;
  readonly endFailureNegotiation: EntityGenericResponse;
  readonly prefilledFileForSupplierDataUpload: FileUrlGenericResponse;
  readonly previewCustomerInvoiceSpecification: FileUrlGenericListResponse;
  readonly previewSupplierInvoiceSpecification: FileUrlGenericResponse;
  readonly recalculatePrices: Scalars['Boolean'];
  readonly registerUser: EntityGenericResponse;
  readonly registerUser2: EntityGenericResponse;
  readonly reportServiceFailure: EntityGenericResponse;
  readonly respondToEditOrderProposal: EntityGenericResponse;
  readonly respondToEditScheduledOrderProposal: EntityGenericResponse;
  readonly respondToFailureProposal: EntityGenericResponse;
  readonly respondToRequestProposal: EntityGenericResponse;
  readonly rollbackSupplierInvoiceStatement: Scalars['Boolean'];
  readonly setFeatureFlag: EntityGenericResponse;
  readonly shutdown: Scalars['Boolean'];
  readonly submitEditOnceOffRequestProposal: EntityGenericResponse;
  readonly submitEditScheduledRequestProposal: EntityGenericResponse;
  readonly submitFailureProposal: EntityGenericResponse;
  readonly systemClockOffset: Scalars['Boolean'];
  readonly systemClockReset: Scalars['Boolean'];
  readonly triggerJob: Scalars['String'];
  readonly updateContainerQuantity: UpdateContainerQuantityResult;
  readonly updateCustomer: EntityGenericResponse;
  readonly updateSite: EntityGenericResponse;
  readonly updateSupplier: EntityGenericResponse;
  readonly updateUser: EntityGenericResponse;
  readonly uploadOrderDocument: EntityGenericResponse;
  readonly whitelistEmail: Scalars['Boolean'];
}


export interface MutationActivateUserArgs {
  id: Scalars['ID'];
}


export interface MutationAddContainerArgs {
  input: AddContainerInput;
}


export interface MutationApplyForArbitrationArgs {
  input: ArbitrationInput;
}


export interface MutationCancelFailureArgs {
  input: CancelFailureInput;
}


export interface MutationCancelOrderArgs {
  input: CancelOrderInput;
}


export interface MutationCancelRequestArgs {
  input: CancelRequestInput;
}


export interface MutationCancelScheduleArgs {
  input: CancelScheduleInput;
}


export interface MutationChangeStateIntoReadyForInvoicingIfPossibleOrToDeliveredArgs {
  input: ChangeStateInput;
}


export interface MutationConfirmGroupOrderDeliveryArgs {
  id: Scalars['ID'];
}


export interface MutationCreateCustomerArgs {
  input: CustomerInput;
}


export interface MutationCreateCustomerInvoiceStatementArgs {
  input: InvoiceActionsInput;
}


export interface MutationCreateCustomerReportArgs {
  input: CustomerReportInput;
}


export interface MutationCreateEquipmentReportArgs {
  input: EquipmentReportInput;
}


export interface MutationCreateEquipmentReportInternalArgs {
  input: EquipmentReportInternalInput;
}


export interface MutationCreateFinancialReportArgs {
  input: FinancialReportInput;
}


export interface MutationCreateMstReportArgs {
  input: MstReportInput;
}


export interface MutationCreateOnceOffManualRequestsArgs {
  input: CreateOnceOffManualRequestsInput;
}


export interface MutationCreateOnceOffRequestsArgs {
  input: CreateOnceOffRequestsInput;
}


export interface MutationCreateScheduledManualRequestsArgs {
  input: CreateScheduledManualRequestsInput;
}


export interface MutationCreateScheduledRequestsArgs {
  input: CreateScheduledRequestsInput;
}


export interface MutationCreateSiteArgs {
  input: SiteInput;
}


export interface MutationCreateSupplierArgs {
  input: SupplierInput;
}


export interface MutationCreateSupplierInvoiceStatementArgs {
  input: InvoiceActionsInput;
}


export interface MutationCreditMemoArgs {
  input: CreditMemoInput;
}


export interface MutationDeleteCustomerArgs {
  id: Scalars['ID'];
}


export interface MutationDeleteSiteArgs {
  id: Scalars['ID'];
}


export interface MutationDeleteSupplierArgs {
  id: Scalars['ID'];
}


export interface MutationDeleteUserArgs {
  id: Scalars['ID'];
}


export interface MutationDownloadMasterExcelArgs {
  input: DownloadMasterExcelInput;
}


export interface MutationDownloadSalesPriceExcelArgs {
  input: DownloadSalesPriceExcelInput;
}


export interface MutationDumpThreadsArgs {
  dumpLocks: Scalars['Boolean'];
  onlyIssFrames: Scalars['Boolean'];
}


export interface MutationEditOrdersArgs {
  input: EditOrdersInput;
}


export interface MutationEditScheduledOrderArgs {
  input: EditScheduledOrderInput;
}


export interface MutationEndFailureNegotiationArgs {
  input: InputMaybe<EndFailureNegotiationInput>;
}


export interface MutationPrefilledFileForSupplierDataUploadArgs {
  input: PrefilledFileForSupplierDataUploadInput;
}


export interface MutationPreviewCustomerInvoiceSpecificationArgs {
  input: InvoiceActionsInput;
}


export interface MutationPreviewSupplierInvoiceSpecificationArgs {
  input: InvoiceActionsInput;
}


export interface MutationRecalculatePricesArgs {
  input: RecalculatePricesInput;
}


export interface MutationRegisterUserArgs {
  input: UpdateUserInput;
}


export interface MutationRegisterUser2Args {
  input: UpdateUserInput;
}


export interface MutationReportServiceFailureArgs {
  input: ReportFailureInput;
}


export interface MutationRespondToEditOrderProposalArgs {
  input: RespondToProposalInput;
}


export interface MutationRespondToEditScheduledOrderProposalArgs {
  input: RespondToProposalInput;
}


export interface MutationRespondToFailureProposalArgs {
  input: RespondToFailureProposalInput;
}


export interface MutationRespondToRequestProposalArgs {
  input: RespondToProposalInput;
}


export interface MutationRollbackSupplierInvoiceStatementArgs {
  input: SupplierInvoiceRollbackInput;
}


export interface MutationSetFeatureFlagArgs {
  name: Scalars['String'];
  value: Scalars['Boolean'];
}


export interface MutationSubmitEditOnceOffRequestProposalArgs {
  input: EditOnceOffRequestProposalInput;
}


export interface MutationSubmitEditScheduledRequestProposalArgs {
  input: EditScheduledRequestProposalInput;
}


export interface MutationSubmitFailureProposalArgs {
  input: InputMaybe<SubmitFailureProposalInput>;
}


export interface MutationSystemClockOffsetArgs {
  input: InputMaybe<Scalars['Date']>;
}


export interface MutationTriggerJobArgs {
  name: Scalars['String'];
}


export interface MutationUpdateContainerQuantityArgs {
  input: UpdateContainerQuantityInput;
}


export interface MutationUpdateCustomerArgs {
  input: UpdateCustomerInput;
}


export interface MutationUpdateSiteArgs {
  input: UpdateSiteInput;
}


export interface MutationUpdateSupplierArgs {
  input: UpdateSupplierInput;
}


export interface MutationUpdateUserArgs {
  input: UpdateUserInput;
}


export interface MutationUploadOrderDocumentArgs {
  input: UploadOrderDocumentInput;
}


export interface MutationWhitelistEmailArgs {
  email: Scalars['String'];
}

export interface Negotiation {
  readonly pendingProposals: ReadonlyArray<RequestProposal>;
  readonly permittedProposers: ReadonlyArray<OrganizationSummary>;
  readonly startedAt: Scalars['DateTime'];
  readonly startedBy: OrganizationSummary;
}

export enum NegotiationState {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export interface OnceOffQuotation extends Negotiation {
  readonly __typename?: 'OnceOffQuotation';
  readonly pendingProposals: ReadonlyArray<OnceOffRequestProposal>;
  readonly permittedProposers: ReadonlyArray<OrganizationSummary>;
  readonly requestedServiceDate: Scalars['Date'];
  readonly startedAt: Scalars['DateTime'];
  readonly startedBy: OrganizationSummary;
}

export interface OnceOffRequest extends Aggregate, Request {
  readonly __typename?: 'OnceOffRequest';
  readonly accessDetailsForSupplier: Maybe<AccessDetailsForSupplier>;
  readonly approvals: ReadonlyArray<SimpleNegotiation>;
  readonly businessId: Scalars['String'];
  readonly comment: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy: User;
  readonly customer: Organization;
  readonly customerReferenceNo: Maybe<Scalars['String']>;
  readonly destinationServiceLocation: Maybe<ServiceLocation>;
  readonly events: ReadonlyArray<EventRepresentation>;
  readonly id: Scalars['ID'];
  readonly order: Maybe<Order>;
  readonly productType: Maybe<Scalars['String']>;
  readonly purchaseRequestLines: ReadonlyArray<RequestLine>;
  readonly quotations: ReadonlyArray<OnceOffQuotation>;
  readonly salesRequestLines: ReadonlyArray<RequestLine>;
  readonly serviceDate: Scalars['Date'];
  readonly serviceLocation: ServiceLocation;
  readonly site: Site;
  readonly state: RequestState;
  readonly supplier: Organization;
}

export interface OnceOffRequestProposal extends RequestProposal {
  readonly __typename?: 'OnceOffRequestProposal';
  readonly approvingSide: OrganizationSummary;
  readonly proposalId: Scalars['ID'];
  readonly proposingSide: OrganizationSummary;
  readonly serviceDate: Maybe<Scalars['Date']>;
  readonly startedAt: Scalars['DateTime'];
}

export interface Order extends Aggregate {
  readonly __typename?: 'Order';
  readonly accessDetailsForSupplier: Maybe<AccessDetailsForSupplier>;
  readonly actualServiceDate: Maybe<Scalars['Date']>;
  readonly agent: Organization;
  readonly amendments: ReadonlyArray<Amendment>;
  readonly availableActions: AvailableOrderActions;
  readonly businessId: Scalars['String'];
  readonly comment: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy: User;
  readonly customer: Organization;
  readonly customerReferenceNo: Maybe<Scalars['String']>;
  readonly destinationServiceLocation: Maybe<ServiceLocation>;
  readonly events: ReadonlyArray<EventRepresentation>;
  readonly id: Scalars['ID'];
  readonly pendingAmendmentsExist: Maybe<Scalars['Boolean']>;
  readonly pendingFailuresExist: Maybe<Scalars['Boolean']>;
  readonly purchaseChargeLines: ReadonlyArray<ChargeLine>;
  readonly purchaseOrderLines: ReadonlyArray<OrderLine>;
  readonly referenceGroupOrders: Maybe<ReadonlyArray<ReferenceGroupOrder>>;
  readonly request: Maybe<Request>;
  readonly salesChargeLines: ReadonlyArray<ChargeLine>;
  readonly salesOrderLines: ReadonlyArray<OrderLine>;
  readonly scheduledOrder: Maybe<ScheduledOrder>;
  readonly serviceDate: Scalars['Date'];
  readonly serviceLocation: ServiceLocation;
  readonly site: Site;
  readonly state: OrderState;
  readonly supplier: Organization;
  readonly supplierReferenceNo: Maybe<Scalars['String']>;
}

export interface OrderFiltersInput {
  readonly businessId?: InputMaybe<Scalars['String']>;
  readonly businessIds?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly customerIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly from?: InputMaybe<Scalars['DateTime']>;
  readonly limit: Scalars['Int'];
  readonly offset: Scalars['Int'];
  readonly onlyInProgress?: InputMaybe<Scalars['Boolean']>;
  readonly packageCategories?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly requestId?: InputMaybe<Scalars['ID']>;
  readonly resourceCodes?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly siteIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly states?: InputMaybe<ReadonlyArray<OrderState>>;
  readonly supplierIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly to?: InputMaybe<Scalars['DateTime']>;
  readonly wasteTypeCodes?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface OrderForContainer {
  readonly __typename?: 'OrderForContainer';
  readonly groupOrderId: Scalars['ID'];
  readonly serviceDate: Scalars['Date'];
}

export interface OrderLine extends Aggregate {
  readonly __typename?: 'OrderLine';
  readonly actualQuantity: Maybe<Scalars['Int']>;
  readonly createdAt: Scalars['DateTime'];
  readonly events: ReadonlyArray<EventRepresentation>;
  readonly id: Scalars['ID'];
  readonly orderId: Scalars['ID'];
  readonly priceRule: Maybe<Scalars['ID']>;
  readonly priceRuleDescription: Maybe<Scalars['String']>;
  readonly productData: OrderProductData;
  readonly quantity: Maybe<Scalars['Int']>;
  readonly totalCost: Maybe<Scalars['BigDecimal']>;
  readonly treatmentFacility: Maybe<Organization>;
  readonly unitPriceCurrency: Maybe<Scalars['String']>;
  readonly unitPriceValue: Maybe<Scalars['BigDecimal']>;
  readonly unitType: Maybe<UnitType>;
}

export interface OrderLineProposal {
  readonly __typename?: 'OrderLineProposal';
  readonly id: Scalars['ID'];
  readonly quantity: Scalars['PositiveInt'];
}

export interface OrderProductData {
  readonly __typename?: 'OrderProductData';
  readonly packageCategory: Maybe<Scalars['String']>;
  readonly packageCategoryName: Maybe<Scalars['String']>;
  readonly packageDescription: Maybe<Scalars['String']>;
  readonly packageTypeId: Maybe<Scalars['ID']>;
  readonly productCategory: Scalars['String'];
  readonly productCategoryName: Scalars['String'];
  readonly productTypeId: Scalars['ID'];
  readonly resource: Maybe<Scalars['String']>;
  readonly resourceName: Maybe<Scalars['String']>;
  readonly wasteType: Maybe<Scalars['String']>;
  readonly wasteTypeName: Maybe<Scalars['String']>;
}

export interface OrderProposal {
  readonly __typename?: 'OrderProposal';
  readonly approvingSide: OrganizationSummary;
  readonly containerQuantity: Maybe<Scalars['PositiveInt']>;
  readonly newAdditionalOrderLines: Maybe<ReadonlyArray<AdditionalLine>>;
  readonly orderLineProposals: Maybe<ReadonlyArray<OrderLineProposal>>;
  readonly proposalId: Scalars['ID'];
  readonly proposingSide: OrganizationSummary;
  readonly removedLineIds: Maybe<ReadonlyArray<Scalars['ID']>>;
  readonly serviceDate: Maybe<Scalars['Date']>;
  readonly startedAt: Scalars['DateTime'];
}

export enum OrderState {
  Cancelled = 'CANCELLED',
  ClosedAll = 'CLOSED_ALL',
  ClosedPurchasePart = 'CLOSED_PURCHASE_PART',
  ClosedSalesPart = 'CLOSED_SALES_PART',
  Delivered = 'DELIVERED',
  Invoiced = 'INVOICED',
  Ordered = 'ORDERED',
  ReadyForInvoicing = 'READY_FOR_INVOICING'
}

export enum OrderType {
  Purchase = 'PURCHASE',
  Sales = 'SALES'
}

export interface OrdersForSupplierFiltersInput {
  readonly businessId?: InputMaybe<Scalars['String']>;
  readonly from?: InputMaybe<Scalars['DateTime']>;
  readonly state: OrdersForSupplierState;
  readonly supplierId: Scalars['ID'];
  readonly to?: InputMaybe<Scalars['DateTime']>;
}

export enum OrdersForSupplierState {
  Delivered = 'DELIVERED',
  ReadyForInvoicing = 'READY_FOR_INVOICING'
}

export interface OrdersResponse {
  readonly __typename?: 'OrdersResponse';
  readonly items: ReadonlyArray<Order>;
  readonly totalCount: Scalars['NonNegativeInt'];
}

export interface Organization {
  readonly __typename?: 'Organization';
  readonly active: Scalars['Boolean'];
  readonly businessId: Scalars['String'];
  readonly comment: Maybe<Scalars['String']>;
  readonly companyType: CompanyType;
  readonly contactPeople: Maybe<ReadonlyArray<ContactPerson>>;
  readonly coupaNumber: Maybe<Scalars['String']>;
  readonly geographicAddresses: GeographicAddress;
  readonly id: Scalars['ID'];
  readonly identifiers: Maybe<ReadonlyArray<Identifier>>;
  readonly name: Scalars['String'];
  readonly paymentAccountNumber: Scalars['String'];
  readonly vatIdNumber: Scalars['String'];
}

export interface OrganizationInProcessGql {
  readonly __typename?: 'OrganizationInProcessGql';
  readonly businessId: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
}

export interface OrganizationInput {
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly companyType: CompanyType;
  readonly contactPeople?: InputMaybe<ReadonlyArray<ContactPersonInput>>;
  readonly coupaNumber?: InputMaybe<Scalars['String']>;
  readonly geographicAddresses: GeographicAddressInput;
  readonly identifiers?: InputMaybe<ReadonlyArray<IdentifierInput>>;
  readonly name: Scalars['String'];
  readonly paymentAccountNumber: Scalars['String'];
  readonly vatIdNumber: Scalars['String'];
}

export interface OrganizationSummary {
  readonly __typename?: 'OrganizationSummary';
  readonly active: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly name: Scalars['String'];
}

export interface PreconditionsCheckIssue {
  readonly __typename?: 'PreconditionsCheckIssue';
  readonly code: Scalars['String'];
}

export interface PreconditionsCheckLine {
  readonly __typename?: 'PreconditionsCheckLine';
  readonly priceRuleDescription: Maybe<Scalars['String']>;
  readonly productData: OrderProductData;
  readonly totalCost: Maybe<Scalars['BigDecimal']>;
  readonly unitPriceCurrency: Maybe<Scalars['String']>;
  readonly unitType: Maybe<UnitType>;
}

export interface PreconditionsCheckResponse {
  readonly __typename?: 'PreconditionsCheckResponse';
  readonly allPreconditionsAreMet: Scalars['Boolean'];
  readonly preconditionsCheckIssues: ReadonlyArray<PreconditionsCheckIssue>;
  readonly purchasePreconditions: ReadonlyArray<PreconditionsCheckLine>;
  readonly salesPreconditions: ReadonlyArray<PreconditionsCheckLine>;
}

export interface PrefilledFileForSupplierDataUploadInput {
  readonly businessId?: InputMaybe<Scalars['String']>;
  readonly fileFormat: FileFormat;
  readonly from?: InputMaybe<Scalars['DateTime']>;
  readonly state: OrdersForSupplierState;
  readonly supplierId: Scalars['ID'];
  readonly to?: InputMaybe<Scalars['DateTime']>;
}

export interface PrepareDataForCreationFromScheduleProcessGql extends ProcessGql {
  readonly __typename?: 'PrepareDataForCreationFromScheduleProcessGql';
  readonly createdAt: Scalars['DateTime'];
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly finalStatus: ProcessStatusGql;
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly initiator: Maybe<User>;
  readonly lastProcessedEvent: Scalars['Int'];
  readonly numPreparedOrders: Scalars['Int'];
  readonly parentId: Maybe<Scalars['ID']>;
  readonly parentSpanId: Maybe<Scalars['String']>;
  readonly rootId: Scalars['ID'];
  readonly selfStatus: ProcessStatusGql;
  readonly spanId: Maybe<Scalars['String']>;
  readonly subProcesses: ReadonlyArray<Scalars['Object']>;
  readonly traceId: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export interface PrepareRentalsForUpdateProcessGql extends ProcessGql {
  readonly __typename?: 'PrepareRentalsForUpdateProcessGql';
  readonly createdAt: Scalars['DateTime'];
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly finalStatus: ProcessStatusGql;
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly initiator: Maybe<User>;
  readonly lastProcessedEvent: Scalars['Int'];
  readonly numPreparedRentals: Scalars['Int'];
  readonly parentId: Maybe<Scalars['ID']>;
  readonly parentSpanId: Maybe<Scalars['String']>;
  readonly rootId: Scalars['ID'];
  readonly selfStatus: ProcessStatusGql;
  readonly spanId: Maybe<Scalars['String']>;
  readonly subProcesses: ReadonlyArray<Scalars['Object']>;
  readonly traceId: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export interface PrepareWoEventsForListenersProcessGql extends ProcessGql {
  readonly __typename?: 'PrepareWoEventsForListenersProcessGql';
  readonly createdAt: Scalars['DateTime'];
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly finalStatus: ProcessStatusGql;
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly initiator: Maybe<User>;
  readonly lastProcessedEvent: Scalars['Int'];
  readonly parentId: Maybe<Scalars['ID']>;
  readonly parentSpanId: Maybe<Scalars['String']>;
  readonly rootId: Scalars['ID'];
  readonly selfStatus: ProcessStatusGql;
  readonly spanId: Maybe<Scalars['String']>;
  readonly subProcesses: ReadonlyArray<Scalars['Object']>;
  readonly traceId: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export interface PriceRuleFeatureItem {
  readonly __typename?: 'PriceRuleFeatureItem';
  readonly code: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly type: Scalars['String'];
}

export interface PriceVerificationInput {
  readonly agentCode: Scalars['String'];
  readonly customerCode: Scalars['String'];
  readonly packageCategory: Scalars['String'];
  readonly postalCode?: InputMaybe<Scalars['String']>;
  readonly productCategory: Scalars['String'];
  readonly quantity: Scalars['PositiveInt'];
  readonly resourceCode: Scalars['String'];
  readonly serviceDate: Scalars['Date'];
  readonly siteCode: Scalars['String'];
  readonly supplierCode: Scalars['String'];
  readonly wasteTypeCode: Scalars['String'];
}

export interface PriceVerificationResponse {
  readonly __typename?: 'PriceVerificationResponse';
  readonly purchasePrice: Maybe<PricingRule>;
  readonly salesPrice: Maybe<PricingRule>;
}

export interface PricingRule {
  readonly __typename?: 'PricingRule';
  readonly customerCode: Maybe<Scalars['String']>;
  readonly features: Maybe<ReadonlyArray<PriceRuleFeatureItem>>;
  readonly postalCode: Maybe<Scalars['String']>;
  readonly priceDescription: Scalars['String'];
  readonly priceRuleId: Scalars['ID'];
  readonly priceType: Scalars['String'];
  readonly priority: Maybe<Scalars['BigDecimal']>;
  readonly siteCode: Maybe<Scalars['String']>;
  readonly totalPrice: Maybe<Scalars['BigDecimal']>;
  readonly unitType: Maybe<UnitType>;
  readonly validFrom: Scalars['Date'];
  readonly validTo: Maybe<Scalars['Date']>;
}

export interface ProcessGql {
  readonly createdAt: Scalars['DateTime'];
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly finalStatus: ProcessStatusGql;
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly initiator: Maybe<User>;
  readonly lastProcessedEvent: Scalars['Int'];
  readonly parentId: Maybe<Scalars['ID']>;
  readonly parentSpanId: Maybe<Scalars['String']>;
  readonly rootId: Scalars['ID'];
  readonly selfStatus: ProcessStatusGql;
  readonly spanId: Maybe<Scalars['String']>;
  readonly subProcesses: ReadonlyArray<Scalars['Object']>;
  readonly traceId: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export interface ProcessHierarchyGqlInput {
  readonly id: Scalars['ID'];
  readonly knownState?: InputMaybe<ProcessKnownStateGql>;
  readonly timeoutMs?: InputMaybe<Scalars['Int']>;
}

export interface ProcessKnownStateGql {
  readonly id: Scalars['ID'];
  readonly lastProcessedEvent: Scalars['Int'];
  readonly subProcesses: ReadonlyArray<ProcessKnownStateGql>;
}

export enum ProcessStatusGql {
  Failed = 'FAILED',
  New = 'NEW',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED',
  WaitingForRetry = 'WAITING_FOR_RETRY'
}

export enum ProcessTypeGql {
  ChangeOrdersStateIntoDelivered = 'ChangeOrdersStateIntoDelivered',
  ChangeRequestsStateIntoExpired = 'ChangeRequestsStateIntoExpired',
  CleanCatalog = 'CleanCatalog',
  CreateGroupOrdersFromSchedule = 'CreateGroupOrdersFromSchedule',
  ListenToAllWoEvents = 'ListenToAllWoEvents',
  PrepareDataForCreationFromSchedule = 'PrepareDataForCreationFromSchedule',
  PrepareRentalsForUpdate = 'PrepareRentalsForUpdate',
  PrepareWoEventsForListeners = 'PrepareWoEventsForListeners',
  SendEmailProcess = 'SendEmailProcess',
  SimpleProcess = 'SimpleProcess',
  UpdatePricingPredictionProcess = 'UpdatePricingPredictionProcess',
  UpdateRentals = 'UpdateRentals',
  UploadMasterExcelProcess = 'UploadMasterExcelProcess',
  UploadSalesPricingExcelProcess = 'UploadSalesPricingExcelProcess'
}

export interface ProcessViewGql {
  readonly __typename?: 'ProcessViewGql';
  readonly id: Scalars['ID'];
  readonly status: ProcessStatusGql;
  readonly type: Scalars['String'];
}

export interface Processes {
  readonly __typename?: 'Processes';
  readonly items: ReadonlyArray<Scalars['Object']>;
  readonly totalCount: Scalars['NonNegativeInt'];
}

export enum ProposalResponseType {
  Accept = 'ACCEPT',
  Reject = 'REJECT'
}

export interface Query {
  readonly __typename?: 'Query';
  readonly additionalServiceCategories: ReadonlyArray<AdditionalServiceCategory>;
  readonly agents: Maybe<ReadonlyArray<Agent>>;
  readonly catalogWasteTypes: ReadonlyArray<WasteType>;
  readonly checkCreateOnceOffManualRequestsPreconditions: PreconditionsCheckResponse;
  readonly checkCreateOnceOffRequestsPreconditions: PreconditionsCheckResponse;
  readonly checkCreateScheduledManualRequestsPreconditions: PreconditionsCheckResponse;
  readonly checkCreateScheduledRequestsPreconditions: PreconditionsCheckResponse;
  readonly containerTypesOnServiceLocation: ReadonlyArray<ContainerTypeOnServiceLocation>;
  readonly containerWasteTypes: ReadonlyArray<WasteType>;
  readonly containers: ContainerTypesOnSiteResponse;
  readonly countries: ReadonlyArray<CountryGql>;
  readonly country: CountryGql;
  readonly customer: Customer;
  readonly customers: CustomersResponse;
  readonly datesForScheduleConfiguration: ReadonlyArray<Scalars['Date']>;
  readonly documents: DocumentsResponse;
  readonly documentsInOrder: ReadonlyArray<Document>;
  readonly downloadDocumentFile: FileUrlGenericResponse;
  readonly downloadEmailAttachment: FileUrlGenericResponse;
  readonly downloadTemplate: FileUrlGenericResponse;
  readonly emails: EmailsResponse;
  readonly employees: ReadonlyArray<Employee>;
  readonly failureTypes: ReadonlyArray<FailureType>;
  readonly failures: FailuresResponse;
  readonly featureFlags: ReadonlyArray<FeatureFlag>;
  readonly findProcesses: Processes;
  readonly groupOrder: GroupOrder;
  readonly mainCountryAgent: Agent;
  readonly myAuthDetails: UserAuthDetails;
  readonly order: Order;
  readonly orderHistory: ReadonlyArray<HistoryRecord>;
  readonly orderLine: Aggregate;
  readonly orders: OrdersResponse;
  readonly plannedOrders: ReadonlyArray<Order>;
  readonly pricingRules: Maybe<ReadonlyArray<Maybe<PricingRule>>>;
  readonly pricingVerification: PriceVerificationResponse;
  readonly process: Scalars['Object'];
  readonly processHierarchy: Scalars['Object'];
  readonly processTypes: ReadonlyArray<ProcessTypeGql>;
  readonly products: ReadonlyArray<CatalogProductType>;
  readonly request: Request;
  readonly requestLine: Aggregate;
  readonly requests: RequestsResponse;
  readonly resources: ResourceResponse;
  readonly schedule: Schedule;
  readonly scheduleHistory: ReadonlyArray<HistoryRecord>;
  readonly scheduledOrder: ScheduledOrder;
  readonly scheduledOrderLine: Aggregate;
  readonly schedules: SchedulesResponse;
  readonly serviceLocations: ServiceLocationsResponse;
  readonly serviceTypes: ReadonlyArray<ServiceTypeResponse>;
  readonly site: Site;
  readonly sites: SitesResponse;
  readonly supplier: Supplier;
  readonly suppliers: SuppliersResponse;
  readonly systemClock: Scalars['DateTime'];
  readonly userAuthDetails: UserAuthDetails;
  readonly usersAuthDetails: UsersAuthDetails;
  readonly wasteTypes: ReadonlyArray<WasteType>;
  readonly whitelistedEmails: ReadonlyArray<Scalars['String']>;
}


export interface QueryAgentsArgs {
  agentsFiltersInput: AgentsFiltersInput;
}


export interface QueryCheckCreateOnceOffManualRequestsPreconditionsArgs {
  input: CreateOnceOffManualRequestsInput;
}


export interface QueryCheckCreateOnceOffRequestsPreconditionsArgs {
  input: CreateOnceOffRequestsInput;
}


export interface QueryCheckCreateScheduledManualRequestsPreconditionsArgs {
  input: CreateScheduledManualRequestsInput;
}


export interface QueryCheckCreateScheduledRequestsPreconditionsArgs {
  input: CreateScheduledRequestsInput;
}


export interface QueryContainerTypesOnServiceLocationArgs {
  serviceLocationId: Scalars['ID'];
  showOnlyActive?: Scalars['Boolean'];
  wasteTypeCode: Scalars['String'];
}


export interface QueryContainerWasteTypesArgs {
  input: InputMaybe<ContainerWasteTypesFiltersInput>;
}


export interface QueryContainersArgs {
  input: ContainersFiltersInput;
}


export interface QueryCountryArgs {
  code: Locale;
}


export interface QueryCustomerArgs {
  id: Scalars['ID'];
}


export interface QueryCustomersArgs {
  customersFiltersInput: CustomersFiltersInput;
}


export interface QueryDatesForScheduleConfigurationArgs {
  input: ScheduleConfigurationInput;
}


export interface QueryDocumentsArgs {
  input: DocumentSearchCriteriaInput;
}


export interface QueryDocumentsInOrderArgs {
  input: DocumentInOrderSearchInput;
}


export interface QueryDownloadDocumentFileArgs {
  id: Scalars['ID'];
}


export interface QueryDownloadEmailAttachmentArgs {
  id: Scalars['ID'];
}


export interface QueryDownloadTemplateArgs {
  template: DocumentTemplate;
}


export interface QueryEmailsArgs {
  input: EmailSearchCriteriaInput;
}


export interface QueryEmployeesArgs {
  organizationId: Scalars['ID'];
}


export interface QueryFailuresArgs {
  failureFiltersInput: FailureFiltersInput;
}


export interface QueryFindProcessesArgs {
  filters: FindProcessesGqlInput;
}


export interface QueryGroupOrderArgs {
  id: Scalars['ID'];
}


export interface QueryMainCountryAgentArgs {
  agentInput: AgentInput;
}


export interface QueryOrderArgs {
  id: Scalars['ID'];
}


export interface QueryOrderHistoryArgs {
  id: Scalars['ID'];
  limit: InputMaybe<Scalars['PositiveInt']>;
}


export interface QueryOrderLineArgs {
  id: Scalars['ID'];
}


export interface QueryOrdersArgs {
  orderFiltersInput: OrderFiltersInput;
}


export interface QueryPlannedOrdersArgs {
  packageCategories: InputMaybe<ReadonlyArray<Scalars['String']>>;
  resourceCodes: InputMaybe<ReadonlyArray<Scalars['String']>>;
  serviceLocationId: InputMaybe<Scalars['ID']>;
  siteId: Scalars['ID'];
  wasteTypeCode: InputMaybe<Scalars['String']>;
}


export interface QueryPricingRulesArgs {
  pricingRuleIds: InputMaybe<ReadonlyArray<Scalars['ID']>>;
}


export interface QueryPricingVerificationArgs {
  input: PriceVerificationInput;
}


export interface QueryProcessArgs {
  id: Scalars['ID'];
}


export interface QueryProcessHierarchyArgs {
  input: ProcessHierarchyGqlInput;
}


export interface QueryProductsArgs {
  catalogSearchCriteriaInput: InputMaybe<CatalogSearchCriteriaInput>;
}


export interface QueryRequestArgs {
  id: Scalars['ID'];
}


export interface QueryRequestLineArgs {
  id: Scalars['ID'];
}


export interface QueryRequestsArgs {
  requestFiltersInput: RequestFiltersInput;
}


export interface QueryResourcesArgs {
  resourcesFilterInput: InputMaybe<ResourcesFilterInput>;
}


export interface QueryScheduleArgs {
  id: Scalars['ID'];
}


export interface QueryScheduleHistoryArgs {
  id: Scalars['ID'];
  limit?: InputMaybe<Scalars['PositiveInt']>;
}


export interface QueryScheduledOrderArgs {
  id: Scalars['ID'];
}


export interface QueryScheduledOrderLineArgs {
  id: Scalars['ID'];
}


export interface QuerySchedulesArgs {
  scheduleFiltersInput: InputMaybe<ScheduleFiltersInput>;
}


export interface QueryServiceLocationsArgs {
  serviceLocationsFiltersInput: ServiceLocationsFiltersInput;
}


export interface QuerySiteArgs {
  id: Scalars['ID'];
}


export interface QuerySitesArgs {
  sitesFiltersInput: SitesFiltersInput;
}


export interface QuerySupplierArgs {
  id: Scalars['ID'];
}


export interface QuerySuppliersArgs {
  suppliersFiltersInput: SuppliersFiltersInput;
}


export interface QueryUserAuthDetailsArgs {
  upn: Scalars['String'];
}


export interface QueryUsersAuthDetailsArgs {
  usersFiltersInput: UsersFiltersInput;
}


export interface QueryWasteTypesArgs {
  includeInactive?: Scalars['Boolean'];
}

export interface RecalculatePricesInput {
  readonly customerId?: InputMaybe<Scalars['ID']>;
  readonly fromServiceDate: Scalars['Date'];
  readonly pricingType: OrderType;
  readonly supplierId?: InputMaybe<Scalars['ID']>;
  readonly toServiceDate?: InputMaybe<Scalars['Date']>;
}

export interface ReconciledChargeLine {
  readonly amount: Scalars['BigDecimal'];
  readonly id: Scalars['ID'];
}

export interface ReconciledOrder {
  readonly actualServiceDate?: InputMaybe<Scalars['Date']>;
  readonly chargeLines?: InputMaybe<ReadonlyArray<ReconciledChargeLine>>;
  readonly orderId: Scalars['ID'];
  readonly orderLines?: InputMaybe<ReadonlyArray<ReconciledOrderLine>>;
}

export interface ReconciledOrderLine {
  readonly actualQuantity?: InputMaybe<Scalars['Int']>;
  readonly id: Scalars['ID'];
  readonly resourceCode?: InputMaybe<Scalars['String']>;
  readonly totalCost?: InputMaybe<Scalars['BigDecimal']>;
  readonly wasteTypeCode?: InputMaybe<Scalars['String']>;
}

export interface ReferenceGroupOrder {
  readonly __typename?: 'ReferenceGroupOrder';
  readonly businessId: Scalars['String'];
  readonly id: Scalars['String'];
  readonly referenceType: ReferenceType;
}

export enum ReferenceType {
  ChildMinus = 'CHILD_MINUS',
  ChildPlus = 'CHILD_PLUS',
  Initial = 'INITIAL',
  Minus = 'MINUS',
  Plus = 'PLUS'
}

export interface ReportFailureInput {
  readonly description?: InputMaybe<Scalars['String']>;
  readonly failureCode: FailureCode;
  readonly files?: InputMaybe<ReadonlyArray<Scalars['Upload']>>;
  readonly groupOrderId: Scalars['ID'];
  readonly serviceDate?: InputMaybe<Scalars['Date']>;
  readonly waitingTimeInMinutes?: InputMaybe<Scalars['PositiveInt']>;
}

export interface Request {
  readonly accessDetailsForSupplier: Maybe<AccessDetailsForSupplier>;
  readonly approvals: ReadonlyArray<SimpleNegotiation>;
  readonly businessId: Scalars['String'];
  readonly comment: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy: User;
  readonly customer: Organization;
  readonly customerReferenceNo: Maybe<Scalars['String']>;
  readonly events: ReadonlyArray<EventRepresentation>;
  readonly id: Scalars['ID'];
  readonly productType: Maybe<Scalars['String']>;
  readonly purchaseRequestLines: ReadonlyArray<RequestLine>;
  readonly quotations: ReadonlyArray<Negotiation>;
  readonly salesRequestLines: ReadonlyArray<RequestLine>;
  readonly serviceLocation: ServiceLocation;
  readonly site: Site;
  readonly state: RequestState;
  readonly supplier: Organization;
}

export interface RequestFiltersInput {
  readonly businessId?: InputMaybe<Scalars['String']>;
  readonly businessIds?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly customerIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly from?: InputMaybe<Scalars['DateTime']>;
  readonly limit: Scalars['PositiveInt'];
  readonly offset: Scalars['NonNegativeInt'];
  readonly packageCategories?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly resourceCodes?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly siteIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly states?: InputMaybe<ReadonlyArray<RequestState>>;
  readonly supplierIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly to?: InputMaybe<Scalars['DateTime']>;
  readonly wasteTypeCodes?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface RequestLine extends Aggregate {
  readonly __typename?: 'RequestLine';
  readonly createdAt: Scalars['DateTime'];
  readonly events: ReadonlyArray<EventRepresentation>;
  readonly id: Scalars['ID'];
  readonly priceRule: Maybe<Scalars['ID']>;
  readonly priceRuleDescription: Maybe<Scalars['String']>;
  readonly productData: RequestProductData;
  readonly quantity: Maybe<Scalars['NonNegativeInt']>;
  readonly totalCost: Maybe<Scalars['BigDecimal']>;
  readonly unitPriceCurrency: Maybe<Scalars['String']>;
  readonly unitPriceValue: Maybe<Scalars['BigDecimal']>;
  readonly unitType: Maybe<UnitType>;
}

export interface RequestLineParamsInput {
  readonly packageCategory: Scalars['String'];
  readonly packageDescription?: InputMaybe<Scalars['String']>;
  readonly quantity: Scalars['PositiveInt'];
  readonly resource: Scalars['String'];
  readonly supplierId: Scalars['ID'];
  readonly wasteType: Scalars['String'];
}

export interface RequestProductData {
  readonly __typename?: 'RequestProductData';
  readonly packageCategory: Maybe<Scalars['String']>;
  readonly packageCategoryName: Maybe<Scalars['String']>;
  readonly packageDescription: Maybe<Scalars['String']>;
  readonly packageTypeId: Maybe<Scalars['ID']>;
  readonly productCategory: Scalars['String'];
  readonly productCategoryName: Scalars['String'];
  readonly productTypeId: Scalars['ID'];
  readonly resource: Maybe<Scalars['String']>;
  readonly resourceName: Maybe<Scalars['String']>;
  readonly wasteType: Maybe<Scalars['String']>;
  readonly wasteTypeName: Maybe<Scalars['String']>;
}

export interface RequestProposal {
  readonly approvingSide: OrganizationSummary;
  readonly proposalId: Scalars['ID'];
  readonly proposingSide: OrganizationSummary;
  readonly startedAt: Scalars['DateTime'];
}

export enum RequestResponseType {
  Accept = 'ACCEPT',
  Reject = 'REJECT'
}

export enum RequestState {
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  Ordered = 'ORDERED',
  Quoted = 'QUOTED',
  Rejected = 'REJECTED',
  Rfq = 'RFQ',
  WaitingForApproval = 'WAITING_FOR_APPROVAL'
}

export interface RequestsResponse {
  readonly __typename?: 'RequestsResponse';
  readonly items: ReadonlyArray<Request>;
  readonly totalCount: Scalars['NonNegativeInt'];
}

export interface Resource {
  readonly __typename?: 'Resource';
  readonly active: Scalars['Boolean'];
  readonly code: Scalars['String'];
  readonly presentedName: Scalars['String'];
}

export interface ResourceResponse {
  readonly __typename?: 'ResourceResponse';
  readonly codes: ReadonlyArray<Scalars['String']>;
  readonly resources: ReadonlyArray<Resource>;
  readonly totalCount: Scalars['NonNegativeInt'];
}

export interface ResourcesFilterInput {
  readonly includeInactive: Scalars['Boolean'];
  readonly limit: Scalars['PositiveInt'];
  readonly offset: Scalars['NonNegativeInt'];
  readonly searchBy?: InputMaybe<Scalars['String']>;
}

export interface RespondToFailureProposalInput {
  readonly action: ProposalResponseType;
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly proposalId: Scalars['ID'];
}

export interface RespondToProposalInput {
  readonly action: ProposalResponseType;
  readonly proposalId: Scalars['ID'];
  readonly respondingSide: Side;
}

export enum ResponseType {
  Acceptance = 'ACCEPTANCE',
  Rejection = 'REJECTION'
}

export enum Role {
  CentralWasteTeamAdmin = 'CENTRAL_WASTE_TEAM_ADMIN',
  CentralWasteTeamFinance = 'CENTRAL_WASTE_TEAM_FINANCE',
  CentralWasteTeamOperations = 'CENTRAL_WASTE_TEAM_OPERATIONS',
  ContractController = 'CONTRACT_CONTROLLER',
  Customer = 'CUSTOMER',
  CustomerApprover = 'CUSTOMER_APPROVER',
  CustomerExternal = 'CUSTOMER_EXTERNAL',
  CustomerExternalApprover = 'CUSTOMER_EXTERNAL_APPROVER',
  SuperAdmin = 'SUPER_ADMIN',
  Supplier = 'SUPPLIER'
}

export interface Schedule extends Aggregate {
  readonly __typename?: 'Schedule';
  readonly businessId: Scalars['String'];
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy: User;
  readonly endDate: Scalars['Date'];
  readonly events: ReadonlyArray<EventRepresentation>;
  readonly id: Scalars['ID'];
  readonly nearestScheduledOrder: ScheduledOrder;
  readonly request: Maybe<Request>;
  readonly scheduledOrders: ReadonlyArray<ScheduledOrder>;
  readonly startDate: Scalars['Date'];
}

export interface ScheduleConfiguration {
  readonly __typename?: 'ScheduleConfiguration';
  readonly dailyEveryWeekday: Maybe<Scalars['Boolean']>;
  readonly endDate: Scalars['Date'];
  readonly frequency: Frequency;
  readonly monthlyRecurrenceConfig: Maybe<MonthlyRecurrenceConfig>;
  readonly monthlyRecurrenceDayNumber: Maybe<Scalars['PositiveInt']>;
  readonly recurrenceCounter: Maybe<Scalars['PositiveInt']>;
  readonly startDate: Scalars['Date'];
  readonly weeklyRecurrenceDayNames: Maybe<ReadonlyArray<DayOfWeek>>;
}

export interface ScheduleConfigurationInput {
  readonly dailyEveryWeekday?: InputMaybe<Scalars['Boolean']>;
  readonly endDate: Scalars['Date'];
  readonly frequency: Frequency;
  readonly monthlyRecurrenceConfig?: InputMaybe<MonthlyRecurrenceConfigInput>;
  readonly monthlyRecurrenceDayNumber?: InputMaybe<Scalars['PositiveInt']>;
  readonly recurrenceCounter?: InputMaybe<Scalars['PositiveInt']>;
  readonly startDate: Scalars['Date'];
  readonly weeklyRecurrenceDayNames?: InputMaybe<ReadonlyArray<DayOfWeek>>;
}

export interface ScheduleFiltersInput {
  readonly businessId?: InputMaybe<Scalars['String']>;
  readonly customerIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly from?: InputMaybe<Scalars['DateTime']>;
  readonly limit: Scalars['PositiveInt'];
  readonly offset: Scalars['NonNegativeInt'];
  readonly packageCategories?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly resourceCodes?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly siteIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly state?: InputMaybe<ActivityState>;
  readonly supplierIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly to?: InputMaybe<Scalars['DateTime']>;
  readonly wasteTypeCodes?: InputMaybe<ReadonlyArray<Scalars['String']>>;
}

export interface ScheduleForContainer {
  readonly __typename?: 'ScheduleForContainer';
  readonly scheduleConfiguration: ReadonlyArray<ScheduleConfiguration>;
  readonly scheduleId: Scalars['ID'];
}

export interface ScheduledAmendment {
  readonly __typename?: 'ScheduledAmendment';
  readonly pendingProposals: ReadonlyArray<ScheduledOrderProposal>;
  readonly permittedProposers: ReadonlyArray<OrganizationSummary>;
  readonly requestedContainerQuantity: Maybe<Scalars['PositiveInt']>;
  readonly requestedScheduleConfiguration: Maybe<ScheduleConfiguration>;
  readonly startedAt: Scalars['DateTime'];
  readonly startedBy: OrganizationSummary;
}

export interface ScheduledOrder extends Aggregate {
  readonly __typename?: 'ScheduledOrder';
  readonly accessDetailsForSupplier: Maybe<AccessDetailsForSupplier>;
  readonly amendments: ReadonlyArray<ScheduledAmendment>;
  readonly availableActions: AvailableScheduledOrderActions;
  readonly businessId: Scalars['String'];
  readonly comment: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly customer: Organization;
  readonly customerReferenceNo: Maybe<Scalars['String']>;
  readonly events: ReadonlyArray<EventRepresentation>;
  readonly id: Scalars['ID'];
  readonly orderLines: ReadonlyArray<ScheduledOrderLine>;
  readonly orderType: OrderType;
  readonly pendingAmendmentsExist: Maybe<Scalars['Boolean']>;
  readonly request: Maybe<Request>;
  readonly scheduleBusinessId: Scalars['String'];
  readonly scheduleConfiguration: ScheduleConfiguration;
  readonly scheduleEndDate: Scalars['Date'];
  readonly scheduleId: Scalars['ID'];
  readonly scheduleStartDate: Scalars['Date'];
  readonly serviceLocation: ServiceLocation;
  readonly site: Site;
  readonly state: ActivityState;
  readonly supplier: Organization;
}

export interface ScheduledOrderLine extends Aggregate {
  readonly __typename?: 'ScheduledOrderLine';
  readonly createdAt: Scalars['DateTime'];
  readonly events: ReadonlyArray<EventRepresentation>;
  readonly id: Scalars['ID'];
  readonly productData: ScheduledProductData;
  readonly quantity: Maybe<Scalars['NonNegativeInt']>;
  readonly unitPriceCurrency: Maybe<Scalars['String']>;
  readonly unitPriceValue: Maybe<Scalars['NonNegativeInt']>;
  readonly unitType: Maybe<Scalars['String']>;
}

export interface ScheduledOrderProposal {
  readonly __typename?: 'ScheduledOrderProposal';
  readonly approvingSide: OrganizationSummary;
  readonly containerQuantity: Maybe<Scalars['PositiveInt']>;
  readonly proposalId: Scalars['ID'];
  readonly proposingSide: OrganizationSummary;
  readonly scheduleConfiguration: Maybe<ScheduleConfiguration>;
  readonly startedAt: Scalars['DateTime'];
}

export interface ScheduledOrdersResponse {
  readonly __typename?: 'ScheduledOrdersResponse';
  readonly items: ReadonlyArray<ScheduledOrder>;
  readonly totalCount: Scalars['NonNegativeInt'];
}

export interface ScheduledProductData {
  readonly __typename?: 'ScheduledProductData';
  readonly packageCategory: Maybe<Scalars['String']>;
  readonly packageCategoryName: Maybe<Scalars['String']>;
  readonly packageDescription: Maybe<Scalars['String']>;
  readonly packageTypeId: Maybe<Scalars['ID']>;
  readonly productCategory: Scalars['String'];
  readonly productCategoryName: Scalars['String'];
  readonly productTypeId: Scalars['ID'];
  readonly resource: Maybe<Scalars['String']>;
  readonly resourceName: Maybe<Scalars['String']>;
  readonly wasteType: Maybe<Scalars['String']>;
  readonly wasteTypeName: Maybe<Scalars['String']>;
}

export interface ScheduledQuotation extends Negotiation {
  readonly __typename?: 'ScheduledQuotation';
  readonly pendingProposals: ReadonlyArray<ScheduledRequestProposal>;
  readonly permittedProposers: ReadonlyArray<OrganizationSummary>;
  readonly requestedScheduleConfiguration: ScheduleConfiguration;
  readonly startedAt: Scalars['DateTime'];
  readonly startedBy: OrganizationSummary;
}

export interface ScheduledRequest extends Aggregate, Request {
  readonly __typename?: 'ScheduledRequest';
  readonly accessDetailsForSupplier: Maybe<AccessDetailsForSupplier>;
  readonly approvals: ReadonlyArray<SimpleNegotiation>;
  readonly businessId: Scalars['String'];
  readonly comment: Maybe<Scalars['String']>;
  readonly createdAt: Scalars['DateTime'];
  readonly createdBy: User;
  readonly customer: Organization;
  readonly customerReferenceNo: Maybe<Scalars['String']>;
  readonly events: ReadonlyArray<EventRepresentation>;
  readonly id: Scalars['ID'];
  readonly productType: Maybe<Scalars['String']>;
  readonly purchaseRequestLines: ReadonlyArray<RequestLine>;
  readonly quotations: ReadonlyArray<ScheduledQuotation>;
  readonly salesRequestLines: ReadonlyArray<RequestLine>;
  readonly scheduleConfiguration: ScheduleConfiguration;
  readonly scheduledOrder: Maybe<ScheduledOrder>;
  readonly serviceLocation: ServiceLocation;
  readonly site: Site;
  readonly state: RequestState;
  readonly supplier: Organization;
}

export interface ScheduledRequestProposal extends RequestProposal {
  readonly __typename?: 'ScheduledRequestProposal';
  readonly approvingSide: OrganizationSummary;
  readonly proposalId: Scalars['ID'];
  readonly proposingSide: OrganizationSummary;
  readonly scheduleConfiguration: ScheduleConfiguration;
  readonly startedAt: Scalars['DateTime'];
}

export interface SchedulesResponse {
  readonly __typename?: 'SchedulesResponse';
  readonly items: ReadonlyArray<Schedule>;
  readonly totalCount: Scalars['NonNegativeInt'];
}

export interface SendEmailProcessGql extends ProcessGql {
  readonly __typename?: 'SendEmailProcessGql';
  readonly createdAt: Scalars['DateTime'];
  readonly email: EmailInProcessGql;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly finalStatus: ProcessStatusGql;
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly initiator: Maybe<User>;
  readonly lastProcessedEvent: Scalars['Int'];
  readonly parentId: Maybe<Scalars['ID']>;
  readonly parentSpanId: Maybe<Scalars['String']>;
  readonly rootId: Scalars['ID'];
  readonly selfStatus: ProcessStatusGql;
  readonly spanId: Maybe<Scalars['String']>;
  readonly subProcesses: ReadonlyArray<Scalars['Object']>;
  readonly traceId: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export interface ServiceLocation {
  readonly __typename?: 'ServiceLocation';
  readonly address: Maybe<Scalars['String']>;
  readonly businessId: Scalars['String'];
  readonly geographicAddress: GeographicAddress;
  readonly id: Scalars['ID'];
  readonly latitude: Maybe<Scalars['BigDecimal']>;
  readonly longitude: Maybe<Scalars['BigDecimal']>;
  readonly name: Maybe<Scalars['String']>;
  readonly what3words: Maybe<Scalars['String']>;
}

export interface ServiceLocationInput {
  readonly existingServiceLocationId?: InputMaybe<Scalars['ID']>;
  readonly geographicAddress: GeographicAddressInput;
  readonly latitude?: InputMaybe<Scalars['BigDecimal']>;
  readonly longitude?: InputMaybe<Scalars['BigDecimal']>;
  readonly name: Scalars['String'];
  readonly what3words?: InputMaybe<Scalars['String']>;
}

export interface ServiceLocationsFiltersInput {
  readonly limit: Scalars['PositiveInt'];
  readonly offset: Scalars['NonNegativeInt'];
  readonly siteId?: InputMaybe<Scalars['ID']>;
}

export interface ServiceLocationsResponse {
  readonly __typename?: 'ServiceLocationsResponse';
  readonly items: ReadonlyArray<ServiceLocation>;
  readonly totalCount: Scalars['NonNegativeInt'];
}

export interface ServiceTypeResponse {
  readonly __typename?: 'ServiceTypeResponse';
  readonly name: Scalars['String'];
  readonly presentedName: Scalars['String'];
}

export enum Side {
  Agent = 'AGENT',
  Customer = 'CUSTOMER',
  Supplier = 'SUPPLIER'
}

export interface SimpleNegotiation extends Negotiation {
  readonly __typename?: 'SimpleNegotiation';
  readonly pendingProposals: ReadonlyArray<SimpleRequestProposal>;
  readonly permittedProposers: ReadonlyArray<OrganizationSummary>;
  readonly startedAt: Scalars['DateTime'];
  readonly startedBy: OrganizationSummary;
}

export interface SimpleProcessGql extends ProcessGql {
  readonly __typename?: 'SimpleProcessGql';
  readonly createdAt: Scalars['DateTime'];
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly finalStatus: ProcessStatusGql;
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly initiator: Maybe<User>;
  readonly lastProcessedEvent: Scalars['Int'];
  readonly name: Scalars['String'];
  readonly parentId: Maybe<Scalars['ID']>;
  readonly parentSpanId: Maybe<Scalars['String']>;
  readonly rootId: Scalars['ID'];
  readonly selfStatus: ProcessStatusGql;
  readonly spanId: Maybe<Scalars['String']>;
  readonly subProcesses: ReadonlyArray<Scalars['Object']>;
  readonly traceId: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export interface SimpleRequestProposal extends RequestProposal {
  readonly __typename?: 'SimpleRequestProposal';
  readonly approvingSide: OrganizationSummary;
  readonly canRespond: Maybe<Scalars['Boolean']>;
  readonly proposalId: Scalars['ID'];
  readonly proposingSide: OrganizationSummary;
  readonly startedAt: Scalars['DateTime'];
}

export interface Site {
  readonly __typename?: 'Site';
  readonly accessDetails: Maybe<Scalars['String']>;
  readonly active: Scalars['Boolean'];
  readonly availableActions: AvailableSiteActions;
  readonly buildingType: BuildingType;
  readonly businessId: Scalars['String'];
  readonly closureDate: Maybe<Scalars['Date']>;
  readonly comment: Maybe<Scalars['String']>;
  readonly contactPeople: Maybe<ReadonlyArray<ContactPerson>>;
  readonly customer: Customer;
  readonly geographicAddress: GeographicAddress;
  readonly id: Scalars['ID'];
  readonly identifiers: Maybe<ReadonlyArray<Identifier>>;
  readonly name: Scalars['String'];
  readonly openDate: Scalars['Date'];
  readonly paymentAccountNumber: Scalars['String'];
  readonly serviceLocations: Maybe<ReadonlyArray<ServiceLocation>>;
}

export enum SiteContactPersonRole {
  Commerce = 'COMMERCE',
  Finance = 'FINANCE',
  Operation = 'OPERATION'
}

export interface SiteInput {
  readonly accessDetails: Scalars['String'];
  readonly buildingType: BuildingType;
  readonly closureDate?: InputMaybe<Scalars['Date']>;
  readonly comment?: InputMaybe<Scalars['String']>;
  readonly contactPeople?: InputMaybe<ReadonlyArray<ContactPersonInput>>;
  readonly createServiceLocation?: InputMaybe<Scalars['Boolean']>;
  readonly customerId: Scalars['ID'];
  readonly geographicAddress: GeographicAddressInput;
  readonly identifiers?: InputMaybe<ReadonlyArray<IdentifierInput>>;
  readonly name: Scalars['String'];
  readonly openDate: Scalars['Date'];
  readonly paymentAccountNumber: Scalars['String'];
  readonly serviceLocations?: InputMaybe<ReadonlyArray<ServiceLocationInput>>;
}

export enum SiteState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export interface SitesFiltersInput {
  readonly businessId?: InputMaybe<Scalars['String']>;
  readonly customerId?: InputMaybe<Scalars['ID']>;
  readonly customerIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly limit: Scalars['PositiveInt'];
  readonly offset: Scalars['NonNegativeInt'];
  readonly siteStates?: InputMaybe<ReadonlyArray<SiteState>>;
}

export interface SitesResponse {
  readonly __typename?: 'SitesResponse';
  readonly items: ReadonlyArray<Site>;
  readonly totalCount: Scalars['NonNegativeInt'];
}

export enum StatementDocumentType {
  CustomerCreditMemoStatement = 'CUSTOMER_CREDIT_MEMO_STATEMENT',
  CustomerInvoiceStatement = 'CUSTOMER_INVOICE_STATEMENT',
  SupplierCreditMemoStatement = 'SUPPLIER_CREDIT_MEMO_STATEMENT',
  SupplierInvoiceStatement = 'SUPPLIER_INVOICE_STATEMENT'
}

export interface SubmitFailureProposalInput {
  readonly negotiationId: Scalars['ID'];
  readonly serviceDate: Scalars['Date'];
}

export interface Supplier {
  readonly __typename?: 'Supplier';
  readonly availableActions: AvailableSupplierActions;
  readonly companySpecification: CompanySpecification;
  readonly id: Scalars['ID'];
  readonly organization: Organization;
  readonly supplierTypes: ReadonlyArray<SupplierType>;
}

export enum SupplierContactRole {
  Commerce = 'COMMERCE',
  Finance = 'FINANCE',
  Operation = 'OPERATION'
}

export interface SupplierInProcessGql {
  readonly __typename?: 'SupplierInProcessGql';
  readonly organization: OrganizationInProcessGql;
}

export interface SupplierInput {
  readonly companySpecification: CompanySpecification;
  readonly organization: OrganizationInput;
  readonly supplierTypes: ReadonlyArray<SupplierType>;
}

export interface SupplierInvoiceRollbackInput {
  readonly documentId: Scalars['ID'];
}

export enum SupplierType {
  ConfidentialMaterials = 'CONFIDENTIAL_MATERIALS',
  ConstructionWaste = 'CONSTRUCTION_WASTE',
  FoodWaste = 'FOOD_WASTE',
  GeneralWaste = 'GENERAL_WASTE',
  GlassBottles = 'GLASS_BOTTLES',
  HazardousWaste = 'HAZARDOUS_WASTE',
  NA = 'N_A'
}

export interface SuppliersFiltersInput {
  readonly businessId?: InputMaybe<Scalars['String']>;
  readonly country?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly isTreatmentFacility?: InputMaybe<Scalars['Boolean']>;
  readonly limit: Scalars['PositiveInt'];
  readonly offset: Scalars['NonNegativeInt'];
  readonly supplierIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
}

export interface SuppliersResponse {
  readonly __typename?: 'SuppliersResponse';
  readonly items: ReadonlyArray<Supplier>;
  readonly totalCount: Scalars['NonNegativeInt'];
}

export enum UnitType {
  Each = 'EACH',
  EachPerDay = 'EACH_PER_DAY',
  EachPerHour = 'EACH_PER_HOUR',
  EachPerMonth = 'EACH_PER_MONTH',
  Hour = 'HOUR',
  Kg = 'KG',
  Litre = 'LITRE',
  Minute = 'MINUTE',
  QuarterHour = 'QUARTER_HOUR',
  Tonne = 'TONNE'
}

export interface UpdateContainerQuantityInput {
  readonly isOnSite: Scalars['Boolean'];
  readonly owner: ContainerOwner;
  readonly ownerId?: InputMaybe<Scalars['ID']>;
  readonly productContainerTypeCode: Scalars['String'];
  readonly quantity: Scalars['NonNegativeInt'];
  readonly serviceLocationId: Scalars['ID'];
  readonly startDate: Scalars['Date'];
  readonly wasteTypeCode: Scalars['String'];
}

export interface UpdateContainerQuantityResult {
  readonly __typename?: 'UpdateContainerQuantityResult';
  readonly addedContainers: Maybe<Scalars['NonNegativeInt']>;
  readonly deliveryOrderBusinessIds: Maybe<ReadonlyArray<Maybe<Scalars['String']>>>;
  readonly removedContainers: Maybe<Scalars['NonNegativeInt']>;
}

export interface UpdateCustomerInput {
  readonly customerInput: CustomerInput;
  readonly id: Scalars['ID'];
}

export interface UpdatePricingPredictionProcessGql extends ProcessGql {
  readonly __typename?: 'UpdatePricingPredictionProcessGql';
  readonly agent: Maybe<AgentInProcessGql>;
  readonly createdAt: Scalars['DateTime'];
  readonly customer: Maybe<CustomerInProcessGql>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly finalStatus: ProcessStatusGql;
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly fromServiceDate: Maybe<Scalars['Date']>;
  readonly id: Scalars['ID'];
  readonly initiator: Maybe<User>;
  readonly lastProcessedEvent: Scalars['Int'];
  readonly numOrdersToUpdate: Maybe<Scalars['Int']>;
  readonly numRequestsToUpdate: Maybe<Scalars['Int']>;
  readonly numUpdatedOrders: Scalars['Int'];
  readonly numUpdatedRequests: Scalars['Int'];
  readonly parentId: Maybe<Scalars['ID']>;
  readonly parentSpanId: Maybe<Scalars['String']>;
  readonly pricingType: Maybe<OrderType>;
  readonly rootId: Scalars['ID'];
  readonly selfStatus: ProcessStatusGql;
  readonly spanId: Maybe<Scalars['String']>;
  readonly subProcesses: ReadonlyArray<Scalars['Object']>;
  readonly supplier: Maybe<SupplierInProcessGql>;
  readonly toServiceDate: Maybe<Scalars['Date']>;
  readonly traceId: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export interface UpdateRentalsProcessGql extends ProcessGql {
  readonly __typename?: 'UpdateRentalsProcessGql';
  readonly createdAt: Scalars['DateTime'];
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly finalStatus: ProcessStatusGql;
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly initiator: Maybe<User>;
  readonly lastProcessedEvent: Scalars['Int'];
  readonly numUpdatedRentals: Scalars['Int'];
  readonly parentId: Maybe<Scalars['ID']>;
  readonly parentSpanId: Maybe<Scalars['String']>;
  readonly rootId: Scalars['ID'];
  readonly selfStatus: ProcessStatusGql;
  readonly spanId: Maybe<Scalars['String']>;
  readonly subProcesses: ReadonlyArray<Scalars['Object']>;
  readonly traceId: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export interface UpdateSiteInput {
  readonly id: Scalars['ID'];
  readonly siteInput: SiteInput;
}

export interface UpdateSupplierInput {
  readonly id: Scalars['ID'];
  readonly input: SupplierInput;
}

export interface UpdateUserInput {
  readonly name?: InputMaybe<Scalars['String']>;
  readonly roles?: InputMaybe<ReadonlyArray<EmployeeRoleInput>>;
  readonly surname?: InputMaybe<Scalars['String']>;
  readonly upn: Scalars['String'];
}

export interface UploadMasterExcelProcessGql extends ProcessGql {
  readonly __typename?: 'UploadMasterExcelProcessGql';
  readonly createdAt: Scalars['DateTime'];
  readonly document: Maybe<DocumentInProcessGql>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly finalStatus: ProcessStatusGql;
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly initiator: Maybe<User>;
  readonly lastProcessedEvent: Scalars['Int'];
  readonly parentId: Maybe<Scalars['ID']>;
  readonly parentSpanId: Maybe<Scalars['String']>;
  readonly rootId: Scalars['ID'];
  readonly selfStatus: ProcessStatusGql;
  readonly spanId: Maybe<Scalars['String']>;
  readonly subProcesses: ReadonlyArray<Scalars['Object']>;
  readonly supplier: SupplierInProcessGql;
  readonly traceId: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export interface UploadOrderDocumentInput {
  readonly file?: InputMaybe<Scalars['Upload']>;
  readonly orderId: Scalars['ID'];
}

export interface UploadSalesPricingExcelProcessGql extends ProcessGql {
  readonly __typename?: 'UploadSalesPricingExcelProcessGql';
  readonly createdAt: Scalars['DateTime'];
  readonly customer: CustomerInProcessGql;
  readonly document: Maybe<DocumentInProcessGql>;
  readonly errorMessage: Maybe<Scalars['String']>;
  readonly finalStatus: ProcessStatusGql;
  readonly finishedAt: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['ID'];
  readonly initiator: Maybe<User>;
  readonly lastProcessedEvent: Scalars['Int'];
  readonly parentId: Maybe<Scalars['ID']>;
  readonly parentSpanId: Maybe<Scalars['String']>;
  readonly rootId: Scalars['ID'];
  readonly selfStatus: ProcessStatusGql;
  readonly spanId: Maybe<Scalars['String']>;
  readonly subProcesses: ReadonlyArray<Scalars['Object']>;
  readonly traceId: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
}

export interface User {
  readonly __typename?: 'User';
  readonly displayName: Scalars['String'];
  readonly id: Scalars['ID'];
}

export interface UserAuthDetails {
  readonly __typename?: 'UserAuthDetails';
  readonly active: Scalars['Boolean'];
  readonly displayName: Scalars['String'];
  readonly distinctCountries: ReadonlyArray<Locale>;
  readonly distinctPermissions: ReadonlyArray<WoPermission>;
  readonly distinctRoles: ReadonlyArray<Role>;
  readonly flatPositions: ReadonlyArray<UserAuthPosition>;
  readonly id: Scalars['ID'];
  readonly lastActivity: Maybe<Scalars['DateTime']>;
  readonly name: Maybe<Scalars['String']>;
  readonly positions: ReadonlyArray<UserAuthPosition>;
  readonly surname: Maybe<Scalars['String']>;
  readonly upn: Scalars['String'];
}

export interface UserAuthPosition {
  readonly __typename?: 'UserAuthPosition';
  readonly employer: Scalars['ID'];
  readonly employerCountry: Locale;
  readonly role: Role;
  readonly type: Scalars['String'];
}

export interface UserContext {
  readonly __typename?: 'UserContext';
  readonly country: Maybe<Locale>;
  readonly customer: Maybe<Scalars['ID']>;
  readonly role: Maybe<Role>;
  readonly serviceLocation: Maybe<Scalars['ID']>;
  readonly site: Maybe<Scalars['ID']>;
  readonly supplier: Maybe<Scalars['ID']>;
}

export interface UserInProcessGql {
  readonly __typename?: 'UserInProcessGql';
  readonly displayName: Scalars['String'];
  readonly id: Scalars['ID'];
  readonly upn: Scalars['String'];
}

export interface UsersAuthDetails {
  readonly __typename?: 'UsersAuthDetails';
  readonly items: ReadonlyArray<UserAuthDetails>;
  readonly totalCount: Scalars['NonNegativeInt'];
}

export interface UsersFiltersInput {
  readonly active?: InputMaybe<Scalars['Boolean']>;
  readonly limit: Scalars['PositiveInt'];
  readonly offset: Scalars['NonNegativeInt'];
  readonly organizationIds?: InputMaybe<ReadonlyArray<Scalars['ID']>>;
  readonly roles?: InputMaybe<ReadonlyArray<Role>>;
  readonly searchBy?: InputMaybe<Scalars['String']>;
}

export interface WasteType {
  readonly __typename?: 'WasteType';
  readonly active: Scalars['Boolean'];
  readonly confidential: Scalars['Boolean'];
  readonly createdAt: Scalars['DateTime'];
  readonly eeeCode: Maybe<Scalars['String']>;
  readonly ewcCode: Scalars['String'];
  readonly ewcName: Scalars['String'];
  readonly hazardous: Scalars['Boolean'];
  readonly id: Scalars['ID'];
  readonly presentedName: Scalars['String'];
  readonly wasteTypeCode: Scalars['String'];
}

export enum WoPermission {
  AdminImpersonate = 'ADMIN__IMPERSONATE',
  AdminProcessRead = 'ADMIN__PROCESS__READ',
  AdminPurchasePricingDownload = 'ADMIN__PURCHASE_PRICING__DOWNLOAD',
  AdminPurchasePricingUpload = 'ADMIN__PURCHASE_PRICING__UPLOAD',
  AdminSalesPricingDownload = 'ADMIN__SALES_PRICING__DOWNLOAD',
  AdminSalesPricingUpload = 'ADMIN__SALES_PRICING__UPLOAD',
  AdminSuperAdmin = 'ADMIN__SUPER_ADMIN',
  AdminUserDeleteEmployee = 'ADMIN__USER__DELETE_EMPLOYEE',
  AdminUserRead = 'ADMIN__USER__READ',
  AdminUserUpdateEmployee = 'ADMIN__USER__UPDATE_EMPLOYEE',
  AgentList = 'AGENT__LIST',
  AgentRead = 'AGENT__READ',
  CatalogAdditionalServiceTypeList = 'CATALOG__ADDITIONAL_SERVICE_TYPE__LIST',
  CatalogProductsList = 'CATALOG__PRODUCTS__LIST',
  CatalogResourceTypeList = 'CATALOG__RESOURCE_TYPE__LIST',
  CatalogServiceTypeList = 'CATALOG__SERVICE_TYPE__LIST',
  CatalogWasteTypesList = 'CATALOG__WASTE_TYPES__LIST',
  CountriesList = 'COUNTRIES__LIST',
  CreditMemoCreate = 'CREDIT_MEMO__CREATE',
  CustomerCreate = 'CUSTOMER__CREATE',
  CustomerDelete = 'CUSTOMER__DELETE',
  CustomerEdit = 'CUSTOMER__EDIT',
  CustomerList = 'CUSTOMER__LIST',
  CustomerRead = 'CUSTOMER__READ',
  CustomerSiteBulkCreate = 'CUSTOMER__SITE__BULK_CREATE',
  CustomerSiteCreate = 'CUSTOMER__SITE__CREATE',
  CustomerSiteDelete = 'CUSTOMER__SITE__DELETE',
  CustomerSiteEdit = 'CUSTOMER__SITE__EDIT',
  CustomerSiteEquipmentBulkUpload = 'CUSTOMER__SITE__EQUIPMENT__BULK_UPLOAD',
  CustomerSiteEquipmentCrud = 'CUSTOMER__SITE__EQUIPMENT__CRUD',
  CustomerSiteEquipmentList = 'CUSTOMER__SITE__EQUIPMENT__LIST',
  CustomerSiteList = 'CUSTOMER__SITE__LIST',
  CustomerSiteRead = 'CUSTOMER__SITE__READ',
  CustomerSiteWasteTypeList = 'CUSTOMER__SITE__WASTE_TYPE__LIST',
  DocumentDownload = 'DOCUMENT__DOWNLOAD',
  DocumentDownloadAllTypes = 'DOCUMENT__DOWNLOAD__ALL_TYPES',
  DocumentDownloadCustomerCreditMemoStatementType = 'DOCUMENT__DOWNLOAD__CUSTOMER_CREDIT_MEMO_STATEMENT_TYPE',
  DocumentDownloadCustomerInvoiceStatementType = 'DOCUMENT__DOWNLOAD__CUSTOMER_INVOICE_STATEMENT_TYPE',
  DocumentDownloadOrderDocumentType = 'DOCUMENT__DOWNLOAD__ORDER_DOCUMENT_TYPE',
  DocumentDownloadOrderServiceFailureFileType = 'DOCUMENT__DOWNLOAD__ORDER_SERVICE_FAILURE_FILE_TYPE',
  DocumentDownloadSalesPricingFileType = 'DOCUMENT__DOWNLOAD__SALES_PRICING_FILE_TYPE',
  DocumentDownloadSupplierCreditMemoStatementType = 'DOCUMENT__DOWNLOAD__SUPPLIER_CREDIT_MEMO_STATEMENT_TYPE',
  DocumentDownloadSupplierDataUploadType = 'DOCUMENT__DOWNLOAD__SUPPLIER_DATA_UPLOAD_TYPE',
  DocumentDownloadSupplierDefaultTreatmentMethodsType = 'DOCUMENT__DOWNLOAD__SUPPLIER_DEFAULT_TREATMENT_METHODS_TYPE',
  DocumentDownloadSupplierInvoiceStatementType = 'DOCUMENT__DOWNLOAD__SUPPLIER_INVOICE_STATEMENT_TYPE',
  DocumentDownloadSupplierMasterFileType = 'DOCUMENT__DOWNLOAD__SUPPLIER_MASTER_FILE_TYPE',
  DocumentList = 'DOCUMENT__LIST',
  DocumentTemplateDownload = 'DOCUMENT__TEMPLATE__DOWNLOAD',
  GroupOrderDocumentsList = 'GROUP_ORDER__DOCUMENTS__LIST',
  GroupOrderDocumentsRemove = 'GROUP_ORDER__DOCUMENTS__REMOVE',
  GroupOrderDocumentsUpload = 'GROUP_ORDER__DOCUMENTS__UPLOAD',
  GroupOrderList = 'GROUP_ORDER__LIST',
  GroupOrderRead = 'GROUP_ORDER__READ',
  GroupOrderReadComment = 'GROUP_ORDER__READ__COMMENT',
  GroupOrderReadHistory = 'GROUP_ORDER__READ__HISTORY',
  InvoicingCustomerCreate = 'INVOICING__CUSTOMER__CREATE',
  InvoicingCustomerPreview = 'INVOICING__CUSTOMER__PREVIEW',
  InvoicingSupplierCreate = 'INVOICING__SUPPLIER__CREATE',
  InvoicingSupplierPreview = 'INVOICING__SUPPLIER__PREVIEW',
  InvoicingSupplierRollback = 'INVOICING__SUPPLIER__ROLLBACK',
  OrderCancel = 'ORDER__CANCEL',
  OrderCancelWithoutSla = 'ORDER__CANCEL__WITHOUT_SLA',
  OrderConfirmDelivery = 'ORDER__CONFIRM_DELIVERY',
  OrderCreateApprove = 'ORDER__CREATE__APPROVE',
  OrderCreateDeliveryOrRemoval = 'ORDER__CREATE__DELIVERY_OR_REMOVAL',
  OrderCreateIgnoreSla = 'ORDER__CREATE__IGNORE_SLA',
  OrderCreateOnceOff = 'ORDER__CREATE__ONCE_OFF',
  OrderCreateOutsideCatalog = 'ORDER__CREATE__OUTSIDE_CATALOG',
  OrderCreateScheduled = 'ORDER__CREATE__SCHEDULED',
  OrderCreateWithoutApprove = 'ORDER__CREATE__WITHOUT_APPROVE',
  OrderCreateWithoutConfirmationFlow = 'ORDER__CREATE__WITHOUT_CONFIRMATION_FLOW',
  OrderCreateWithoutPricing = 'ORDER__CREATE__WITHOUT_PRICING',
  OrderCreateWithAddedServices = 'ORDER__CREATE__WITH_ADDED_SERVICES',
  OrderEdit = 'ORDER__EDIT',
  OrderEditAfterDelivery = 'ORDER__EDIT__AFTER_DELIVERY',
  OrderEditApprove = 'ORDER__EDIT__APPROVE',
  OrderEditReadAmendments = 'ORDER__EDIT__READ_AMENDMENTS',
  OrderEditRespondToProposal = 'ORDER__EDIT__RESPOND_TO_PROPOSAL',
  OrderEditWithoutApprove = 'ORDER__EDIT__WITHOUT_APPROVE',
  OrderEditWithoutNegotiation = 'ORDER__EDIT__WITHOUT_NEGOTIATION',
  OrderPlannedList = 'ORDER__PLANNED__LIST',
  PurchaseOrderRead = 'PURCHASE_ORDER__READ',
  PurchaseOrderReadFinancial = 'PURCHASE_ORDER__READ__FINANCIAL',
  PurchaseOrderReadFinancialRule = 'PURCHASE_ORDER__READ__FINANCIAL__RULE',
  ReportCustomer = 'REPORT__CUSTOMER',
  ReportCustomersSitesLocations = 'REPORT__CUSTOMERS_SITES_LOCATIONS',
  ReportEquipment = 'REPORT__EQUIPMENT',
  ReportEquipmentInternal = 'REPORT__EQUIPMENT__INTERNAL',
  ReportFinancial = 'REPORT__FINANCIAL',
  ReportMst = 'REPORT__MST',
  RequestForApprovalList = 'REQUEST_FOR_APPROVAL__LIST',
  RequestForApprovalRead = 'REQUEST_FOR_APPROVAL__READ',
  RequestCancel = 'REQUEST__CANCEL',
  RequestEditWithoutApprove = 'REQUEST__EDIT__WITHOUT_APPROVE',
  RequestList = 'REQUEST__LIST',
  RequestQuotationsList = 'REQUEST__QUOTATIONS_LIST',
  RequestRead = 'REQUEST__READ',
  RequestReadComment = 'REQUEST__READ__COMMENT',
  RequestRespond = 'REQUEST__RESPOND',
  RequestSubmitProposal = 'REQUEST__SUBMIT_PROPOSAL',
  SalesOrderRead = 'SALES_ORDER__READ',
  SalesOrderReadFinancial = 'SALES_ORDER__READ__FINANCIAL',
  SalesOrderReadFinancialRule = 'SALES_ORDER__READ__FINANCIAL__RULE',
  ScheduleCancel = 'SCHEDULE__CANCEL',
  ScheduleEdit = 'SCHEDULE__EDIT',
  ScheduleEditApprove = 'SCHEDULE__EDIT__APPROVE',
  ScheduleEditReadAmendments = 'SCHEDULE__EDIT__READ_AMENDMENTS',
  ScheduleEditRespondToProposal = 'SCHEDULE__EDIT__RESPOND_TO_PROPOSAL',
  ScheduleEditWithoutApprove = 'SCHEDULE__EDIT__WITHOUT_APPROVE',
  ScheduleList = 'SCHEDULE__LIST',
  ScheduleRead = 'SCHEDULE__READ',
  ScheduleReadHistory = 'SCHEDULE__READ__HISTORY',
  ServiceFailureTypeList = 'SERVICE_FAILURE_TYPE__LIST',
  ServiceFailureCancel = 'SERVICE_FAILURE__CANCEL',
  ServiceFailureEscalationSolution = 'SERVICE_FAILURE__ESCALATION_SOLUTION',
  ServiceFailureNegotiationList = 'SERVICE_FAILURE__NEGOTIATION__LIST',
  ServiceFailureReport = 'SERVICE_FAILURE__REPORT',
  ServiceFailureReportCustomerResponsibility = 'SERVICE_FAILURE__REPORT__CUSTOMER_RESPONSIBILITY',
  ServiceFailureReportCustomerResponsibilityApprove = 'SERVICE_FAILURE__REPORT__CUSTOMER_RESPONSIBILITY__APPROVE',
  ServiceFailureReportSupplierResponsibility = 'SERVICE_FAILURE__REPORT__SUPPLIER_RESPONSIBILITY',
  ServiceFailureReportSupplierResponsibilityAdmission = 'SERVICE_FAILURE__REPORT__SUPPLIER_RESPONSIBILITY_ADMISSION',
  ServiceFailureReportSupplierResponsibilityAdmissionApprove = 'SERVICE_FAILURE__REPORT__SUPPLIER_RESPONSIBILITY_ADMISSION__APPROVE',
  ServiceFailureReportSupplierResponsibilityApprove = 'SERVICE_FAILURE__REPORT__SUPPLIER_RESPONSIBILITY__APPROVE',
  ServiceFailureReportWaitingTime = 'SERVICE_FAILURE__REPORT__WAITING_TIME',
  ServiceFailureReportWaitingTimeApprove = 'SERVICE_FAILURE__REPORT__WAITING_TIME__APPROVE',
  SupplierApiConfirmDelivery = 'SUPPLIER_API__CONFIRM_DELIVERY',
  SupplierApiGetEvents = 'SUPPLIER_API__GET_EVENTS',
  SupplierApiListOrders = 'SUPPLIER_API__LIST_ORDERS',
  SupplierApiReportServiceFailure = 'SUPPLIER_API__REPORT_SERVICE_FAILURE',
  SupplierApiUpdateOrder = 'SUPPLIER_API__UPDATE_ORDER',
  SupplierApiUploadWeights = 'SUPPLIER_API__UPLOAD_WEIGHTS',
  SupplierOrderList = 'SUPPLIER_ORDER__LIST',
  SupplierOrderWeightDownloadPrefilledFile = 'SUPPLIER_ORDER__WEIGHT__DOWNLOAD_PREFILLED_FILE',
  SupplierOrderWeightUploadedFileRollback = 'SUPPLIER_ORDER__WEIGHT__UPLOADED_FILE_ROLLBACK',
  SupplierOrderWeightUploadFile = 'SUPPLIER_ORDER__WEIGHT__UPLOAD_FILE',
  SupplierCreate = 'SUPPLIER__CREATE',
  SupplierDelete = 'SUPPLIER__DELETE',
  SupplierEdit = 'SUPPLIER__EDIT_',
  SupplierList = 'SUPPLIER__LIST',
  SupplierRead = 'SUPPLIER__READ',
  WasteTypeList = 'WASTE_TYPE__LIST'
}

export type SitesQueryVariables = Exact<{
  sitesFiltersInput: SitesFiltersInput;
}>;


export type SitesQuery = { readonly __typename?: 'Query', readonly sites: { readonly __typename?: 'SitesResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Site', readonly id: string, readonly name: string, readonly accessDetails: string | null | undefined, readonly customer: { readonly __typename?: 'Customer', readonly id: string } }> } };

export type SitesWithCustomersQueryVariables = Exact<{
  sitesFiltersInput: SitesFiltersInput;
}>;


export type SitesWithCustomersQuery = { readonly __typename?: 'Query', readonly sites: { readonly __typename?: 'SitesResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Site', readonly id: string, readonly name: string, readonly customer: { readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly name: string } } }> } };

export type ContainerTypesOnServiceLocationQueryVariables = Exact<{
  serviceLocationId: Scalars['ID'];
  wasteTypeCode: Scalars['String'];
}>;


export type ContainerTypesOnServiceLocationQuery = { readonly __typename?: 'Query', readonly containerTypesOnServiceLocation: ReadonlyArray<{ readonly __typename?: 'ContainerTypeOnServiceLocation', readonly productContainerCode: string, readonly quantity: number, readonly quantityInDelivery: number }> };

export type ContainersQueryVariables = Exact<{
  input: ContainersFiltersInput;
}>;


export type ContainersQuery = { readonly __typename?: 'Query', readonly containers: { readonly __typename?: 'ContainerTypesOnSiteResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'ContainerTypeOnSite', readonly quantity: number, readonly startDate: string | null | undefined, readonly endDate: string | null | undefined, readonly isOnSite: boolean, readonly productContainerTypeCode: string, readonly productContainerTypeName: string, readonly wasteTypeCode: string, readonly wasteTypeEwcCode: string, readonly wasteTypePresentedName: string, readonly ownerId: string, readonly ownerName: string, readonly ownerBusinessId: string, readonly serviceLocationId: string, readonly serviceLocationName: string, readonly siteId: string, readonly customerId: string, readonly supplierName: string | null | undefined, readonly serviceLocationCode: string, readonly availableActions: { readonly __typename?: 'AvailableContainerActions', readonly edit: boolean, readonly delete: boolean, readonly createNewOrder: boolean }, readonly activeSchedules: ReadonlyArray<{ readonly __typename?: 'ScheduleForContainer', readonly scheduleId: string, readonly scheduleConfiguration: ReadonlyArray<{ readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined }> }> | null | undefined, readonly nearestOneOffOrder: { readonly __typename?: 'OrderForContainer', readonly groupOrderId: string, readonly serviceDate: string } | null | undefined }> } };

export type ContainerOwnersQueryVariables = Exact<{
  siteId: Scalars['ID'];
  serviceLocationId: Scalars['ID'];
  wasteTypeCode: Scalars['String'];
  productContainerCode: Scalars['String'];
}>;


export type ContainerOwnersQuery = { readonly __typename?: 'Query', readonly containers: { readonly __typename?: 'ContainerTypesOnSiteResponse', readonly items: ReadonlyArray<{ readonly __typename?: 'ContainerTypeOnSite', readonly ownerId: string }> } };

export type UpdateContainerQuantityMutationVariables = Exact<{
  input: UpdateContainerQuantityInput;
}>;


export type UpdateContainerQuantityMutation = { readonly __typename?: 'Mutation', readonly updateContainerQuantity: { readonly __typename?: 'UpdateContainerQuantityResult', readonly addedContainers: number | null | undefined, readonly removedContainers: number | null | undefined, readonly deliveryOrderBusinessIds: ReadonlyArray<string | null | undefined> | null | undefined } };

export type AddContainerMutationVariables = Exact<{
  input: AddContainerInput;
}>;


export type AddContainerMutation = { readonly __typename?: 'Mutation', readonly addContainer: boolean };

export type ServiceLocationsQueryVariables = Exact<{
  serviceLocationsFiltersInput: ServiceLocationsFiltersInput;
}>;


export type ServiceLocationsQuery = { readonly __typename?: 'Query', readonly serviceLocations: { readonly __typename?: 'ServiceLocationsResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'ServiceLocation', readonly id: string, readonly name: string | null | undefined }> } };

export type WeakWasteTypeFragment = { readonly __typename?: 'WasteType', readonly wasteTypeCode: string, readonly presentedName: string, readonly ewcCode: string };

export type ContainerWasteTypesQueryVariables = Exact<{
  input: InputMaybe<ContainerWasteTypesFiltersInput>;
}>;


export type ContainerWasteTypesQuery = { readonly __typename?: 'Query', readonly containerWasteTypes: ReadonlyArray<{ readonly __typename?: 'WasteType', readonly wasteTypeCode: string, readonly presentedName: string, readonly ewcCode: string }> };

export type AllWasteTypesQueryVariables = Exact<{
  includeInactive: Scalars['Boolean'];
}>;


export type AllWasteTypesQuery = { readonly __typename?: 'Query', readonly wasteTypes: ReadonlyArray<{ readonly __typename?: 'WasteType', readonly wasteTypeCode: string, readonly presentedName: string, readonly ewcCode: string }> };

export type CatalogWasteTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type CatalogWasteTypesQuery = { readonly __typename?: 'Query', readonly catalogWasteTypes: ReadonlyArray<{ readonly __typename?: 'WasteType', readonly wasteTypeCode: string, readonly presentedName: string, readonly ewcCode: string }> };

export type SitesListQueryVariables = Exact<{
  sitesFiltersInput: SitesFiltersInput;
}>;


export type SitesListQuery = { readonly __typename?: 'Query', readonly sites: { readonly __typename?: 'SitesResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Site', readonly id: string, readonly businessId: string, readonly name: string, readonly active: boolean, readonly customer: { readonly __typename?: 'Customer', readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } }, readonly availableActions: { readonly __typename?: 'AvailableSiteActions', readonly delete: boolean }, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }> } };

export type DatesForScheduleConfigurationQueryVariables = Exact<{
  input: ScheduleConfigurationInput;
}>;


export type DatesForScheduleConfigurationQuery = { readonly __typename?: 'Query', readonly datesForScheduleConfiguration: ReadonlyArray<string> };

export type PlannedOrdersQueryVariables = Exact<{
  siteId: Scalars['ID'];
  serviceLocationId: InputMaybe<Scalars['ID']>;
  wasteTypeCode: InputMaybe<Scalars['String']>;
  packageCategories: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
  resourceCodes: InputMaybe<ReadonlyArray<Scalars['String']> | Scalars['String']>;
}>;


export type PlannedOrdersQuery = { readonly __typename?: 'Query', readonly plannedOrders: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: string, readonly businessId: string, readonly state: OrderState, readonly serviceDate: string, readonly scheduledOrder: { readonly __typename?: 'ScheduledOrder', readonly id: string } | null | undefined, readonly purchaseOrderLines: ReadonlyArray<{ readonly __typename?: 'OrderLine', readonly quantity: number | null | undefined, readonly productData: { readonly __typename?: 'OrderProductData', readonly packageCategory: string | null | undefined, readonly packageDescription: string | null | undefined, readonly productCategory: string, readonly wasteType: string | null | undefined, readonly wasteTypeName: string | null | undefined, readonly resource: string | null | undefined } }> }> };

export type CancelRequestMutationVariables = Exact<{
  input: CancelRequestInput;
}>;


export type CancelRequestMutation = { readonly __typename?: 'Mutation', readonly cancelRequest: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type CancelOrderMutationVariables = Exact<{
  input: CancelOrderInput;
}>;


export type CancelOrderMutation = { readonly __typename?: 'Mutation', readonly cancelOrder: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type CancelScheduleMutationVariables = Exact<{
  input: CancelScheduleInput;
}>;


export type CancelScheduleMutation = { readonly __typename?: 'Mutation', readonly cancelSchedule: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type ReportServiceFailureMutationVariables = Exact<{
  input: ReportFailureInput;
}>;


export type ReportServiceFailureMutation = { readonly __typename?: 'Mutation', readonly reportServiceFailure: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type UploadOrderDocumentMutationVariables = Exact<{
  input: UploadOrderDocumentInput;
}>;


export type UploadOrderDocumentMutation = { readonly __typename?: 'Mutation', readonly uploadOrderDocument: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type EditOrdersMutationVariables = Exact<{
  input: EditOrdersInput;
}>;


export type EditOrdersMutation = { readonly __typename?: 'Mutation', readonly editOrders: { readonly __typename?: 'EntitiesGenericResponse', readonly ids: ReadonlyArray<string> } };

export type EditScheduledOrderMutationVariables = Exact<{
  input: EditScheduledOrderInput;
}>;


export type EditScheduledOrderMutation = { readonly __typename?: 'Mutation', readonly editScheduledOrder: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type PreviewCustomerInvoiceSpecificationMutationVariables = Exact<{
  input: InvoiceActionsInput;
}>;


export type PreviewCustomerInvoiceSpecificationMutation = { readonly __typename?: 'Mutation', readonly previewCustomerInvoiceSpecification: { readonly __typename?: 'FileUrlGenericListResponse', readonly url: ReadonlyArray<string> | null | undefined } };

export type CreateCustomerInvoiceStatementMutationVariables = Exact<{
  input: InvoiceActionsInput;
}>;


export type CreateCustomerInvoiceStatementMutation = { readonly __typename?: 'Mutation', readonly createCustomerInvoiceStatement: boolean };

export type PreviewSupplierInvoiceSpecificationMutationVariables = Exact<{
  input: InvoiceActionsInput;
}>;


export type PreviewSupplierInvoiceSpecificationMutation = { readonly __typename?: 'Mutation', readonly previewSupplierInvoiceSpecification: { readonly __typename?: 'FileUrlGenericResponse', readonly url: string } };

export type CreateSupplierInvoiceStatementMutationVariables = Exact<{
  input: InvoiceActionsInput;
}>;


export type CreateSupplierInvoiceStatementMutation = { readonly __typename?: 'Mutation', readonly createSupplierInvoiceStatement: boolean };

export type RollbackSupplierInvoiceStatementMutationVariables = Exact<{
  documentId: Scalars['ID'];
}>;


export type RollbackSupplierInvoiceStatementMutation = { readonly __typename?: 'Mutation', readonly rollbackSupplierInvoiceStatement: boolean };

export type SupplierDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SupplierDetailsQuery = { readonly __typename?: 'Query', readonly supplier: { readonly __typename?: 'Supplier', readonly id: string, readonly companySpecification: CompanySpecification, readonly supplierTypes: ReadonlyArray<SupplierType>, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly businessId: string, readonly name: string, readonly comment: string | null | undefined, readonly active: boolean, readonly companyType: CompanyType, readonly coupaNumber: string | null | undefined, readonly paymentAccountNumber: string, readonly vatIdNumber: string, readonly contactPeople: ReadonlyArray<{ readonly __typename?: 'ContactPerson', readonly email: string, readonly firstName: string | null | undefined, readonly phoneNumber: string | null | undefined, readonly role: string, readonly surname: string | null | undefined }> | null | undefined, readonly geographicAddresses: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined }, readonly identifiers: ReadonlyArray<{ readonly __typename?: 'Identifier', readonly name: IdentifierName, readonly value: string }> | null | undefined }, readonly availableActions: { readonly __typename?: 'AvailableSupplierActions', readonly delete: boolean } } };

export type OrderDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrderDetailsQuery = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly createdAt: string, readonly id: string, readonly businessId: string, readonly state: OrderState, readonly serviceDate: string, readonly actualServiceDate: string | null | undefined, readonly customerReferenceNo: string | null | undefined, readonly comment: string | null | undefined, readonly pendingAmendmentsExist: boolean | null | undefined, readonly pendingFailuresExist: boolean | null | undefined, readonly accessDetailsForSupplier: { readonly __typename?: 'AccessDetailsForSupplier', readonly text: string | null | undefined } | null | undefined, readonly site: { readonly __typename?: 'Site', readonly id: string, readonly businessId: string, readonly name: string, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined }, readonly customer: { readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } } }, readonly serviceLocation: { readonly __typename?: 'ServiceLocation', readonly name: string | null | undefined, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly destinationServiceLocation: { readonly __typename?: 'ServiceLocation', readonly name: string | null | undefined } | null | undefined, readonly supplier: { readonly __typename?: 'Organization', readonly name: string, readonly id: string, readonly businessId: string }, readonly scheduledOrder: { readonly __typename?: 'ScheduledOrder', readonly id: string, readonly businessId: string, readonly scheduleId: string, readonly scheduleStartDate: string, readonly scheduleEndDate: string, readonly scheduleBusinessId: string, readonly scheduleConfiguration: { readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined } } | null | undefined, readonly request: { readonly __typename?: 'OnceOffRequest', readonly id: string, readonly businessId: string } | { readonly __typename?: 'ScheduledRequest', readonly id: string, readonly businessId: string } | null | undefined, readonly salesOrderLines: ReadonlyArray<{ readonly __typename?: 'OrderLine', readonly id: string, readonly orderId: string, readonly quantity: number | null | undefined, readonly actualQuantity: number | null | undefined, readonly unitPriceCurrency: string | null | undefined, readonly unitPriceValue: number | null | undefined, readonly unitType: UnitType | null | undefined, readonly totalCost: number | null | undefined, readonly priceRuleDescription: string | null | undefined, readonly productData: { readonly __typename?: 'OrderProductData', readonly packageCategory: string | null | undefined, readonly packageDescription: string | null | undefined, readonly productCategory: string, readonly wasteType: string | null | undefined, readonly wasteTypeName: string | null | undefined, readonly resource: string | null | undefined, readonly packageTypeId: string | null | undefined } }>, readonly purchaseOrderLines: ReadonlyArray<{ readonly __typename?: 'OrderLine', readonly id: string, readonly orderId: string, readonly quantity: number | null | undefined, readonly actualQuantity: number | null | undefined, readonly unitPriceCurrency: string | null | undefined, readonly unitPriceValue: number | null | undefined, readonly unitType: UnitType | null | undefined, readonly totalCost: number | null | undefined, readonly priceRuleDescription: string | null | undefined, readonly productData: { readonly __typename?: 'OrderProductData', readonly packageCategory: string | null | undefined, readonly packageDescription: string | null | undefined, readonly productCategory: string, readonly wasteType: string | null | undefined, readonly wasteTypeName: string | null | undefined, readonly resource: string | null | undefined, readonly packageTypeId: string | null | undefined }, readonly treatmentFacility: { readonly __typename?: 'Organization', readonly id: string, readonly businessId: string, readonly name: string } | null | undefined }>, readonly purchaseChargeLines: ReadonlyArray<{ readonly __typename?: 'ChargeLine', readonly id: string, readonly createdAt: string, readonly code: string, readonly amount: number | null | undefined, readonly currency: string | null | undefined, readonly unitType: UnitType | null | undefined, readonly priceRuleDescription: string | null | undefined, readonly createdBy: { readonly __typename?: 'User', readonly displayName: string } | null | undefined }>, readonly salesChargeLines: ReadonlyArray<{ readonly __typename?: 'ChargeLine', readonly id: string, readonly createdAt: string, readonly code: string, readonly amount: number | null | undefined, readonly currency: string | null | undefined, readonly unitType: UnitType | null | undefined, readonly priceRuleDescription: string | null | undefined, readonly createdBy: { readonly __typename?: 'User', readonly displayName: string } | null | undefined }>, readonly createdBy: { readonly __typename?: 'User', readonly displayName: string }, readonly availableActions: { readonly __typename?: 'AvailableOrderActions', readonly cancelSingleOrder: boolean, readonly cancelSchedule: boolean, readonly edit: boolean, readonly reportServiceFailure: boolean, readonly editWithoutNegotiation: boolean, readonly confirmDelivery: boolean, readonly creditMemo: boolean }, readonly amendments: ReadonlyArray<{ readonly __typename?: 'Amendment', readonly startedAt: string, readonly requestedContainerQuantity: number | null | undefined, readonly requestedServiceDate: string | null | undefined, readonly pendingProposals: ReadonlyArray<{ readonly __typename?: 'OrderProposal', readonly proposalId: string, readonly serviceDate: string | null | undefined, readonly containerQuantity: number | null | undefined, readonly removedLineIds: ReadonlyArray<string> | null | undefined, readonly orderLineProposals: ReadonlyArray<{ readonly __typename?: 'OrderLineProposal', readonly id: string, readonly quantity: number }> | null | undefined, readonly newAdditionalOrderLines: ReadonlyArray<{ readonly __typename?: 'AdditionalLine', readonly requestedQuantity: number, readonly additionalServiceCategoryCode: string }> | null | undefined, readonly approvingSide: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }, readonly proposingSide: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string } }>, readonly permittedProposers: ReadonlyArray<{ readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }>, readonly startedBy: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string } }>, readonly referenceGroupOrders: ReadonlyArray<{ readonly __typename?: 'ReferenceGroupOrder', readonly id: string, readonly businessId: string, readonly referenceType: ReferenceType }> | null | undefined } };

export type ScheduleDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ScheduleDetailsQuery = { readonly __typename?: 'Query', readonly schedule: { readonly __typename?: 'Schedule', readonly id: string, readonly createdAt: string, readonly startDate: string, readonly endDate: string, readonly businessId: string, readonly nearestScheduledOrder: { readonly __typename?: 'ScheduledOrder', readonly id: string, readonly businessId: string, readonly orderType: OrderType, readonly state: ActivityState, readonly customerReferenceNo: string | null | undefined, readonly comment: string | null | undefined, readonly createdAt: string, readonly scheduleId: string, readonly scheduleBusinessId: string, readonly pendingAmendmentsExist: boolean | null | undefined, readonly accessDetailsForSupplier: { readonly __typename?: 'AccessDetailsForSupplier', readonly text: string | null | undefined } | null | undefined, readonly site: { readonly __typename?: 'Site', readonly id: string, readonly businessId: string, readonly name: string, readonly customer: { readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } }, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly serviceLocation: { readonly __typename?: 'ServiceLocation', readonly name: string | null | undefined, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly orderLines: ReadonlyArray<{ readonly __typename?: 'ScheduledOrderLine', readonly id: string, readonly quantity: number | null | undefined, readonly productData: { readonly __typename?: 'ScheduledProductData', readonly productCategory: string, readonly packageCategory: string | null | undefined, readonly packageDescription: string | null | undefined, readonly wasteType: string | null | undefined, readonly wasteTypeName: string | null | undefined, readonly resource: string | null | undefined, readonly packageTypeId: string | null | undefined } }>, readonly supplier: { readonly __typename?: 'Organization', readonly id: string, readonly businessId: string, readonly name: string }, readonly scheduleConfiguration: { readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined }, readonly availableActions: { readonly __typename?: 'AvailableScheduledOrderActions', readonly cancel: boolean, readonly edit: boolean }, readonly amendments: ReadonlyArray<{ readonly __typename?: 'ScheduledAmendment', readonly startedAt: string, readonly requestedContainerQuantity: number | null | undefined, readonly pendingProposals: ReadonlyArray<{ readonly __typename?: 'ScheduledOrderProposal', readonly proposalId: string, readonly containerQuantity: number | null | undefined, readonly scheduleConfiguration: { readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined } | null | undefined, readonly approvingSide: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }, readonly proposingSide: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string } }>, readonly requestedScheduleConfiguration: { readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined } | null | undefined, readonly permittedProposers: ReadonlyArray<{ readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }>, readonly startedBy: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string } }> }, readonly scheduledOrders: ReadonlyArray<{ readonly __typename?: 'ScheduledOrder', readonly scheduleConfiguration: { readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined }, readonly orderLines: ReadonlyArray<{ readonly __typename?: 'ScheduledOrderLine', readonly quantity: number | null | undefined, readonly productData: { readonly __typename?: 'ScheduledProductData', readonly productCategory: string, readonly packageCategory: string | null | undefined, readonly packageDescription: string | null | undefined, readonly packageTypeId: string | null | undefined, readonly wasteType: string | null | undefined, readonly wasteTypeName: string | null | undefined } }> }>, readonly request: { readonly __typename?: 'OnceOffRequest', readonly id: string, readonly businessId: string } | { readonly __typename?: 'ScheduledRequest', readonly id: string, readonly businessId: string } | null | undefined, readonly createdBy: { readonly __typename?: 'User', readonly id: string, readonly displayName: string } } };

export type RequestDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RequestDetailsQuery = { readonly __typename?: 'Query', readonly request: { readonly __typename?: 'OnceOffRequest', readonly serviceDate: string, readonly id: string, readonly businessId: string, readonly createdAt: string, readonly customerReferenceNo: string | null | undefined, readonly comment: string | null | undefined, readonly state: RequestState, readonly destinationServiceLocation: { readonly __typename?: 'ServiceLocation', readonly name: string | null | undefined } | null | undefined, readonly quotations: ReadonlyArray<{ readonly __typename?: 'OnceOffQuotation', readonly startedAt: string, readonly requestedServiceDate: string, readonly startedBy: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }, readonly permittedProposers: ReadonlyArray<{ readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }>, readonly pendingProposals: ReadonlyArray<{ readonly __typename?: 'OnceOffRequestProposal', readonly proposalId: string, readonly startedAt: string, readonly serviceDate: string | null | undefined, readonly approvingSide: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }, readonly proposingSide: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string } }> }>, readonly approvals: ReadonlyArray<{ readonly __typename?: 'SimpleNegotiation', readonly startedAt: string, readonly startedBy: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }, readonly permittedProposers: ReadonlyArray<{ readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }>, readonly pendingProposals: ReadonlyArray<{ readonly __typename?: 'SimpleRequestProposal', readonly canRespond: boolean | null | undefined, readonly proposalId: string, readonly startedAt: string, readonly approvingSide: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }, readonly proposingSide: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string } }> }>, readonly order: { readonly __typename?: 'Order', readonly id: string, readonly businessId: string } | null | undefined, readonly site: { readonly __typename?: 'Site', readonly id: string, readonly businessId: string, readonly name: string, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined }, readonly customer: { readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } } }, readonly serviceLocation: { readonly __typename?: 'ServiceLocation', readonly name: string | null | undefined, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly supplier: { readonly __typename?: 'Organization', readonly name: string, readonly id: string, readonly businessId: string }, readonly accessDetailsForSupplier: { readonly __typename?: 'AccessDetailsForSupplier', readonly text: string | null | undefined } | null | undefined, readonly purchaseRequestLines: ReadonlyArray<{ readonly __typename?: 'RequestLine', readonly quantity: number | null | undefined, readonly unitType: UnitType | null | undefined, readonly unitPriceCurrency: string | null | undefined, readonly totalCost: number | null | undefined, readonly priceRuleDescription: string | null | undefined, readonly productData: { readonly __typename?: 'RequestProductData', readonly packageCategory: string | null | undefined, readonly packageDescription: string | null | undefined, readonly productCategory: string, readonly wasteType: string | null | undefined, readonly wasteTypeName: string | null | undefined, readonly resource: string | null | undefined, readonly packageTypeId: string | null | undefined } }>, readonly salesRequestLines: ReadonlyArray<{ readonly __typename?: 'RequestLine', readonly unitType: UnitType | null | undefined, readonly unitPriceCurrency: string | null | undefined, readonly totalCost: number | null | undefined, readonly priceRuleDescription: string | null | undefined, readonly productData: { readonly __typename?: 'RequestProductData', readonly productCategory: string } }>, readonly createdBy: { readonly __typename?: 'User', readonly displayName: string } } | { readonly __typename?: 'ScheduledRequest', readonly id: string, readonly businessId: string, readonly createdAt: string, readonly customerReferenceNo: string | null | undefined, readonly comment: string | null | undefined, readonly state: RequestState, readonly scheduleConfiguration: { readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined }, readonly quotations: ReadonlyArray<{ readonly __typename?: 'ScheduledQuotation', readonly startedAt: string, readonly startedBy: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }, readonly requestedScheduleConfiguration: { readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined }, readonly permittedProposers: ReadonlyArray<{ readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }>, readonly pendingProposals: ReadonlyArray<{ readonly __typename?: 'ScheduledRequestProposal', readonly proposalId: string, readonly startedAt: string, readonly scheduleConfiguration: { readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined }, readonly approvingSide: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }, readonly proposingSide: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string } }> }>, readonly approvals: ReadonlyArray<{ readonly __typename?: 'SimpleNegotiation', readonly startedAt: string, readonly startedBy: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }, readonly permittedProposers: ReadonlyArray<{ readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }>, readonly pendingProposals: ReadonlyArray<{ readonly __typename?: 'SimpleRequestProposal', readonly canRespond: boolean | null | undefined, readonly proposalId: string, readonly startedAt: string, readonly approvingSide: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }, readonly proposingSide: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string } }> }>, readonly scheduledOrder: { readonly __typename?: 'ScheduledOrder', readonly id: string, readonly businessId: string } | null | undefined, readonly site: { readonly __typename?: 'Site', readonly id: string, readonly businessId: string, readonly name: string, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined }, readonly customer: { readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } } }, readonly serviceLocation: { readonly __typename?: 'ServiceLocation', readonly name: string | null | undefined, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly supplier: { readonly __typename?: 'Organization', readonly name: string, readonly id: string, readonly businessId: string }, readonly accessDetailsForSupplier: { readonly __typename?: 'AccessDetailsForSupplier', readonly text: string | null | undefined } | null | undefined, readonly purchaseRequestLines: ReadonlyArray<{ readonly __typename?: 'RequestLine', readonly quantity: number | null | undefined, readonly unitType: UnitType | null | undefined, readonly unitPriceCurrency: string | null | undefined, readonly totalCost: number | null | undefined, readonly priceRuleDescription: string | null | undefined, readonly productData: { readonly __typename?: 'RequestProductData', readonly packageCategory: string | null | undefined, readonly packageDescription: string | null | undefined, readonly productCategory: string, readonly wasteType: string | null | undefined, readonly wasteTypeName: string | null | undefined, readonly resource: string | null | undefined, readonly packageTypeId: string | null | undefined } }>, readonly salesRequestLines: ReadonlyArray<{ readonly __typename?: 'RequestLine', readonly unitType: UnitType | null | undefined, readonly unitPriceCurrency: string | null | undefined, readonly totalCost: number | null | undefined, readonly priceRuleDescription: string | null | undefined, readonly productData: { readonly __typename?: 'RequestProductData', readonly productCategory: string } }>, readonly createdBy: { readonly __typename?: 'User', readonly displayName: string } } };

export type RequestsQueryVariables = Exact<{
  input: RequestFiltersInput;
}>;


export type RequestsQuery = { readonly __typename?: 'Query', readonly requests: { readonly __typename?: 'RequestsResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'OnceOffRequest', readonly serviceDate: string, readonly id: string, readonly businessId: string, readonly state: RequestState, readonly comment: string | null | undefined, readonly createdAt: string, readonly customerReferenceNo: string | null | undefined, readonly site: { readonly __typename?: 'Site', readonly id: string, readonly businessId: string, readonly name: string, readonly customer: { readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } }, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly serviceLocation: { readonly __typename?: 'ServiceLocation', readonly name: string | null | undefined, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly supplier: { readonly __typename?: 'Organization', readonly name: string }, readonly accessDetailsForSupplier: { readonly __typename?: 'AccessDetailsForSupplier', readonly text: string | null | undefined } | null | undefined, readonly purchaseRequestLines: ReadonlyArray<{ readonly __typename?: 'RequestLine', readonly quantity: number | null | undefined, readonly productData: { readonly __typename?: 'RequestProductData', readonly packageCategory: string | null | undefined, readonly packageDescription: string | null | undefined, readonly productCategory: string, readonly wasteType: string | null | undefined, readonly wasteTypeName: string | null | undefined, readonly resource: string | null | undefined, readonly packageTypeId: string | null | undefined } }>, readonly createdBy: { readonly __typename?: 'User', readonly displayName: string } } | { readonly __typename?: 'ScheduledRequest', readonly id: string, readonly businessId: string, readonly state: RequestState, readonly comment: string | null | undefined, readonly createdAt: string, readonly customerReferenceNo: string | null | undefined, readonly scheduleConfiguration: { readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined }, readonly site: { readonly __typename?: 'Site', readonly id: string, readonly businessId: string, readonly name: string, readonly customer: { readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } }, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly serviceLocation: { readonly __typename?: 'ServiceLocation', readonly name: string | null | undefined, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly supplier: { readonly __typename?: 'Organization', readonly name: string }, readonly accessDetailsForSupplier: { readonly __typename?: 'AccessDetailsForSupplier', readonly text: string | null | undefined } | null | undefined, readonly purchaseRequestLines: ReadonlyArray<{ readonly __typename?: 'RequestLine', readonly quantity: number | null | undefined, readonly productData: { readonly __typename?: 'RequestProductData', readonly packageCategory: string | null | undefined, readonly packageDescription: string | null | undefined, readonly productCategory: string, readonly wasteType: string | null | undefined, readonly wasteTypeName: string | null | undefined, readonly resource: string | null | undefined, readonly packageTypeId: string | null | undefined } }>, readonly createdBy: { readonly __typename?: 'User', readonly displayName: string } }> } };

export type RequestQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RequestQuery = { readonly __typename?: 'Query', readonly request: { readonly __typename?: 'OnceOffRequest', readonly serviceDate: string, readonly id: string, readonly businessId: string, readonly state: RequestState, readonly comment: string | null | undefined, readonly createdAt: string, readonly customerReferenceNo: string | null | undefined, readonly site: { readonly __typename?: 'Site', readonly id: string, readonly businessId: string, readonly name: string, readonly customer: { readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } }, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly serviceLocation: { readonly __typename?: 'ServiceLocation', readonly name: string | null | undefined, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly supplier: { readonly __typename?: 'Organization', readonly name: string }, readonly accessDetailsForSupplier: { readonly __typename?: 'AccessDetailsForSupplier', readonly text: string | null | undefined } | null | undefined, readonly purchaseRequestLines: ReadonlyArray<{ readonly __typename?: 'RequestLine', readonly quantity: number | null | undefined, readonly productData: { readonly __typename?: 'RequestProductData', readonly packageCategory: string | null | undefined, readonly packageDescription: string | null | undefined, readonly productCategory: string, readonly wasteType: string | null | undefined, readonly wasteTypeName: string | null | undefined, readonly resource: string | null | undefined, readonly packageTypeId: string | null | undefined } }>, readonly createdBy: { readonly __typename?: 'User', readonly displayName: string } } | { readonly __typename?: 'ScheduledRequest', readonly id: string, readonly businessId: string, readonly state: RequestState, readonly comment: string | null | undefined, readonly createdAt: string, readonly customerReferenceNo: string | null | undefined, readonly scheduleConfiguration: { readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined }, readonly site: { readonly __typename?: 'Site', readonly id: string, readonly businessId: string, readonly name: string, readonly customer: { readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } }, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly serviceLocation: { readonly __typename?: 'ServiceLocation', readonly name: string | null | undefined, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly supplier: { readonly __typename?: 'Organization', readonly name: string }, readonly accessDetailsForSupplier: { readonly __typename?: 'AccessDetailsForSupplier', readonly text: string | null | undefined } | null | undefined, readonly purchaseRequestLines: ReadonlyArray<{ readonly __typename?: 'RequestLine', readonly quantity: number | null | undefined, readonly productData: { readonly __typename?: 'RequestProductData', readonly packageCategory: string | null | undefined, readonly packageDescription: string | null | undefined, readonly productCategory: string, readonly wasteType: string | null | undefined, readonly wasteTypeName: string | null | undefined, readonly resource: string | null | undefined, readonly packageTypeId: string | null | undefined } }>, readonly createdBy: { readonly __typename?: 'User', readonly displayName: string } } };

export type OrdersQueryVariables = Exact<{
  input: OrderFiltersInput;
}>;


export type OrdersQuery = { readonly __typename?: 'Query', readonly orders: { readonly __typename?: 'OrdersResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Order', readonly id: string, readonly businessId: string, readonly state: OrderState, readonly serviceDate: string, readonly actualServiceDate: string | null | undefined, readonly createdAt: string, readonly pendingAmendmentsExist: boolean | null | undefined, readonly pendingFailuresExist: boolean | null | undefined, readonly site: { readonly __typename?: 'Site', readonly id: string, readonly businessId: string, readonly name: string, readonly customer: { readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } }, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly serviceLocation: { readonly __typename?: 'ServiceLocation', readonly name: string | null | undefined, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly scheduledOrder: { readonly __typename?: 'ScheduledOrder', readonly id: string, readonly businessId: string, readonly scheduleId: string, readonly scheduleBusinessId: string, readonly scheduleStartDate: string, readonly scheduleEndDate: string, readonly scheduleConfiguration: { readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined } } | null | undefined, readonly supplier: { readonly __typename?: 'Organization', readonly name: string }, readonly purchaseOrderLines: ReadonlyArray<{ readonly __typename?: 'OrderLine', readonly id: string, readonly orderId: string, readonly quantity: number | null | undefined, readonly actualQuantity: number | null | undefined, readonly productData: { readonly __typename?: 'OrderProductData', readonly packageCategory: string | null | undefined, readonly packageDescription: string | null | undefined, readonly productCategory: string, readonly wasteType: string | null | undefined, readonly wasteTypeName: string | null | undefined, readonly resource: string | null | undefined, readonly packageTypeId: string | null | undefined } }>, readonly createdBy: { readonly __typename?: 'User', readonly displayName: string }, readonly availableActions: { readonly __typename?: 'AvailableOrderActions', readonly cancelSingleOrder: boolean, readonly cancelSchedule: boolean, readonly edit: boolean, readonly reportServiceFailure: boolean, readonly editWithoutNegotiation: boolean, readonly confirmDelivery: boolean, readonly creditMemo: boolean } }> } };

export type OrderQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type OrderQuery = { readonly __typename?: 'Query', readonly order: { readonly __typename?: 'Order', readonly id: string, readonly businessId: string, readonly state: OrderState, readonly serviceDate: string, readonly actualServiceDate: string | null | undefined, readonly createdAt: string, readonly pendingAmendmentsExist: boolean | null | undefined, readonly pendingFailuresExist: boolean | null | undefined, readonly site: { readonly __typename?: 'Site', readonly id: string, readonly businessId: string, readonly name: string, readonly customer: { readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } }, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly serviceLocation: { readonly __typename?: 'ServiceLocation', readonly name: string | null | undefined, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly scheduledOrder: { readonly __typename?: 'ScheduledOrder', readonly id: string, readonly businessId: string, readonly scheduleId: string, readonly scheduleBusinessId: string, readonly scheduleStartDate: string, readonly scheduleEndDate: string, readonly scheduleConfiguration: { readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined } } | null | undefined, readonly supplier: { readonly __typename?: 'Organization', readonly name: string }, readonly purchaseOrderLines: ReadonlyArray<{ readonly __typename?: 'OrderLine', readonly id: string, readonly orderId: string, readonly quantity: number | null | undefined, readonly actualQuantity: number | null | undefined, readonly productData: { readonly __typename?: 'OrderProductData', readonly packageCategory: string | null | undefined, readonly packageDescription: string | null | undefined, readonly productCategory: string, readonly wasteType: string | null | undefined, readonly wasteTypeName: string | null | undefined, readonly resource: string | null | undefined, readonly packageTypeId: string | null | undefined } }>, readonly createdBy: { readonly __typename?: 'User', readonly displayName: string }, readonly availableActions: { readonly __typename?: 'AvailableOrderActions', readonly cancelSingleOrder: boolean, readonly cancelSchedule: boolean, readonly edit: boolean, readonly reportServiceFailure: boolean, readonly editWithoutNegotiation: boolean, readonly confirmDelivery: boolean, readonly creditMemo: boolean } } };

export type SchedulesQueryVariables = Exact<{
  input: ScheduleFiltersInput;
}>;


export type SchedulesQuery = { readonly __typename?: 'Query', readonly schedules: { readonly __typename?: 'SchedulesResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Schedule', readonly id: string, readonly businessId: string, readonly startDate: string, readonly endDate: string, readonly createdAt: string, readonly nearestScheduledOrder: { readonly __typename?: 'ScheduledOrder', readonly id: string, readonly state: ActivityState, readonly createdAt: string, readonly scheduleId: string, readonly scheduleBusinessId: string, readonly pendingAmendmentsExist: boolean | null | undefined, readonly site: { readonly __typename?: 'Site', readonly id: string, readonly businessId: string, readonly name: string, readonly customer: { readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } }, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly serviceLocation: { readonly __typename?: 'ServiceLocation', readonly name: string | null | undefined, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly orderLines: ReadonlyArray<{ readonly __typename?: 'ScheduledOrderLine', readonly id: string, readonly quantity: number | null | undefined, readonly productData: { readonly __typename?: 'ScheduledProductData', readonly packageCategory: string | null | undefined, readonly packageDescription: string | null | undefined, readonly productCategory: string, readonly wasteType: string | null | undefined, readonly wasteTypeName: string | null | undefined, readonly resource: string | null | undefined, readonly packageTypeId: string | null | undefined } }>, readonly supplier: { readonly __typename?: 'Organization', readonly name: string }, readonly scheduleConfiguration: { readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined }, readonly availableActions: { readonly __typename?: 'AvailableScheduledOrderActions', readonly cancel: boolean, readonly edit: boolean }, readonly accessDetailsForSupplier: { readonly __typename?: 'AccessDetailsForSupplier', readonly text: string | null | undefined } | null | undefined } }> } };

export type ScheduleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ScheduleQuery = { readonly __typename?: 'Query', readonly schedule: { readonly __typename?: 'Schedule', readonly id: string, readonly businessId: string, readonly startDate: string, readonly endDate: string, readonly createdAt: string, readonly nearestScheduledOrder: { readonly __typename?: 'ScheduledOrder', readonly id: string, readonly state: ActivityState, readonly createdAt: string, readonly scheduleId: string, readonly scheduleBusinessId: string, readonly pendingAmendmentsExist: boolean | null | undefined, readonly site: { readonly __typename?: 'Site', readonly id: string, readonly businessId: string, readonly name: string, readonly customer: { readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } }, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly serviceLocation: { readonly __typename?: 'ServiceLocation', readonly name: string | null | undefined, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly orderLines: ReadonlyArray<{ readonly __typename?: 'ScheduledOrderLine', readonly id: string, readonly quantity: number | null | undefined, readonly productData: { readonly __typename?: 'ScheduledProductData', readonly packageCategory: string | null | undefined, readonly packageDescription: string | null | undefined, readonly productCategory: string, readonly wasteType: string | null | undefined, readonly wasteTypeName: string | null | undefined, readonly resource: string | null | undefined, readonly packageTypeId: string | null | undefined } }>, readonly supplier: { readonly __typename?: 'Organization', readonly name: string }, readonly scheduleConfiguration: { readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined }, readonly availableActions: { readonly __typename?: 'AvailableScheduledOrderActions', readonly cancel: boolean, readonly edit: boolean }, readonly accessDetailsForSupplier: { readonly __typename?: 'AccessDetailsForSupplier', readonly text: string | null | undefined } | null | undefined } } };

export type CheckCreateOnceOffRequestsPreconditionsQueryVariables = Exact<{
  input: CreateOnceOffRequestsInput;
}>;


export type CheckCreateOnceOffRequestsPreconditionsQuery = { readonly __typename?: 'Query', readonly checkCreateOnceOffRequestsPreconditions: { readonly __typename?: 'PreconditionsCheckResponse', readonly allPreconditionsAreMet: boolean, readonly purchasePreconditions: ReadonlyArray<{ readonly __typename?: 'PreconditionsCheckLine', readonly priceRuleDescription: string | null | undefined, readonly totalCost: number | null | undefined, readonly unitPriceCurrency: string | null | undefined, readonly unitType: UnitType | null | undefined, readonly productData: { readonly __typename?: 'OrderProductData', readonly productCategory: string } }>, readonly salesPreconditions: ReadonlyArray<{ readonly __typename?: 'PreconditionsCheckLine', readonly priceRuleDescription: string | null | undefined, readonly totalCost: number | null | undefined, readonly unitPriceCurrency: string | null | undefined, readonly unitType: UnitType | null | undefined, readonly productData: { readonly __typename?: 'OrderProductData', readonly productCategory: string } }> } };

export type CreateOnceOffRequestsMutationVariables = Exact<{
  input: CreateOnceOffRequestsInput;
}>;


export type CreateOnceOffRequestsMutation = { readonly __typename?: 'Mutation', readonly createOnceOffRequests: { readonly __typename?: 'CreateRequestResponse', readonly createdOrderIds: ReadonlyArray<string>, readonly createdRequestIds: ReadonlyArray<string>, readonly createdScheduleIds: ReadonlyArray<string> } };

export type CheckCreateOnceOffManualRequestsPreconditionsQueryVariables = Exact<{
  input: CreateOnceOffManualRequestsInput;
}>;


export type CheckCreateOnceOffManualRequestsPreconditionsQuery = { readonly __typename?: 'Query', readonly checkCreateOnceOffManualRequestsPreconditions: { readonly __typename?: 'PreconditionsCheckResponse', readonly allPreconditionsAreMet: boolean, readonly purchasePreconditions: ReadonlyArray<{ readonly __typename?: 'PreconditionsCheckLine', readonly priceRuleDescription: string | null | undefined, readonly totalCost: number | null | undefined, readonly unitPriceCurrency: string | null | undefined, readonly unitType: UnitType | null | undefined, readonly productData: { readonly __typename?: 'OrderProductData', readonly productCategory: string } }>, readonly salesPreconditions: ReadonlyArray<{ readonly __typename?: 'PreconditionsCheckLine', readonly priceRuleDescription: string | null | undefined, readonly totalCost: number | null | undefined, readonly unitPriceCurrency: string | null | undefined, readonly unitType: UnitType | null | undefined, readonly productData: { readonly __typename?: 'OrderProductData', readonly productCategory: string } }> } };

export type CreateOnceOffManualRequestsMutationVariables = Exact<{
  input: CreateOnceOffManualRequestsInput;
}>;


export type CreateOnceOffManualRequestsMutation = { readonly __typename?: 'Mutation', readonly createOnceOffManualRequests: { readonly __typename?: 'CreateRequestResponse', readonly createdOrderIds: ReadonlyArray<string>, readonly createdRequestIds: ReadonlyArray<string>, readonly createdScheduleIds: ReadonlyArray<string> } };

export type CheckCreateScheduledRequestsPreconditionsQueryVariables = Exact<{
  input: CreateScheduledRequestsInput;
}>;


export type CheckCreateScheduledRequestsPreconditionsQuery = { readonly __typename?: 'Query', readonly checkCreateScheduledRequestsPreconditions: { readonly __typename?: 'PreconditionsCheckResponse', readonly allPreconditionsAreMet: boolean, readonly purchasePreconditions: ReadonlyArray<{ readonly __typename?: 'PreconditionsCheckLine', readonly priceRuleDescription: string | null | undefined, readonly totalCost: number | null | undefined, readonly unitPriceCurrency: string | null | undefined, readonly unitType: UnitType | null | undefined, readonly productData: { readonly __typename?: 'OrderProductData', readonly productCategory: string } }>, readonly salesPreconditions: ReadonlyArray<{ readonly __typename?: 'PreconditionsCheckLine', readonly priceRuleDescription: string | null | undefined, readonly totalCost: number | null | undefined, readonly unitPriceCurrency: string | null | undefined, readonly unitType: UnitType | null | undefined, readonly productData: { readonly __typename?: 'OrderProductData', readonly productCategory: string } }> } };

export type CreateScheduledRequestsMutationVariables = Exact<{
  input: CreateScheduledRequestsInput;
}>;


export type CreateScheduledRequestsMutation = { readonly __typename?: 'Mutation', readonly createScheduledRequests: { readonly __typename?: 'CreateRequestResponse', readonly createdOrderIds: ReadonlyArray<string>, readonly createdRequestIds: ReadonlyArray<string>, readonly createdScheduleIds: ReadonlyArray<string> } };

export type CheckCreateScheduledManualRequestsPreconditionsQueryVariables = Exact<{
  input: CreateScheduledManualRequestsInput;
}>;


export type CheckCreateScheduledManualRequestsPreconditionsQuery = { readonly __typename?: 'Query', readonly checkCreateScheduledManualRequestsPreconditions: { readonly __typename?: 'PreconditionsCheckResponse', readonly allPreconditionsAreMet: boolean, readonly purchasePreconditions: ReadonlyArray<{ readonly __typename?: 'PreconditionsCheckLine', readonly priceRuleDescription: string | null | undefined, readonly totalCost: number | null | undefined, readonly unitPriceCurrency: string | null | undefined, readonly unitType: UnitType | null | undefined, readonly productData: { readonly __typename?: 'OrderProductData', readonly productCategory: string } }>, readonly salesPreconditions: ReadonlyArray<{ readonly __typename?: 'PreconditionsCheckLine', readonly priceRuleDescription: string | null | undefined, readonly totalCost: number | null | undefined, readonly unitPriceCurrency: string | null | undefined, readonly unitType: UnitType | null | undefined, readonly productData: { readonly __typename?: 'OrderProductData', readonly productCategory: string } }> } };

export type CreateScheduledManualRequestsMutationVariables = Exact<{
  input: CreateScheduledManualRequestsInput;
}>;


export type CreateScheduledManualRequestsMutation = { readonly __typename?: 'Mutation', readonly createScheduledManualRequests: { readonly __typename?: 'CreateRequestResponse', readonly createdOrderIds: ReadonlyArray<string>, readonly createdRequestIds: ReadonlyArray<string>, readonly createdScheduleIds: ReadonlyArray<string> } };

export type SuppliersListQueryVariables = Exact<{
  input: SuppliersFiltersInput;
}>;


export type SuppliersListQuery = { readonly __typename?: 'Query', readonly suppliers: { readonly __typename?: 'SuppliersResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Supplier', readonly id: string, readonly supplierTypes: ReadonlyArray<SupplierType>, readonly companySpecification: CompanySpecification, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string, readonly businessId: string, readonly active: boolean, readonly geographicAddresses: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }, readonly availableActions: { readonly __typename?: 'AvailableSupplierActions', readonly delete: boolean } }> } };

export type CustomerInputQueryVariables = Exact<{
  input: CustomersFiltersInput;
}>;


export type CustomerInputQuery = { readonly __typename?: 'Query', readonly customers: { readonly __typename?: 'CustomersResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Customer', readonly id: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } }> } };

export type SiteInputQueryVariables = Exact<{
  input: SitesFiltersInput;
}>;


export type SiteInputQuery = { readonly __typename?: 'Query', readonly sites: { readonly __typename?: 'SitesResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Site', readonly id: string, readonly name: string, readonly customer: { readonly __typename?: 'Customer', readonly id: string } }> } };

export type ServiceLocationInputQueryVariables = Exact<{
  input: ServiceLocationsFiltersInput;
}>;


export type ServiceLocationInputQuery = { readonly __typename?: 'Query', readonly serviceLocations: { readonly __typename?: 'ServiceLocationsResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'ServiceLocation', readonly id: string }> } };

export type OnlyOneCustomerQueryVariables = Exact<{
  ids: InputMaybe<ReadonlyArray<Scalars['ID']> | Scalars['ID']>;
}>;


export type OnlyOneCustomerQuery = { readonly __typename?: 'Query', readonly customers: { readonly __typename?: 'CustomersResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Customer', readonly id: string }> } };

export type OnlyOneSiteQueryVariables = Exact<{
  customerId: InputMaybe<Scalars['ID']>;
}>;


export type OnlyOneSiteQuery = { readonly __typename?: 'Query', readonly sites: { readonly __typename?: 'SitesResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Site', readonly id: string }> } };

export type OnlyOneServiceLocationQueryVariables = Exact<{
  siteId: InputMaybe<Scalars['ID']>;
}>;


export type OnlyOneServiceLocationQuery = { readonly __typename?: 'Query', readonly serviceLocations: { readonly __typename?: 'ServiceLocationsResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'ServiceLocation', readonly id: string }> } };

export type CustomerForSiteQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerForSiteQuery = { readonly __typename?: 'Query', readonly site: { readonly __typename?: 'Site', readonly customer: { readonly __typename?: 'Customer', readonly id: string } } };

export type SiteAccessDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SiteAccessDetailsQuery = { readonly __typename?: 'Query', readonly site: { readonly __typename?: 'Site', readonly accessDetails: string | null | undefined } };

export type CustomersQueryVariables = Exact<{
  input: CustomersFiltersInput;
}>;


export type CustomersQuery = { readonly __typename?: 'Query', readonly customers: { readonly __typename?: 'CustomersResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly businessUnit: BusinessUnit, readonly availableActions: { readonly __typename?: 'AvailableCustomerActions', readonly delete: boolean }, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly businessId: string, readonly name: string, readonly active: boolean, readonly geographicAddresses: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } } }> } };

export type BasicCustomersQueryVariables = Exact<{
  input: CustomersFiltersInput;
}>;


export type BasicCustomersQuery = { readonly __typename?: 'Query', readonly customers: { readonly __typename?: 'CustomersResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly name: string } }> } };

export type CustomerDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerDetailsQuery = { readonly __typename?: 'Query', readonly customer: { readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly businessUnit: BusinessUnit, readonly availableActions: { readonly __typename?: 'AvailableCustomerActions', readonly delete: boolean }, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly businessId: string, readonly active: boolean, readonly name: string, readonly comment: string | null | undefined, readonly companyType: CompanyType, readonly vatIdNumber: string, readonly coupaNumber: string | null | undefined, readonly paymentAccountNumber: string, readonly identifiers: ReadonlyArray<{ readonly __typename?: 'Identifier', readonly name: IdentifierName, readonly value: string }> | null | undefined, readonly geographicAddresses: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined }, readonly contactPeople: ReadonlyArray<{ readonly __typename?: 'ContactPerson', readonly role: string, readonly surname: string | null | undefined, readonly phoneNumber: string | null | undefined, readonly email: string, readonly firstName: string | null | undefined }> | null | undefined } } };

export type SiteDetailsQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SiteDetailsQuery = { readonly __typename?: 'Query', readonly site: { readonly __typename?: 'Site', readonly id: string, readonly businessId: string, readonly name: string, readonly active: boolean, readonly paymentAccountNumber: string, readonly comment: string | null | undefined, readonly buildingType: BuildingType, readonly accessDetails: string | null | undefined, readonly openDate: string, readonly closureDate: string | null | undefined, readonly contactPeople: ReadonlyArray<{ readonly __typename?: 'ContactPerson', readonly firstName: string | null | undefined, readonly email: string, readonly phoneNumber: string | null | undefined, readonly surname: string | null | undefined, readonly role: string }> | null | undefined, readonly availableActions: { readonly __typename?: 'AvailableSiteActions', readonly delete: boolean }, readonly customer: { readonly __typename?: 'Customer', readonly id: string, readonly contractId: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } }, readonly identifiers: ReadonlyArray<{ readonly __typename?: 'Identifier', readonly value: string, readonly name: IdentifierName }> | null | undefined, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined }, readonly serviceLocations: ReadonlyArray<{ readonly __typename?: 'ServiceLocation', readonly id: string, readonly businessId: string, readonly name: string | null | undefined, readonly latitude: number | null | undefined, readonly longitude: number | null | undefined, readonly what3words: string | null | undefined, readonly geographicAddress: { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined } }> | null | undefined } };

export type CreateSupplierMutationVariables = Exact<{
  input: SupplierInput;
}>;


export type CreateSupplierMutation = { readonly __typename?: 'Mutation', readonly createSupplier: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type UpdateSupplierMutationVariables = Exact<{
  input: UpdateSupplierInput;
}>;


export type UpdateSupplierMutation = { readonly __typename?: 'Mutation', readonly updateSupplier: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type CreateCustomerMutationVariables = Exact<{
  input: CustomerInput;
}>;


export type CreateCustomerMutation = { readonly __typename?: 'Mutation', readonly createCustomer: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type UpdateCustomerMutationVariables = Exact<{
  input: UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = { readonly __typename?: 'Mutation', readonly updateCustomer: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type CreateSiteMutationVariables = Exact<{
  input: SiteInput;
}>;


export type CreateSiteMutation = { readonly __typename?: 'Mutation', readonly createSite: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type UpdateSiteMutationVariables = Exact<{
  input: UpdateSiteInput;
}>;


export type UpdateSiteMutation = { readonly __typename?: 'Mutation', readonly updateSite: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type RespondToEditOrderProposalMutationVariables = Exact<{
  input: RespondToProposalInput;
}>;


export type RespondToEditOrderProposalMutation = { readonly __typename?: 'Mutation', readonly respondToEditOrderProposal: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type RespondToEditScheduledOrderProposalMutationVariables = Exact<{
  input: RespondToProposalInput;
}>;


export type RespondToEditScheduledOrderProposalMutation = { readonly __typename?: 'Mutation', readonly respondToEditScheduledOrderProposal: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type RespondToRequestProposalMutationVariables = Exact<{
  input: RespondToProposalInput;
}>;


export type RespondToRequestProposalMutation = { readonly __typename?: 'Mutation', readonly respondToRequestProposal: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type EntireScheduleConfigurationFragment = { readonly __typename?: 'ScheduleConfiguration', readonly weeklyRecurrenceDayNames: ReadonlyArray<DayOfWeek> | null | undefined, readonly monthlyRecurrenceDayNumber: number | null | undefined, readonly frequency: Frequency, readonly startDate: string, readonly endDate: string, readonly recurrenceCounter: number | null | undefined, readonly dailyEveryWeekday: boolean | null | undefined, readonly monthlyRecurrenceConfig: { readonly __typename?: 'MonthlyRecurrenceConfig', readonly monthlyRecurrenceConfigType: MonthlyRecurrenceConfigType, readonly monthlyRecurrenceConfigDay: MonthlyRecurrenceConfigDay } | null | undefined };

export type EntireGeographicAddressFragment = { readonly __typename?: 'GeographicAddress', readonly regionOrState: string | null | undefined, readonly city: string | null | undefined, readonly zipOrPostCode: string | null | undefined, readonly addressLine: string | null | undefined, readonly locale: Locale | null | undefined };

export type ProductsQueryVariables = Exact<{
  catalogSearchCriteriaInput: InputMaybe<CatalogSearchCriteriaInput>;
}>;


export type ProductsQuery = { readonly __typename?: 'Query', readonly products: ReadonlyArray<{ readonly __typename?: 'CatalogProductType', readonly id: string, readonly category: string, readonly isCategoryRecommended: boolean, readonly frequency: FrequencyFeature | null | undefined, readonly wasteType: string | null | undefined, readonly resource: string | null | undefined, readonly supplierId: string, readonly isSupplierRecommended: boolean }> };

export type DocumentsQueryVariables = Exact<{
  input: DocumentSearchCriteriaInput;
}>;


export type DocumentsQuery = { readonly __typename?: 'Query', readonly documents: { readonly __typename?: 'DocumentsResponse', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly siteIds: ReadonlyArray<string> | null | undefined, readonly createdAt: string, readonly documentType: DocumentType, readonly originalFileName: string, readonly createdBy: { readonly __typename?: 'User', readonly displayName: string } | null | undefined, readonly availableActions: { readonly __typename?: 'AvailableDocumentActions', readonly documentRollback: { readonly __typename?: 'DocumentRollback', readonly alreadyRolledBack: boolean, readonly canRollback: boolean } } | null | undefined }> } };

export type DocumentsInOrderQueryVariables = Exact<{
  input: DocumentInOrderSearchInput;
}>;


export type DocumentsInOrderQuery = { readonly __typename?: 'Query', readonly documentsInOrder: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly siteIds: ReadonlyArray<string> | null | undefined, readonly createdAt: string, readonly documentType: DocumentType, readonly originalFileName: string, readonly createdBy: { readonly __typename?: 'User', readonly displayName: string } | null | undefined }> };

export type DownloadDocumentFileQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DownloadDocumentFileQuery = { readonly __typename?: 'Query', readonly downloadDocumentFile: { readonly __typename?: 'FileUrlGenericResponse', readonly url: string } };

export type DeleteCustomerMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteCustomerMutation = { readonly __typename?: 'Mutation', readonly deleteCustomer: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type DeleteSiteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSiteMutation = { readonly __typename?: 'Mutation', readonly deleteSite: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type DeleteSupplierMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteSupplierMutation = { readonly __typename?: 'Mutation', readonly deleteSupplier: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type DownloadMasterExcelMutationVariables = Exact<{
  input: DownloadMasterExcelInput;
}>;


export type DownloadMasterExcelMutation = { readonly __typename?: 'Mutation', readonly downloadMasterExcel: { readonly __typename?: 'FileUrlGenericResponse', readonly url: string } };

export type DownloadSalesPriceExcelMutationVariables = Exact<{
  input: DownloadSalesPriceExcelInput;
}>;


export type DownloadSalesPriceExcelMutation = { readonly __typename?: 'Mutation', readonly downloadSalesPriceExcel: { readonly __typename?: 'FileUrlGenericResponse', readonly url: string } };

export type ServiceTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ServiceTypesQuery = { readonly __typename?: 'Query', readonly serviceTypes: ReadonlyArray<{ readonly __typename?: 'ServiceTypeResponse', readonly name: string, readonly presentedName: string }> };

export type ResourcesQueryVariables = Exact<{
  input: ResourcesFilterInput;
}>;


export type ResourcesQuery = { readonly __typename?: 'Query', readonly resources: { readonly __typename?: 'ResourceResponse', readonly totalCount: number, readonly resources: ReadonlyArray<{ readonly __typename?: 'Resource', readonly presentedName: string, readonly code: string }> } };

export type CreateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type CreateUserMutation = { readonly __typename?: 'Mutation', readonly registerUser2: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { readonly __typename?: 'Mutation', readonly updateUser: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type DeactivateUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeactivateUserMutation = { readonly __typename?: 'Mutation', readonly deleteUser: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type ActivateUserMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ActivateUserMutation = { readonly __typename?: 'Mutation', readonly activateUser: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type UserDetailsQueryVariables = Exact<{
  upn: Scalars['String'];
}>;


export type UserDetailsQuery = { readonly __typename?: 'Query', readonly userAuthDetails: { readonly __typename?: 'UserAuthDetails', readonly id: string, readonly active: boolean, readonly surname: string | null | undefined, readonly name: string | null | undefined, readonly upn: string, readonly positions: ReadonlyArray<{ readonly __typename?: 'UserAuthPosition', readonly type: string, readonly employer: string, readonly employerCountry: Locale, readonly role: Role }> } };

export type AgentsQueryVariables = Exact<{
  agentInput: AgentInput;
}>;


export type AgentsQuery = { readonly __typename?: 'Query', readonly mainCountryAgent: { readonly __typename?: 'Agent', readonly id: string, readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } } };

export type ConfirmGroupOrderDeliveryMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ConfirmGroupOrderDeliveryMutation = { readonly __typename?: 'Mutation', readonly confirmGroupOrderDelivery: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type OrderHistoryQueryVariables = Exact<{
  id: Scalars['ID'];
  limit: InputMaybe<Scalars['PositiveInt']>;
}>;


export type OrderHistoryQuery = { readonly __typename?: 'Query', readonly orderHistory: ReadonlyArray<{ readonly __typename?: 'HistoryRecord', readonly id: string, readonly createdAt: string, readonly description: string, readonly sideCreator: HistorySideCreator, readonly actionType: HistoryActionType, readonly createdBy: { readonly __typename?: 'User', readonly id: string, readonly displayName: string } | null | undefined, readonly historyChanges: ReadonlyArray<{ readonly __typename?: 'ChangeHistory', readonly parameter: string, readonly oldValue: string | null | undefined, readonly newValue: string | null | undefined }> }> };

export type ScheduleHistoryQueryVariables = Exact<{
  id: Scalars['ID'];
  limit: InputMaybe<Scalars['PositiveInt']>;
}>;


export type ScheduleHistoryQuery = { readonly __typename?: 'Query', readonly scheduleHistory: ReadonlyArray<{ readonly __typename?: 'HistoryRecord', readonly id: string, readonly createdAt: string, readonly description: string, readonly sideCreator: HistorySideCreator, readonly actionType: HistoryActionType, readonly createdBy: { readonly __typename?: 'User', readonly id: string, readonly displayName: string } | null | undefined, readonly historyChanges: ReadonlyArray<{ readonly __typename?: 'ChangeHistory', readonly parameter: string, readonly oldValue: string | null | undefined, readonly newValue: string | null | undefined }> }> };

export type CreateFinancialReportMutationVariables = Exact<{
  input: FinancialReportInput;
}>;


export type CreateFinancialReportMutation = { readonly __typename?: 'Mutation', readonly createFinancialReport: { readonly __typename?: 'FileUrlGenericResponse', readonly url: string } };

export type CreateEquipmentReportMutationVariables = Exact<{
  input: EquipmentReportInput;
}>;


export type CreateEquipmentReportMutation = { readonly __typename?: 'Mutation', readonly createEquipmentReport: { readonly __typename?: 'FileUrlGenericResponse', readonly url: string } };

export type CreateEquipmentReportInternalMutationVariables = Exact<{
  input: EquipmentReportInternalInput;
}>;


export type CreateEquipmentReportInternalMutation = { readonly __typename?: 'Mutation', readonly createEquipmentReportInternal: { readonly __typename?: 'FileUrlGenericResponse', readonly url: string } };

export type CreateCustomerReportMutationVariables = Exact<{
  input: CustomerReportInput;
}>;


export type CreateCustomerReportMutation = { readonly __typename?: 'Mutation', readonly createCustomerReport: { readonly __typename?: 'FileUrlGenericResponse', readonly url: string } };

export type CreateCustomersSitesLocationsReportMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCustomersSitesLocationsReportMutation = { readonly __typename?: 'Mutation', readonly createCustomersSitesLocationsReport: { readonly __typename?: 'FileUrlGenericResponse', readonly url: string } };

export type CreateMstReportMutationVariables = Exact<{
  input: MstReportInput;
}>;


export type CreateMstReportMutation = { readonly __typename?: 'Mutation', readonly createMstReport: { readonly __typename?: 'FileUrlGenericResponse', readonly url: string } };

export type AdditionalServiceCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AdditionalServiceCategoriesQuery = { readonly __typename?: 'Query', readonly additionalServiceCategories: ReadonlyArray<{ readonly __typename?: 'AdditionalServiceCategory', readonly id: string, readonly code: string, readonly presentedName: string }> };

export type CreditMemoMutationVariables = Exact<{
  input: CreditMemoInput;
}>;


export type CreditMemoMutation = { readonly __typename?: 'Mutation', readonly creditMemo: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type UsersListQueryVariables = Exact<{
  input: UsersFiltersInput;
}>;


export type UsersListQuery = { readonly __typename?: 'Query', readonly usersAuthDetails: { readonly __typename?: 'UsersAuthDetails', readonly totalCount: number, readonly items: ReadonlyArray<{ readonly __typename?: 'UserAuthDetails', readonly id: string, readonly active: boolean, readonly name: string | null | undefined, readonly surname: string | null | undefined, readonly displayName: string, readonly distinctRoles: ReadonlyArray<Role>, readonly lastActivity: string | null | undefined, readonly email: string }> } };

export type DownloadTemplateQueryVariables = Exact<{
  template: DocumentTemplate;
}>;


export type DownloadTemplateQuery = { readonly __typename?: 'Query', readonly downloadTemplate: { readonly __typename?: 'FileUrlGenericResponse', readonly url: string } };

export type CustomerIdsQueryVariables = Exact<{ [key: string]: never; }>;


export type CustomerIdsQuery = { readonly __typename?: 'Query', readonly customers: { readonly __typename?: 'CustomersResponse', readonly items: ReadonlyArray<{ readonly __typename?: 'Customer', readonly id: string }> } };

export type SiteIdsQueryVariables = Exact<{
  customerId: Scalars['ID'];
}>;


export type SiteIdsQuery = { readonly __typename?: 'Query', readonly sites: { readonly __typename?: 'SitesResponse', readonly items: ReadonlyArray<{ readonly __typename?: 'Site', readonly id: string }> } };

export type ServiceLocationIdsQueryVariables = Exact<{
  siteId: Scalars['ID'];
}>;


export type ServiceLocationIdsQuery = { readonly __typename?: 'Query', readonly serviceLocations: { readonly __typename?: 'ServiceLocationsResponse', readonly items: ReadonlyArray<{ readonly __typename?: 'ServiceLocation', readonly id: string }> } };

export type FailureTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type FailureTypesQuery = { readonly __typename?: 'Query', readonly failureTypes: ReadonlyArray<{ readonly __typename?: 'FailureType', readonly name: FailureCode, readonly presentedName: string, readonly submitProposalAction: boolean }> };

export type FailuresQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type FailuresQuery = { readonly __typename?: 'Query', readonly failures: { readonly __typename?: 'FailuresResponse', readonly failures: ReadonlyArray<{ readonly __typename?: 'Failure', readonly state: FailureState | null | undefined, readonly waitingTimeInMinutes: string | null | undefined, readonly description: string | null | undefined, readonly code: FailureCode | null | undefined, readonly id: string, readonly createdAt: string, readonly createdBy: { readonly __typename?: 'User', readonly id: string, readonly displayName: string }, readonly negotiations: ReadonlyArray<{ readonly __typename?: 'FailureNegotiation', readonly negotiationId: string, readonly state: NegotiationState, readonly startedAt: string, readonly isInArbitration: boolean | null | undefined, readonly availableActions: ReadonlyArray<FailureNegotiationAction | null | undefined> | null | undefined, readonly startedBy: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }, readonly waitingFor: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string } | null | undefined, readonly proposals: ReadonlyArray<{ readonly __typename?: 'FailureProposal', readonly canRespond: boolean | null | undefined, readonly serviceDate: string | null | undefined, readonly proposalId: string, readonly startedAt: string, readonly waitingTimeInMinutes: string | null | undefined, readonly response: { readonly __typename?: 'FailureProposalResponse', readonly comment: string | null | undefined, readonly responseType: ResponseType } | null | undefined, readonly approvingSide: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string }, readonly proposingSide: { readonly __typename?: 'OrganizationSummary', readonly id: string, readonly name: string } }> | null | undefined }> | null | undefined, readonly documents: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly originalFileName: string }> | null | undefined }> | null | undefined } };

export type RespondToFailureProposalMutationVariables = Exact<{
  input: RespondToFailureProposalInput;
}>;


export type RespondToFailureProposalMutation = { readonly __typename?: 'Mutation', readonly respondToFailureProposal: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type ApplyForArbitrationMutationVariables = Exact<{
  input: ArbitrationInput;
}>;


export type ApplyForArbitrationMutation = { readonly __typename?: 'Mutation', readonly applyForArbitration: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type EndFailureNegotiationMutationVariables = Exact<{
  negotiationId: Scalars['ID'];
}>;


export type EndFailureNegotiationMutation = { readonly __typename?: 'Mutation', readonly endFailureNegotiation: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type SubmitFailureProposalMutationVariables = Exact<{
  negotiationId: Scalars['ID'];
  serviceDate: Scalars['Date'];
}>;


export type SubmitFailureProposalMutation = { readonly __typename?: 'Mutation', readonly submitFailureProposal: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type CountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesQuery = { readonly __typename?: 'Query', readonly countries: ReadonlyArray<{ readonly __typename?: 'CountryGql', readonly id: string, readonly code: Locale, readonly presentedName: string }> };

export type CountriesConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type CountriesConfigQuery = { readonly __typename?: 'Query', readonly countries: ReadonlyArray<{ readonly __typename?: 'CountryGql', readonly code: Locale, readonly config: { readonly __typename?: 'CountryConfigGql', readonly useOrderConfirmationFlowByDefault: boolean } }> };

export type FindProcessesQueryVariables = Exact<{
  filters: FindProcessesGqlInput;
}>;


export type FindProcessesQuery = { readonly __typename?: 'Query', readonly findProcesses: { readonly __typename?: 'Processes', readonly items: ReadonlyArray<unknown>, readonly totalCount: number } };

export type ProcessHierarchyQueryVariables = Exact<{
  input: ProcessHierarchyGqlInput;
}>;


export type ProcessHierarchyQuery = { readonly __typename?: 'Query', readonly processHierarchy: unknown };

export type DownloadEmailAttachmentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DownloadEmailAttachmentQuery = { readonly __typename?: 'Query', readonly downloadEmailAttachment: { readonly __typename?: 'FileUrlGenericResponse', readonly url: string } };

export type PrefilledFileForSupplierDataUploadMutationVariables = Exact<{
  input: PrefilledFileForSupplierDataUploadInput;
}>;


export type PrefilledFileForSupplierDataUploadMutation = { readonly __typename?: 'Mutation', readonly prefilledFileForSupplierDataUpload: { readonly __typename?: 'FileUrlGenericResponse', readonly url: string } };

export type SubmitEditOnceOffRequestProposalMutationVariables = Exact<{
  input: EditOnceOffRequestProposalInput;
}>;


export type SubmitEditOnceOffRequestProposalMutation = { readonly __typename?: 'Mutation', readonly submitEditOnceOffRequestProposal: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type SubmitEditScheduledRequestProposalMutationVariables = Exact<{
  input: EditScheduledRequestProposalInput;
}>;


export type SubmitEditScheduledRequestProposalMutation = { readonly __typename?: 'Mutation', readonly submitEditScheduledRequestProposal: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type CancelFailureMutationVariables = Exact<{
  failureId: Scalars['ID'];
}>;


export type CancelFailureMutation = { readonly __typename?: 'Mutation', readonly cancelFailure: { readonly __typename?: 'EntityGenericResponse', readonly id: string } };

export type MyAuthDetailsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyAuthDetailsQuery = { readonly __typename?: 'Query', readonly myAuthDetails: { readonly __typename?: 'UserAuthDetails', readonly id: string, readonly upn: string, readonly displayName: string, readonly distinctRoles: ReadonlyArray<Role>, readonly distinctPermissions: ReadonlyArray<WoPermission>, readonly distinctCountries: ReadonlyArray<Locale>, readonly flatPositions: ReadonlyArray<{ readonly __typename?: 'UserAuthPosition', readonly role: Role, readonly employer: string, readonly type: string }> } };

export type MyPermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPermissionsQuery = { readonly __typename?: 'Query', readonly myAuthDetails: { readonly __typename?: 'UserAuthDetails', readonly distinctPermissions: ReadonlyArray<WoPermission> } };

export type FilteredSuppliersQueryVariables = Exact<{
  suppliersFiltersInput: SuppliersFiltersInput;
}>;


export type FilteredSuppliersQuery = { readonly __typename?: 'Query', readonly suppliers: { readonly __typename?: 'SuppliersResponse', readonly items: ReadonlyArray<{ readonly __typename?: 'Supplier', readonly id: string, readonly organization: { readonly __typename?: 'Organization', readonly name: string } }> } };

export type CustomerNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type CustomerNameQuery = { readonly __typename?: 'Query', readonly customer: { readonly __typename?: 'Customer', readonly organization: { readonly __typename?: 'Organization', readonly id: string, readonly name: string } } };

export type SiteNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SiteNameQuery = { readonly __typename?: 'Query', readonly site: { readonly __typename?: 'Site', readonly id: string, readonly name: string } };

export type ServiceLocationNameQueryVariables = Exact<{
  siteId: Scalars['ID'];
}>;


export type ServiceLocationNameQuery = { readonly __typename?: 'Query', readonly serviceLocations: { readonly __typename?: 'ServiceLocationsResponse', readonly items: ReadonlyArray<{ readonly __typename?: 'ServiceLocation', readonly address: string | null | undefined, readonly name: string | null | undefined, readonly id: string }> } };

export type SupplierNameQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type SupplierNameQuery = { readonly __typename?: 'Query', readonly supplier: { readonly __typename?: 'Supplier', readonly organization: { readonly __typename?: 'Organization', readonly name: string } } };

export const WeakWasteTypeFragmentDoc = gql`
    fragment WeakWasteType on WasteType {
  wasteTypeCode
  presentedName
  ewcCode
}
    `;
export const EntireScheduleConfigurationFragmentDoc = gql`
    fragment EntireScheduleConfiguration on ScheduleConfiguration {
  weeklyRecurrenceDayNames
  monthlyRecurrenceDayNumber
  frequency
  startDate
  endDate
  recurrenceCounter
  monthlyRecurrenceConfig {
    monthlyRecurrenceConfigType
    monthlyRecurrenceConfigDay
  }
  dailyEveryWeekday
}
    `;
export const EntireGeographicAddressFragmentDoc = gql`
    fragment EntireGeographicAddress on GeographicAddress {
  regionOrState
  city
  zipOrPostCode
  addressLine
  locale
}
    `;
export const SitesDocument = gql`
    query Sites($sitesFiltersInput: SitesFiltersInput!) {
  sites(sitesFiltersInput: $sitesFiltersInput) {
    items {
      id
      name
      accessDetails
      customer {
        id
      }
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SitesGQL extends Apollo.Query<SitesQuery, SitesQueryVariables> {
    document = SitesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SitesWithCustomersDocument = gql`
    query SitesWithCustomers($sitesFiltersInput: SitesFiltersInput!) {
  sites(sitesFiltersInput: $sitesFiltersInput) {
    items {
      id
      name
      customer {
        id
        contractId
        organization {
          name
        }
      }
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SitesWithCustomersGQL extends Apollo.Query<SitesWithCustomersQuery, SitesWithCustomersQueryVariables> {
    document = SitesWithCustomersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContainerTypesOnServiceLocationDocument = gql`
    query ContainerTypesOnServiceLocation($serviceLocationId: ID!, $wasteTypeCode: String!) {
  containerTypesOnServiceLocation(
    serviceLocationId: $serviceLocationId
    wasteTypeCode: $wasteTypeCode
    showOnlyActive: true
  ) {
    productContainerCode
    quantity
    quantityInDelivery
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ContainerTypesOnServiceLocationGQL extends Apollo.Query<ContainerTypesOnServiceLocationQuery, ContainerTypesOnServiceLocationQueryVariables> {
    document = ContainerTypesOnServiceLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContainersDocument = gql`
    query Containers($input: ContainersFiltersInput!) {
  containers(input: $input) {
    items {
      quantity
      startDate
      endDate
      isOnSite
      productContainerTypeCode
      productContainerTypeName
      wasteTypeCode
      wasteTypeEwcCode
      wasteTypePresentedName
      ownerId
      ownerName
      ownerBusinessId
      serviceLocationId
      serviceLocationName
      siteId
      customerId
      supplierName
      serviceLocationCode
      availableActions {
        edit
        delete
        createNewOrder
      }
      activeSchedules {
        scheduleConfiguration {
          ...EntireScheduleConfiguration
        }
        scheduleId
      }
      nearestOneOffOrder {
        groupOrderId
        serviceDate
      }
    }
    totalCount
  }
}
    ${EntireScheduleConfigurationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ContainersGQL extends Apollo.Query<ContainersQuery, ContainersQueryVariables> {
    document = ContainersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContainerOwnersDocument = gql`
    query ContainerOwners($siteId: ID!, $serviceLocationId: ID!, $wasteTypeCode: String!, $productContainerCode: String!) {
  containers(
    input: {offset: 0, limit: 999, siteId: $siteId, serviceLocationIds: [$serviceLocationId], productContainerCodes: [$productContainerCode], wasteTypeCodes: [$wasteTypeCode], showOnlyOnSite: false}
  ) {
    items {
      ownerId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ContainerOwnersGQL extends Apollo.Query<ContainerOwnersQuery, ContainerOwnersQueryVariables> {
    document = ContainerOwnersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateContainerQuantityDocument = gql`
    mutation UpdateContainerQuantity($input: UpdateContainerQuantityInput!) {
  updateContainerQuantity(input: $input) {
    addedContainers
    removedContainers
    deliveryOrderBusinessIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateContainerQuantityGQL extends Apollo.Mutation<UpdateContainerQuantityMutation, UpdateContainerQuantityMutationVariables> {
    document = UpdateContainerQuantityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddContainerDocument = gql`
    mutation AddContainer($input: AddContainerInput!) {
  addContainer(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddContainerGQL extends Apollo.Mutation<AddContainerMutation, AddContainerMutationVariables> {
    document = AddContainerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ServiceLocationsDocument = gql`
    query ServiceLocations($serviceLocationsFiltersInput: ServiceLocationsFiltersInput!) {
  serviceLocations(serviceLocationsFiltersInput: $serviceLocationsFiltersInput) {
    items {
      id
      name
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ServiceLocationsGQL extends Apollo.Query<ServiceLocationsQuery, ServiceLocationsQueryVariables> {
    document = ServiceLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContainerWasteTypesDocument = gql`
    query ContainerWasteTypes($input: ContainerWasteTypesFiltersInput) {
  containerWasteTypes(input: $input) {
    ...WeakWasteType
  }
}
    ${WeakWasteTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ContainerWasteTypesGQL extends Apollo.Query<ContainerWasteTypesQuery, ContainerWasteTypesQueryVariables> {
    document = ContainerWasteTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AllWasteTypesDocument = gql`
    query AllWasteTypes($includeInactive: Boolean!) {
  wasteTypes(includeInactive: $includeInactive) {
    ...WeakWasteType
  }
}
    ${WeakWasteTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AllWasteTypesGQL extends Apollo.Query<AllWasteTypesQuery, AllWasteTypesQueryVariables> {
    document = AllWasteTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CatalogWasteTypesDocument = gql`
    query CatalogWasteTypes {
  catalogWasteTypes {
    ...WeakWasteType
  }
}
    ${WeakWasteTypeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CatalogWasteTypesGQL extends Apollo.Query<CatalogWasteTypesQuery, CatalogWasteTypesQueryVariables> {
    document = CatalogWasteTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SitesListDocument = gql`
    query SitesList($sitesFiltersInput: SitesFiltersInput!) {
  sites(sitesFiltersInput: $sitesFiltersInput) {
    totalCount
    items {
      id
      businessId
      name
      customer {
        contractId
        organization {
          id
          name
        }
      }
      availableActions {
        delete
      }
      active
      geographicAddress {
        ...EntireGeographicAddress
      }
    }
  }
}
    ${EntireGeographicAddressFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SitesListGQL extends Apollo.Query<SitesListQuery, SitesListQueryVariables> {
    document = SitesListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DatesForScheduleConfigurationDocument = gql`
    query DatesForScheduleConfiguration($input: ScheduleConfigurationInput!) {
  datesForScheduleConfiguration(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DatesForScheduleConfigurationGQL extends Apollo.Query<DatesForScheduleConfigurationQuery, DatesForScheduleConfigurationQueryVariables> {
    document = DatesForScheduleConfigurationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PlannedOrdersDocument = gql`
    query PlannedOrders($siteId: ID!, $serviceLocationId: ID, $wasteTypeCode: String, $packageCategories: [String!], $resourceCodes: [String!]) {
  plannedOrders(
    siteId: $siteId
    serviceLocationId: $serviceLocationId
    wasteTypeCode: $wasteTypeCode
    packageCategories: $packageCategories
    resourceCodes: $resourceCodes
  ) {
    id
    businessId
    state
    serviceDate
    scheduledOrder {
      id
    }
    purchaseOrderLines {
      productData {
        packageCategory
        packageDescription
        productCategory
        wasteType
        wasteTypeName
        resource
      }
      quantity
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PlannedOrdersGQL extends Apollo.Query<PlannedOrdersQuery, PlannedOrdersQueryVariables> {
    document = PlannedOrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelRequestDocument = gql`
    mutation CancelRequest($input: CancelRequestInput!) {
  cancelRequest(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelRequestGQL extends Apollo.Mutation<CancelRequestMutation, CancelRequestMutationVariables> {
    document = CancelRequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelOrderDocument = gql`
    mutation CancelOrder($input: CancelOrderInput!) {
  cancelOrder(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelOrderGQL extends Apollo.Mutation<CancelOrderMutation, CancelOrderMutationVariables> {
    document = CancelOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelScheduleDocument = gql`
    mutation CancelSchedule($input: CancelScheduleInput!) {
  cancelSchedule(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelScheduleGQL extends Apollo.Mutation<CancelScheduleMutation, CancelScheduleMutationVariables> {
    document = CancelScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportServiceFailureDocument = gql`
    mutation ReportServiceFailure($input: ReportFailureInput!) {
  reportServiceFailure(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportServiceFailureGQL extends Apollo.Mutation<ReportServiceFailureMutation, ReportServiceFailureMutationVariables> {
    document = ReportServiceFailureDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UploadOrderDocumentDocument = gql`
    mutation UploadOrderDocument($input: UploadOrderDocumentInput!) {
  uploadOrderDocument(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadOrderDocumentGQL extends Apollo.Mutation<UploadOrderDocumentMutation, UploadOrderDocumentMutationVariables> {
    document = UploadOrderDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditOrdersDocument = gql`
    mutation EditOrders($input: EditOrdersInput!) {
  editOrders(input: $input) {
    ids
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditOrdersGQL extends Apollo.Mutation<EditOrdersMutation, EditOrdersMutationVariables> {
    document = EditOrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditScheduledOrderDocument = gql`
    mutation EditScheduledOrder($input: EditScheduledOrderInput!) {
  editScheduledOrder(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditScheduledOrderGQL extends Apollo.Mutation<EditScheduledOrderMutation, EditScheduledOrderMutationVariables> {
    document = EditScheduledOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PreviewCustomerInvoiceSpecificationDocument = gql`
    mutation PreviewCustomerInvoiceSpecification($input: InvoiceActionsInput!) {
  previewCustomerInvoiceSpecification(input: $input) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PreviewCustomerInvoiceSpecificationGQL extends Apollo.Mutation<PreviewCustomerInvoiceSpecificationMutation, PreviewCustomerInvoiceSpecificationMutationVariables> {
    document = PreviewCustomerInvoiceSpecificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCustomerInvoiceStatementDocument = gql`
    mutation CreateCustomerInvoiceStatement($input: InvoiceActionsInput!) {
  createCustomerInvoiceStatement(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCustomerInvoiceStatementGQL extends Apollo.Mutation<CreateCustomerInvoiceStatementMutation, CreateCustomerInvoiceStatementMutationVariables> {
    document = CreateCustomerInvoiceStatementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PreviewSupplierInvoiceSpecificationDocument = gql`
    mutation PreviewSupplierInvoiceSpecification($input: InvoiceActionsInput!) {
  previewSupplierInvoiceSpecification(input: $input) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PreviewSupplierInvoiceSpecificationGQL extends Apollo.Mutation<PreviewSupplierInvoiceSpecificationMutation, PreviewSupplierInvoiceSpecificationMutationVariables> {
    document = PreviewSupplierInvoiceSpecificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSupplierInvoiceStatementDocument = gql`
    mutation CreateSupplierInvoiceStatement($input: InvoiceActionsInput!) {
  createSupplierInvoiceStatement(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSupplierInvoiceStatementGQL extends Apollo.Mutation<CreateSupplierInvoiceStatementMutation, CreateSupplierInvoiceStatementMutationVariables> {
    document = CreateSupplierInvoiceStatementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RollbackSupplierInvoiceStatementDocument = gql`
    mutation RollbackSupplierInvoiceStatement($documentId: ID!) {
  rollbackSupplierInvoiceStatement(input: {documentId: $documentId})
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RollbackSupplierInvoiceStatementGQL extends Apollo.Mutation<RollbackSupplierInvoiceStatementMutation, RollbackSupplierInvoiceStatementMutationVariables> {
    document = RollbackSupplierInvoiceStatementDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SupplierDetailsDocument = gql`
    query SupplierDetails($id: ID!) {
  supplier(id: $id) {
    id
    organization {
      id
      businessId
      name
      comment
      active
      companyType
      contactPeople {
        email
        firstName
        phoneNumber
        role
        surname
      }
      coupaNumber
      paymentAccountNumber
      geographicAddresses {
        ...EntireGeographicAddress
      }
      vatIdNumber
      identifiers {
        name
        value
      }
    }
    companySpecification
    supplierTypes
    availableActions {
      delete
    }
  }
}
    ${EntireGeographicAddressFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SupplierDetailsGQL extends Apollo.Query<SupplierDetailsQuery, SupplierDetailsQueryVariables> {
    document = SupplierDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderDetailsDocument = gql`
    query OrderDetails($id: ID!) {
  order(id: $id) {
    createdAt
    id
    businessId
    state
    serviceDate
    actualServiceDate
    customerReferenceNo
    accessDetailsForSupplier {
      text
    }
    comment
    site {
      id
      businessId
      geographicAddress {
        ...EntireGeographicAddress
      }
      name
      customer {
        id
        contractId
        organization {
          id
          name
        }
      }
    }
    serviceLocation {
      name
      geographicAddress {
        ...EntireGeographicAddress
      }
    }
    destinationServiceLocation {
      name
    }
    accessDetailsForSupplier {
      text
    }
    comment
    supplier {
      name
      id
      businessId
    }
    scheduledOrder {
      id
      businessId
      scheduleId
      scheduleStartDate
      scheduleEndDate
      scheduleBusinessId
      scheduleConfiguration {
        ...EntireScheduleConfiguration
      }
    }
    request {
      id
      businessId
    }
    salesOrderLines {
      id
      orderId
      quantity
      actualQuantity
      unitPriceCurrency
      unitPriceValue
      unitType
      totalCost
      priceRuleDescription
      productData {
        packageCategory
        packageDescription
        productCategory
        wasteType
        wasteTypeName
        resource
        packageTypeId
      }
    }
    purchaseOrderLines {
      id
      orderId
      quantity
      actualQuantity
      unitPriceCurrency
      unitPriceValue
      unitType
      totalCost
      priceRuleDescription
      productData {
        packageCategory
        packageDescription
        productCategory
        wasteType
        wasteTypeName
        resource
        packageTypeId
      }
      treatmentFacility {
        id
        businessId
        name
      }
    }
    purchaseChargeLines {
      id
      createdAt
      createdBy {
        displayName
      }
      code
      amount
      currency
      unitType
      priceRuleDescription
    }
    salesChargeLines {
      id
      createdAt
      createdBy {
        displayName
      }
      code
      amount
      currency
      unitType
      priceRuleDescription
    }
    createdBy {
      displayName
    }
    availableActions {
      cancelSingleOrder
      cancelSchedule
      edit
      reportServiceFailure
      editWithoutNegotiation
      confirmDelivery
      creditMemo
    }
    amendments {
      pendingProposals {
        proposalId
        serviceDate
        containerQuantity
        orderLineProposals {
          id
          quantity
        }
        newAdditionalOrderLines {
          requestedQuantity
          additionalServiceCategoryCode
        }
        removedLineIds
        approvingSide {
          id
          name
        }
        proposingSide {
          id
          name
        }
      }
      startedAt
      requestedContainerQuantity
      requestedServiceDate
      permittedProposers {
        id
        name
      }
      startedBy {
        id
        name
      }
    }
    pendingAmendmentsExist
    pendingFailuresExist
    referenceGroupOrders {
      id
      businessId
      referenceType
    }
  }
}
    ${EntireGeographicAddressFragmentDoc}
${EntireScheduleConfigurationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderDetailsGQL extends Apollo.Query<OrderDetailsQuery, OrderDetailsQueryVariables> {
    document = OrderDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScheduleDetailsDocument = gql`
    query ScheduleDetails($id: ID!) {
  schedule(id: $id) {
    id
    createdAt
    startDate
    endDate
    businessId
    nearestScheduledOrder {
      id
      businessId
      orderType
      state
      customerReferenceNo
      accessDetailsForSupplier {
        text
      }
      comment
      site {
        id
        businessId
        name
        customer {
          id
          contractId
          organization {
            id
            name
          }
        }
        geographicAddress {
          ...EntireGeographicAddress
        }
      }
      serviceLocation {
        name
        geographicAddress {
          ...EntireGeographicAddress
        }
      }
      orderLines {
        id
        productData {
          productCategory
          packageCategory
          packageDescription
          wasteType
          wasteTypeName
          resource
          packageTypeId
        }
        quantity
      }
      createdAt
      supplier {
        id
        businessId
        name
      }
      scheduleConfiguration {
        ...EntireScheduleConfiguration
      }
      scheduleId
      scheduleBusinessId
      availableActions {
        cancel
        edit
      }
      amendments {
        pendingProposals {
          proposalId
          scheduleConfiguration {
            ...EntireScheduleConfiguration
          }
          containerQuantity
          approvingSide {
            id
            name
          }
          proposingSide {
            id
            name
          }
        }
        startedAt
        requestedContainerQuantity
        requestedScheduleConfiguration {
          ...EntireScheduleConfiguration
        }
        permittedProposers {
          id
          name
        }
        startedBy {
          id
          name
        }
      }
      pendingAmendmentsExist
      accessDetailsForSupplier {
        text
      }
    }
    scheduledOrders {
      scheduleConfiguration {
        ...EntireScheduleConfiguration
      }
      orderLines {
        productData {
          productCategory
          packageCategory
          packageDescription
          packageTypeId
          wasteType
          wasteTypeName
        }
        quantity
      }
    }
    request {
      id
      businessId
    }
    createdBy {
      id
      displayName
    }
  }
}
    ${EntireGeographicAddressFragmentDoc}
${EntireScheduleConfigurationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ScheduleDetailsGQL extends Apollo.Query<ScheduleDetailsQuery, ScheduleDetailsQueryVariables> {
    document = ScheduleDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestDetailsDocument = gql`
    query RequestDetails($id: ID!) {
  request(id: $id) {
    id
    businessId
    site {
      id
      businessId
      geographicAddress {
        ...EntireGeographicAddress
      }
      name
      customer {
        id
        contractId
        organization {
          id
          name
        }
      }
    }
    serviceLocation {
      name
      geographicAddress {
        ...EntireGeographicAddress
      }
    }
    createdAt
    supplier {
      name
      id
      businessId
    }
    customerReferenceNo
    accessDetailsForSupplier {
      text
    }
    comment
    purchaseRequestLines {
      productData {
        packageCategory
        packageDescription
        productCategory
        wasteType
        wasteTypeName
        resource
        packageTypeId
      }
      quantity
      unitType
      unitPriceCurrency
      totalCost
      priceRuleDescription
    }
    salesRequestLines {
      productData {
        productCategory
      }
      unitType
      unitPriceCurrency
      totalCost
      priceRuleDescription
    }
    createdBy {
      displayName
    }
    state
    ... on OnceOffRequest {
      serviceDate
      destinationServiceLocation {
        name
      }
      quotations {
        startedAt
        startedBy {
          id
          name
        }
        requestedServiceDate
        permittedProposers {
          id
          name
        }
        pendingProposals {
          proposalId
          startedAt
          serviceDate
          approvingSide {
            id
            name
          }
          proposingSide {
            id
            name
          }
        }
      }
      approvals {
        startedAt
        startedBy {
          id
          name
        }
        permittedProposers {
          id
          name
        }
        pendingProposals {
          canRespond
          proposalId
          startedAt
          approvingSide {
            id
            name
          }
          proposingSide {
            id
            name
          }
        }
      }
      order {
        id
        businessId
      }
    }
    ... on ScheduledRequest {
      scheduleConfiguration {
        ...EntireScheduleConfiguration
      }
      quotations {
        startedAt
        startedBy {
          id
          name
        }
        requestedScheduleConfiguration {
          ...EntireScheduleConfiguration
        }
        permittedProposers {
          id
          name
        }
        pendingProposals {
          proposalId
          startedAt
          scheduleConfiguration {
            ...EntireScheduleConfiguration
          }
          approvingSide {
            id
            name
          }
          proposingSide {
            id
            name
          }
        }
      }
      approvals {
        startedAt
        startedBy {
          id
          name
        }
        permittedProposers {
          id
          name
        }
        pendingProposals {
          canRespond
          proposalId
          startedAt
          approvingSide {
            id
            name
          }
          proposingSide {
            id
            name
          }
        }
      }
      scheduledOrder {
        id
        businessId
      }
    }
  }
}
    ${EntireGeographicAddressFragmentDoc}
${EntireScheduleConfigurationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestDetailsGQL extends Apollo.Query<RequestDetailsQuery, RequestDetailsQueryVariables> {
    document = RequestDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestsDocument = gql`
    query Requests($input: RequestFiltersInput!) {
  requests(requestFiltersInput: $input) {
    totalCount
    items {
      id
      businessId
      site {
        id
        businessId
        name
        customer {
          id
          contractId
          organization {
            id
            name
          }
        }
        geographicAddress {
          ...EntireGeographicAddress
        }
      }
      serviceLocation {
        name
        geographicAddress {
          ...EntireGeographicAddress
        }
      }
      state
      supplier {
        name
      }
      accessDetailsForSupplier {
        text
      }
      comment
      createdAt
      customerReferenceNo
      purchaseRequestLines {
        productData {
          packageCategory
          packageDescription
          productCategory
          wasteType
          wasteTypeName
          resource
          packageTypeId
        }
        quantity
      }
      createdBy {
        displayName
      }
      ... on OnceOffRequest {
        serviceDate
      }
      ... on ScheduledRequest {
        scheduleConfiguration {
          ...EntireScheduleConfiguration
        }
      }
    }
  }
}
    ${EntireGeographicAddressFragmentDoc}
${EntireScheduleConfigurationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestsGQL extends Apollo.Query<RequestsQuery, RequestsQueryVariables> {
    document = RequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestDocument = gql`
    query Request($id: ID!) {
  request(id: $id) {
    id
    businessId
    site {
      id
      businessId
      name
      customer {
        id
        contractId
        organization {
          id
          name
        }
      }
      geographicAddress {
        ...EntireGeographicAddress
      }
    }
    serviceLocation {
      name
      geographicAddress {
        ...EntireGeographicAddress
      }
    }
    state
    supplier {
      name
    }
    accessDetailsForSupplier {
      text
    }
    comment
    createdAt
    customerReferenceNo
    purchaseRequestLines {
      productData {
        packageCategory
        packageDescription
        productCategory
        wasteType
        wasteTypeName
        resource
        packageTypeId
      }
      quantity
    }
    createdBy {
      displayName
    }
    ... on OnceOffRequest {
      serviceDate
    }
    ... on ScheduledRequest {
      scheduleConfiguration {
        ...EntireScheduleConfiguration
      }
    }
  }
}
    ${EntireGeographicAddressFragmentDoc}
${EntireScheduleConfigurationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestGQL extends Apollo.Query<RequestQuery, RequestQueryVariables> {
    document = RequestDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrdersDocument = gql`
    query Orders($input: OrderFiltersInput!) {
  orders(orderFiltersInput: $input) {
    totalCount
    items {
      id
      businessId
      site {
        id
        businessId
        name
        customer {
          id
          contractId
          organization {
            id
            name
          }
        }
        geographicAddress {
          ...EntireGeographicAddress
        }
      }
      serviceLocation {
        name
        geographicAddress {
          ...EntireGeographicAddress
        }
      }
      state
      serviceDate
      actualServiceDate
      scheduledOrder {
        id
        businessId
        scheduleId
        scheduleBusinessId
        scheduleStartDate
        scheduleEndDate
        scheduleConfiguration {
          ...EntireScheduleConfiguration
        }
      }
      createdAt
      supplier {
        name
      }
      purchaseOrderLines {
        id
        orderId
        productData {
          packageCategory
          packageDescription
          productCategory
          wasteType
          wasteTypeName
          resource
          packageTypeId
        }
        quantity
        actualQuantity
      }
      createdBy {
        displayName
      }
      availableActions {
        cancelSingleOrder
        cancelSchedule
        edit
        reportServiceFailure
        editWithoutNegotiation
        confirmDelivery
        creditMemo
      }
      pendingAmendmentsExist
      pendingFailuresExist
    }
  }
}
    ${EntireGeographicAddressFragmentDoc}
${EntireScheduleConfigurationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrdersGQL extends Apollo.Query<OrdersQuery, OrdersQueryVariables> {
    document = OrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderDocument = gql`
    query Order($id: ID!) {
  order(id: $id) {
    id
    businessId
    site {
      id
      businessId
      name
      customer {
        id
        contractId
        organization {
          id
          name
        }
      }
      geographicAddress {
        ...EntireGeographicAddress
      }
    }
    serviceLocation {
      name
      geographicAddress {
        ...EntireGeographicAddress
      }
    }
    state
    serviceDate
    actualServiceDate
    scheduledOrder {
      id
      businessId
      scheduleId
      scheduleBusinessId
      scheduleStartDate
      scheduleEndDate
      scheduleConfiguration {
        ...EntireScheduleConfiguration
      }
    }
    createdAt
    supplier {
      name
    }
    purchaseOrderLines {
      id
      orderId
      productData {
        packageCategory
        packageDescription
        productCategory
        wasteType
        wasteTypeName
        resource
        packageTypeId
      }
      quantity
      actualQuantity
    }
    createdBy {
      displayName
    }
    availableActions {
      cancelSingleOrder
      cancelSchedule
      edit
      reportServiceFailure
      editWithoutNegotiation
      confirmDelivery
      creditMemo
    }
    pendingAmendmentsExist
    pendingFailuresExist
  }
}
    ${EntireGeographicAddressFragmentDoc}
${EntireScheduleConfigurationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderGQL extends Apollo.Query<OrderQuery, OrderQueryVariables> {
    document = OrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SchedulesDocument = gql`
    query Schedules($input: ScheduleFiltersInput!) {
  schedules(scheduleFiltersInput: $input) {
    totalCount
    items {
      id
      businessId
      startDate
      endDate
      nearestScheduledOrder {
        id
        state
        site {
          id
          businessId
          name
          customer {
            id
            contractId
            organization {
              id
              name
            }
          }
          geographicAddress {
            ...EntireGeographicAddress
          }
        }
        serviceLocation {
          name
          geographicAddress {
            ...EntireGeographicAddress
          }
        }
        orderLines {
          id
          productData {
            packageCategory
            packageDescription
            productCategory
            wasteType
            wasteTypeName
            resource
            packageTypeId
          }
          quantity
        }
        createdAt
        supplier {
          name
        }
        scheduleConfiguration {
          ...EntireScheduleConfiguration
        }
        scheduleId
        scheduleBusinessId
        availableActions {
          cancel
          edit
        }
        pendingAmendmentsExist
        accessDetailsForSupplier {
          text
        }
      }
      createdAt
    }
  }
}
    ${EntireGeographicAddressFragmentDoc}
${EntireScheduleConfigurationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SchedulesGQL extends Apollo.Query<SchedulesQuery, SchedulesQueryVariables> {
    document = SchedulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScheduleDocument = gql`
    query Schedule($id: ID!) {
  schedule(id: $id) {
    id
    businessId
    startDate
    endDate
    nearestScheduledOrder {
      id
      state
      site {
        id
        businessId
        name
        customer {
          id
          contractId
          organization {
            id
            name
          }
        }
        geographicAddress {
          ...EntireGeographicAddress
        }
      }
      serviceLocation {
        name
        geographicAddress {
          ...EntireGeographicAddress
        }
      }
      orderLines {
        id
        productData {
          packageCategory
          packageDescription
          productCategory
          wasteType
          wasteTypeName
          resource
          packageTypeId
        }
        quantity
      }
      createdAt
      supplier {
        name
      }
      scheduleConfiguration {
        ...EntireScheduleConfiguration
      }
      scheduleId
      scheduleBusinessId
      availableActions {
        cancel
        edit
      }
      pendingAmendmentsExist
      accessDetailsForSupplier {
        text
      }
    }
    createdAt
  }
}
    ${EntireGeographicAddressFragmentDoc}
${EntireScheduleConfigurationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ScheduleGQL extends Apollo.Query<ScheduleQuery, ScheduleQueryVariables> {
    document = ScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckCreateOnceOffRequestsPreconditionsDocument = gql`
    query CheckCreateOnceOffRequestsPreconditions($input: CreateOnceOffRequestsInput!) {
  checkCreateOnceOffRequestsPreconditions(input: $input) {
    allPreconditionsAreMet
    purchasePreconditions {
      priceRuleDescription
      productData {
        productCategory
      }
      totalCost
      unitPriceCurrency
      unitType
    }
    salesPreconditions {
      priceRuleDescription
      productData {
        productCategory
      }
      totalCost
      unitPriceCurrency
      unitType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckCreateOnceOffRequestsPreconditionsGQL extends Apollo.Query<CheckCreateOnceOffRequestsPreconditionsQuery, CheckCreateOnceOffRequestsPreconditionsQueryVariables> {
    document = CheckCreateOnceOffRequestsPreconditionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOnceOffRequestsDocument = gql`
    mutation CreateOnceOffRequests($input: CreateOnceOffRequestsInput!) {
  createOnceOffRequests(input: $input) {
    createdOrderIds
    createdRequestIds
    createdScheduleIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOnceOffRequestsGQL extends Apollo.Mutation<CreateOnceOffRequestsMutation, CreateOnceOffRequestsMutationVariables> {
    document = CreateOnceOffRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckCreateOnceOffManualRequestsPreconditionsDocument = gql`
    query CheckCreateOnceOffManualRequestsPreconditions($input: CreateOnceOffManualRequestsInput!) {
  checkCreateOnceOffManualRequestsPreconditions(input: $input) {
    allPreconditionsAreMet
    purchasePreconditions {
      priceRuleDescription
      productData {
        productCategory
      }
      totalCost
      unitPriceCurrency
      unitType
    }
    salesPreconditions {
      priceRuleDescription
      productData {
        productCategory
      }
      totalCost
      unitPriceCurrency
      unitType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckCreateOnceOffManualRequestsPreconditionsGQL extends Apollo.Query<CheckCreateOnceOffManualRequestsPreconditionsQuery, CheckCreateOnceOffManualRequestsPreconditionsQueryVariables> {
    document = CheckCreateOnceOffManualRequestsPreconditionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOnceOffManualRequestsDocument = gql`
    mutation CreateOnceOffManualRequests($input: CreateOnceOffManualRequestsInput!) {
  createOnceOffManualRequests(input: $input) {
    createdOrderIds
    createdRequestIds
    createdScheduleIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOnceOffManualRequestsGQL extends Apollo.Mutation<CreateOnceOffManualRequestsMutation, CreateOnceOffManualRequestsMutationVariables> {
    document = CreateOnceOffManualRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckCreateScheduledRequestsPreconditionsDocument = gql`
    query CheckCreateScheduledRequestsPreconditions($input: CreateScheduledRequestsInput!) {
  checkCreateScheduledRequestsPreconditions(input: $input) {
    allPreconditionsAreMet
    purchasePreconditions {
      priceRuleDescription
      productData {
        productCategory
      }
      totalCost
      unitPriceCurrency
      unitType
    }
    salesPreconditions {
      priceRuleDescription
      productData {
        productCategory
      }
      totalCost
      unitPriceCurrency
      unitType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckCreateScheduledRequestsPreconditionsGQL extends Apollo.Query<CheckCreateScheduledRequestsPreconditionsQuery, CheckCreateScheduledRequestsPreconditionsQueryVariables> {
    document = CheckCreateScheduledRequestsPreconditionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateScheduledRequestsDocument = gql`
    mutation CreateScheduledRequests($input: CreateScheduledRequestsInput!) {
  createScheduledRequests(input: $input) {
    createdOrderIds
    createdRequestIds
    createdScheduleIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateScheduledRequestsGQL extends Apollo.Mutation<CreateScheduledRequestsMutation, CreateScheduledRequestsMutationVariables> {
    document = CreateScheduledRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckCreateScheduledManualRequestsPreconditionsDocument = gql`
    query CheckCreateScheduledManualRequestsPreconditions($input: CreateScheduledManualRequestsInput!) {
  checkCreateScheduledManualRequestsPreconditions(input: $input) {
    allPreconditionsAreMet
    purchasePreconditions {
      priceRuleDescription
      productData {
        productCategory
      }
      totalCost
      unitPriceCurrency
      unitType
    }
    salesPreconditions {
      priceRuleDescription
      productData {
        productCategory
      }
      totalCost
      unitPriceCurrency
      unitType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckCreateScheduledManualRequestsPreconditionsGQL extends Apollo.Query<CheckCreateScheduledManualRequestsPreconditionsQuery, CheckCreateScheduledManualRequestsPreconditionsQueryVariables> {
    document = CheckCreateScheduledManualRequestsPreconditionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateScheduledManualRequestsDocument = gql`
    mutation CreateScheduledManualRequests($input: CreateScheduledManualRequestsInput!) {
  createScheduledManualRequests(input: $input) {
    createdOrderIds
    createdRequestIds
    createdScheduleIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateScheduledManualRequestsGQL extends Apollo.Mutation<CreateScheduledManualRequestsMutation, CreateScheduledManualRequestsMutationVariables> {
    document = CreateScheduledManualRequestsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SuppliersListDocument = gql`
    query SuppliersList($input: SuppliersFiltersInput!) {
  suppliers(suppliersFiltersInput: $input) {
    totalCount
    items {
      id
      organization {
        id
        name
        businessId
        active
        geographicAddresses {
          ...EntireGeographicAddress
        }
      }
      supplierTypes
      companySpecification
      availableActions {
        delete
      }
    }
  }
}
    ${EntireGeographicAddressFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SuppliersListGQL extends Apollo.Query<SuppliersListQuery, SuppliersListQueryVariables> {
    document = SuppliersListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerInputDocument = gql`
    query CustomerInput($input: CustomersFiltersInput!) {
  customers(customersFiltersInput: $input) {
    totalCount
    items {
      id
      organization {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerInputGQL extends Apollo.Query<CustomerInputQuery, CustomerInputQueryVariables> {
    document = CustomerInputDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SiteInputDocument = gql`
    query SiteInput($input: SitesFiltersInput!) {
  sites(sitesFiltersInput: $input) {
    totalCount
    items {
      id
      name
      customer {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SiteInputGQL extends Apollo.Query<SiteInputQuery, SiteInputQueryVariables> {
    document = SiteInputDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ServiceLocationInputDocument = gql`
    query ServiceLocationInput($input: ServiceLocationsFiltersInput!) {
  serviceLocations(serviceLocationsFiltersInput: $input) {
    totalCount
    items {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ServiceLocationInputGQL extends Apollo.Query<ServiceLocationInputQuery, ServiceLocationInputQueryVariables> {
    document = ServiceLocationInputDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnlyOneCustomerDocument = gql`
    query OnlyOneCustomer($ids: [ID!]) {
  customers(customersFiltersInput: {offset: 0, limit: 1, ids: $ids}) {
    totalCount
    items {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnlyOneCustomerGQL extends Apollo.Query<OnlyOneCustomerQuery, OnlyOneCustomerQueryVariables> {
    document = OnlyOneCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnlyOneSiteDocument = gql`
    query OnlyOneSite($customerId: ID) {
  sites(
    sitesFiltersInput: {offset: 0, limit: 1, siteStates: [ACTIVE], customerId: $customerId}
  ) {
    totalCount
    items {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnlyOneSiteGQL extends Apollo.Query<OnlyOneSiteQuery, OnlyOneSiteQueryVariables> {
    document = OnlyOneSiteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OnlyOneServiceLocationDocument = gql`
    query OnlyOneServiceLocation($siteId: ID) {
  serviceLocations(
    serviceLocationsFiltersInput: {offset: 0, limit: 1, siteId: $siteId}
  ) {
    totalCount
    items {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OnlyOneServiceLocationGQL extends Apollo.Query<OnlyOneServiceLocationQuery, OnlyOneServiceLocationQueryVariables> {
    document = OnlyOneServiceLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerForSiteDocument = gql`
    query CustomerForSite($id: ID!) {
  site(id: $id) {
    customer {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerForSiteGQL extends Apollo.Query<CustomerForSiteQuery, CustomerForSiteQueryVariables> {
    document = CustomerForSiteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SiteAccessDetailsDocument = gql`
    query SiteAccessDetails($id: ID!) {
  site(id: $id) {
    accessDetails
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SiteAccessDetailsGQL extends Apollo.Query<SiteAccessDetailsQuery, SiteAccessDetailsQueryVariables> {
    document = SiteAccessDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomersDocument = gql`
    query Customers($input: CustomersFiltersInput!) {
  customers(customersFiltersInput: $input) {
    totalCount
    items {
      id
      contractId
      businessUnit
      availableActions {
        delete
      }
      organization {
        id
        businessId
        name
        active
        geographicAddresses {
          ...EntireGeographicAddress
        }
      }
    }
  }
}
    ${EntireGeographicAddressFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomersGQL extends Apollo.Query<CustomersQuery, CustomersQueryVariables> {
    document = CustomersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BasicCustomersDocument = gql`
    query BasicCustomers($input: CustomersFiltersInput!) {
  customers(customersFiltersInput: $input) {
    totalCount
    items {
      id
      contractId
      organization {
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BasicCustomersGQL extends Apollo.Query<BasicCustomersQuery, BasicCustomersQueryVariables> {
    document = BasicCustomersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerDetailsDocument = gql`
    query CustomerDetails($id: ID!) {
  customer(id: $id) {
    id
    contractId
    businessUnit
    availableActions {
      delete
    }
    organization {
      id
      businessId
      active
      name
      identifiers {
        name
        value
      }
      comment
      geographicAddresses {
        ...EntireGeographicAddress
      }
      companyType
      vatIdNumber
      coupaNumber
      contactPeople {
        role
        surname
        phoneNumber
        email
        firstName
      }
      paymentAccountNumber
    }
  }
}
    ${EntireGeographicAddressFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerDetailsGQL extends Apollo.Query<CustomerDetailsQuery, CustomerDetailsQueryVariables> {
    document = CustomerDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SiteDetailsDocument = gql`
    query SiteDetails($id: ID!) {
  site(id: $id) {
    id
    businessId
    name
    active
    paymentAccountNumber
    contactPeople {
      firstName
      email
      phoneNumber
      surname
      role
    }
    comment
    buildingType
    accessDetails
    openDate
    closureDate
    availableActions {
      delete
    }
    customer {
      id
      contractId
      organization {
        id
        name
      }
    }
    identifiers {
      value
      name
    }
    geographicAddress {
      ...EntireGeographicAddress
    }
    serviceLocations {
      id
      businessId
      name
      latitude
      longitude
      geographicAddress {
        ...EntireGeographicAddress
      }
      what3words
    }
  }
}
    ${EntireGeographicAddressFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SiteDetailsGQL extends Apollo.Query<SiteDetailsQuery, SiteDetailsQueryVariables> {
    document = SiteDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSupplierDocument = gql`
    mutation CreateSupplier($input: SupplierInput!) {
  createSupplier(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSupplierGQL extends Apollo.Mutation<CreateSupplierMutation, CreateSupplierMutationVariables> {
    document = CreateSupplierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSupplierDocument = gql`
    mutation UpdateSupplier($input: UpdateSupplierInput!) {
  updateSupplier(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSupplierGQL extends Apollo.Mutation<UpdateSupplierMutation, UpdateSupplierMutationVariables> {
    document = UpdateSupplierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCustomerDocument = gql`
    mutation CreateCustomer($input: CustomerInput!) {
  createCustomer(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCustomerGQL extends Apollo.Mutation<CreateCustomerMutation, CreateCustomerMutationVariables> {
    document = CreateCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($input: UpdateCustomerInput!) {
  updateCustomer(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCustomerGQL extends Apollo.Mutation<UpdateCustomerMutation, UpdateCustomerMutationVariables> {
    document = UpdateCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateSiteDocument = gql`
    mutation CreateSite($input: SiteInput!) {
  createSite(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateSiteGQL extends Apollo.Mutation<CreateSiteMutation, CreateSiteMutationVariables> {
    document = CreateSiteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateSiteDocument = gql`
    mutation UpdateSite($input: UpdateSiteInput!) {
  updateSite(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSiteGQL extends Apollo.Mutation<UpdateSiteMutation, UpdateSiteMutationVariables> {
    document = UpdateSiteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RespondToEditOrderProposalDocument = gql`
    mutation RespondToEditOrderProposal($input: RespondToProposalInput!) {
  respondToEditOrderProposal(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RespondToEditOrderProposalGQL extends Apollo.Mutation<RespondToEditOrderProposalMutation, RespondToEditOrderProposalMutationVariables> {
    document = RespondToEditOrderProposalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RespondToEditScheduledOrderProposalDocument = gql`
    mutation RespondToEditScheduledOrderProposal($input: RespondToProposalInput!) {
  respondToEditScheduledOrderProposal(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RespondToEditScheduledOrderProposalGQL extends Apollo.Mutation<RespondToEditScheduledOrderProposalMutation, RespondToEditScheduledOrderProposalMutationVariables> {
    document = RespondToEditScheduledOrderProposalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RespondToRequestProposalDocument = gql`
    mutation RespondToRequestProposal($input: RespondToProposalInput!) {
  respondToRequestProposal(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RespondToRequestProposalGQL extends Apollo.Mutation<RespondToRequestProposalMutation, RespondToRequestProposalMutationVariables> {
    document = RespondToRequestProposalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProductsDocument = gql`
    query Products($catalogSearchCriteriaInput: CatalogSearchCriteriaInput) {
  products(catalogSearchCriteriaInput: $catalogSearchCriteriaInput) {
    id
    category
    isCategoryRecommended
    frequency
    wasteType
    resource
    supplierId
    isSupplierRecommended
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProductsGQL extends Apollo.Query<ProductsQuery, ProductsQueryVariables> {
    document = ProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentsDocument = gql`
    query Documents($input: DocumentSearchCriteriaInput!) {
  documents(input: $input) {
    items {
      id
      siteIds
      createdBy {
        displayName
      }
      createdAt
      documentType
      originalFileName
      availableActions {
        documentRollback {
          alreadyRolledBack
          canRollback
        }
      }
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentsGQL extends Apollo.Query<DocumentsQuery, DocumentsQueryVariables> {
    document = DocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentsInOrderDocument = gql`
    query DocumentsInOrder($input: DocumentInOrderSearchInput!) {
  documentsInOrder(input: $input) {
    id
    siteIds
    createdBy {
      displayName
    }
    createdAt
    documentType
    originalFileName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentsInOrderGQL extends Apollo.Query<DocumentsInOrderQuery, DocumentsInOrderQueryVariables> {
    document = DocumentsInOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadDocumentFileDocument = gql`
    query DownloadDocumentFile($id: ID!) {
  downloadDocumentFile(id: $id) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadDocumentFileGQL extends Apollo.Query<DownloadDocumentFileQuery, DownloadDocumentFileQueryVariables> {
    document = DownloadDocumentFileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCustomerDocument = gql`
    mutation DeleteCustomer($id: ID!) {
  deleteCustomer(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCustomerGQL extends Apollo.Mutation<DeleteCustomerMutation, DeleteCustomerMutationVariables> {
    document = DeleteCustomerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSiteDocument = gql`
    mutation DeleteSite($id: ID!) {
  deleteSite(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSiteGQL extends Apollo.Mutation<DeleteSiteMutation, DeleteSiteMutationVariables> {
    document = DeleteSiteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteSupplierDocument = gql`
    mutation DeleteSupplier($id: ID!) {
  deleteSupplier(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSupplierGQL extends Apollo.Mutation<DeleteSupplierMutation, DeleteSupplierMutationVariables> {
    document = DeleteSupplierDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadMasterExcelDocument = gql`
    mutation DownloadMasterExcel($input: DownloadMasterExcelInput!) {
  downloadMasterExcel(input: $input) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadMasterExcelGQL extends Apollo.Mutation<DownloadMasterExcelMutation, DownloadMasterExcelMutationVariables> {
    document = DownloadMasterExcelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadSalesPriceExcelDocument = gql`
    mutation DownloadSalesPriceExcel($input: DownloadSalesPriceExcelInput!) {
  downloadSalesPriceExcel(input: $input) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadSalesPriceExcelGQL extends Apollo.Mutation<DownloadSalesPriceExcelMutation, DownloadSalesPriceExcelMutationVariables> {
    document = DownloadSalesPriceExcelDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ServiceTypesDocument = gql`
    query ServiceTypes {
  serviceTypes {
    name
    presentedName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ServiceTypesGQL extends Apollo.Query<ServiceTypesQuery, ServiceTypesQueryVariables> {
    document = ServiceTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResourcesDocument = gql`
    query Resources($input: ResourcesFilterInput!) {
  resources(resourcesFilterInput: $input) {
    resources {
      presentedName
      code
    }
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResourcesGQL extends Apollo.Query<ResourcesQuery, ResourcesQueryVariables> {
    document = ResourcesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation CreateUser($input: UpdateUserInput!) {
  registerUser2(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUserGQL extends Apollo.Mutation<UpdateUserMutation, UpdateUserMutationVariables> {
    document = UpdateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeactivateUserDocument = gql`
    mutation DeactivateUser($id: ID!) {
  deleteUser(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeactivateUserGQL extends Apollo.Mutation<DeactivateUserMutation, DeactivateUserMutationVariables> {
    document = DeactivateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActivateUserDocument = gql`
    mutation ActivateUser($id: ID!) {
  activateUser(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActivateUserGQL extends Apollo.Mutation<ActivateUserMutation, ActivateUserMutationVariables> {
    document = ActivateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserDetailsDocument = gql`
    query UserDetails($upn: String!) {
  userAuthDetails(upn: $upn) {
    id
    active
    surname
    name
    upn
    positions {
      type
      employer
      employerCountry
      role
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserDetailsGQL extends Apollo.Query<UserDetailsQuery, UserDetailsQueryVariables> {
    document = UserDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AgentsDocument = gql`
    query Agents($agentInput: AgentInput!) {
  mainCountryAgent(agentInput: $agentInput) {
    id
    organization {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AgentsGQL extends Apollo.Query<AgentsQuery, AgentsQueryVariables> {
    document = AgentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmGroupOrderDeliveryDocument = gql`
    mutation ConfirmGroupOrderDelivery($id: ID!) {
  confirmGroupOrderDelivery(id: $id) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmGroupOrderDeliveryGQL extends Apollo.Mutation<ConfirmGroupOrderDeliveryMutation, ConfirmGroupOrderDeliveryMutationVariables> {
    document = ConfirmGroupOrderDeliveryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const OrderHistoryDocument = gql`
    query OrderHistory($id: ID!, $limit: PositiveInt) {
  orderHistory(id: $id, limit: $limit) {
    id
    createdAt
    createdBy {
      id
      displayName
    }
    description
    historyChanges {
      parameter
      oldValue
      newValue
    }
    sideCreator
    actionType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrderHistoryGQL extends Apollo.Query<OrderHistoryQuery, OrderHistoryQueryVariables> {
    document = OrderHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScheduleHistoryDocument = gql`
    query ScheduleHistory($id: ID!, $limit: PositiveInt) {
  scheduleHistory(id: $id, limit: $limit) {
    id
    createdAt
    createdBy {
      id
      displayName
    }
    description
    historyChanges {
      parameter
      oldValue
      newValue
    }
    sideCreator
    actionType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ScheduleHistoryGQL extends Apollo.Query<ScheduleHistoryQuery, ScheduleHistoryQueryVariables> {
    document = ScheduleHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateFinancialReportDocument = gql`
    mutation CreateFinancialReport($input: FinancialReportInput!) {
  createFinancialReport(input: $input) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateFinancialReportGQL extends Apollo.Mutation<CreateFinancialReportMutation, CreateFinancialReportMutationVariables> {
    document = CreateFinancialReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEquipmentReportDocument = gql`
    mutation CreateEquipmentReport($input: EquipmentReportInput!) {
  createEquipmentReport(input: $input) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEquipmentReportGQL extends Apollo.Mutation<CreateEquipmentReportMutation, CreateEquipmentReportMutationVariables> {
    document = CreateEquipmentReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateEquipmentReportInternalDocument = gql`
    mutation CreateEquipmentReportInternal($input: EquipmentReportInternalInput!) {
  createEquipmentReportInternal(input: $input) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateEquipmentReportInternalGQL extends Apollo.Mutation<CreateEquipmentReportInternalMutation, CreateEquipmentReportInternalMutationVariables> {
    document = CreateEquipmentReportInternalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCustomerReportDocument = gql`
    mutation CreateCustomerReport($input: CustomerReportInput!) {
  createCustomerReport(input: $input) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCustomerReportGQL extends Apollo.Mutation<CreateCustomerReportMutation, CreateCustomerReportMutationVariables> {
    document = CreateCustomerReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCustomersSitesLocationsReportDocument = gql`
    mutation CreateCustomersSitesLocationsReport {
  createCustomersSitesLocationsReport {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCustomersSitesLocationsReportGQL extends Apollo.Mutation<CreateCustomersSitesLocationsReportMutation, CreateCustomersSitesLocationsReportMutationVariables> {
    document = CreateCustomersSitesLocationsReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateMstReportDocument = gql`
    mutation CreateMstReport($input: MSTReportInput!) {
  createMstReport(input: $input) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateMstReportGQL extends Apollo.Mutation<CreateMstReportMutation, CreateMstReportMutationVariables> {
    document = CreateMstReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AdditionalServiceCategoriesDocument = gql`
    query AdditionalServiceCategories {
  additionalServiceCategories {
    id
    code
    presentedName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AdditionalServiceCategoriesGQL extends Apollo.Query<AdditionalServiceCategoriesQuery, AdditionalServiceCategoriesQueryVariables> {
    document = AdditionalServiceCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreditMemoDocument = gql`
    mutation CreditMemo($input: CreditMemoInput!) {
  creditMemo(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreditMemoGQL extends Apollo.Mutation<CreditMemoMutation, CreditMemoMutationVariables> {
    document = CreditMemoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UsersListDocument = gql`
    query UsersList($input: UsersFiltersInput!) {
  usersAuthDetails(usersFiltersInput: $input) {
    totalCount
    items {
      id
      active
      name
      surname
      displayName
      email: upn
      distinctRoles
      lastActivity
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UsersListGQL extends Apollo.Query<UsersListQuery, UsersListQueryVariables> {
    document = UsersListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadTemplateDocument = gql`
    query downloadTemplate($template: DocumentTemplate!) {
  downloadTemplate(template: $template) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadTemplateGQL extends Apollo.Query<DownloadTemplateQuery, DownloadTemplateQueryVariables> {
    document = DownloadTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerIdsDocument = gql`
    query CustomerIds {
  customers(customersFiltersInput: {offset: 0, limit: 999}) {
    items {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerIdsGQL extends Apollo.Query<CustomerIdsQuery, CustomerIdsQueryVariables> {
    document = CustomerIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SiteIdsDocument = gql`
    query SiteIds($customerId: ID!) {
  sites(
    sitesFiltersInput: {offset: 0, limit: 999, customerIds: [$customerId], siteStates: [ACTIVE]}
  ) {
    items {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SiteIdsGQL extends Apollo.Query<SiteIdsQuery, SiteIdsQueryVariables> {
    document = SiteIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ServiceLocationIdsDocument = gql`
    query ServiceLocationIds($siteId: ID!) {
  serviceLocations(
    serviceLocationsFiltersInput: {offset: 0, limit: 999, siteId: $siteId}
  ) {
    items {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ServiceLocationIdsGQL extends Apollo.Query<ServiceLocationIdsQuery, ServiceLocationIdsQueryVariables> {
    document = ServiceLocationIdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FailureTypesDocument = gql`
    query FailureTypes {
  failureTypes {
    name
    presentedName
    submitProposalAction
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FailureTypesGQL extends Apollo.Query<FailureTypesQuery, FailureTypesQueryVariables> {
    document = FailureTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FailuresDocument = gql`
    query Failures($id: String!) {
  failures(
    failureFiltersInput: {groupOrderIds: [$id], states: [PENDING, APPROVED, CANCELLED, REJECTED]}
  ) {
    failures {
      state
      waitingTimeInMinutes
      description
      code
      id
      createdAt
      createdBy {
        id
        displayName
      }
      negotiations {
        negotiationId
        state
        startedAt
        startedBy {
          id
          name
        }
        waitingFor {
          id
          name
        }
        isInArbitration
        proposals {
          canRespond
          response {
            comment
            responseType
          }
          serviceDate
          proposalId
          startedAt
          waitingTimeInMinutes
          approvingSide {
            id
            name
          }
          proposingSide {
            id
            name
          }
        }
        availableActions
        startedAt
        startedBy {
          id
          name
        }
      }
      documents {
        id
        originalFileName
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FailuresGQL extends Apollo.Query<FailuresQuery, FailuresQueryVariables> {
    document = FailuresDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RespondToFailureProposalDocument = gql`
    mutation RespondToFailureProposal($input: RespondToFailureProposalInput!) {
  respondToFailureProposal(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RespondToFailureProposalGQL extends Apollo.Mutation<RespondToFailureProposalMutation, RespondToFailureProposalMutationVariables> {
    document = RespondToFailureProposalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApplyForArbitrationDocument = gql`
    mutation ApplyForArbitration($input: ArbitrationInput!) {
  applyForArbitration(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ApplyForArbitrationGQL extends Apollo.Mutation<ApplyForArbitrationMutation, ApplyForArbitrationMutationVariables> {
    document = ApplyForArbitrationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EndFailureNegotiationDocument = gql`
    mutation EndFailureNegotiation($negotiationId: ID!) {
  endFailureNegotiation(input: {negotiationId: $negotiationId}) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EndFailureNegotiationGQL extends Apollo.Mutation<EndFailureNegotiationMutation, EndFailureNegotiationMutationVariables> {
    document = EndFailureNegotiationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitFailureProposalDocument = gql`
    mutation SubmitFailureProposal($negotiationId: ID!, $serviceDate: Date!) {
  submitFailureProposal(
    input: {negotiationId: $negotiationId, serviceDate: $serviceDate}
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitFailureProposalGQL extends Apollo.Mutation<SubmitFailureProposalMutation, SubmitFailureProposalMutationVariables> {
    document = SubmitFailureProposalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CountriesDocument = gql`
    query Countries {
  countries {
    id
    code
    presentedName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CountriesGQL extends Apollo.Query<CountriesQuery, CountriesQueryVariables> {
    document = CountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CountriesConfigDocument = gql`
    query CountriesConfig {
  countries {
    code
    config {
      useOrderConfirmationFlowByDefault
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CountriesConfigGQL extends Apollo.Query<CountriesConfigQuery, CountriesConfigQueryVariables> {
    document = CountriesConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindProcessesDocument = gql`
    query findProcesses($filters: FindProcessesGqlInput!) {
  findProcesses(filters: $filters) {
    items
    totalCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FindProcessesGQL extends Apollo.Query<FindProcessesQuery, FindProcessesQueryVariables> {
    document = FindProcessesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ProcessHierarchyDocument = gql`
    query processHierarchy($input: ProcessHierarchyGqlInput!) {
  processHierarchy(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProcessHierarchyGQL extends Apollo.Query<ProcessHierarchyQuery, ProcessHierarchyQueryVariables> {
    document = ProcessHierarchyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DownloadEmailAttachmentDocument = gql`
    query downloadEmailAttachment($id: ID!) {
  downloadEmailAttachment(id: $id) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadEmailAttachmentGQL extends Apollo.Query<DownloadEmailAttachmentQuery, DownloadEmailAttachmentQueryVariables> {
    document = DownloadEmailAttachmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PrefilledFileForSupplierDataUploadDocument = gql`
    mutation PrefilledFileForSupplierDataUpload($input: PrefilledFileForSupplierDataUploadInput!) {
  prefilledFileForSupplierDataUpload(input: $input) {
    url
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PrefilledFileForSupplierDataUploadGQL extends Apollo.Mutation<PrefilledFileForSupplierDataUploadMutation, PrefilledFileForSupplierDataUploadMutationVariables> {
    document = PrefilledFileForSupplierDataUploadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitEditOnceOffRequestProposalDocument = gql`
    mutation SubmitEditOnceOffRequestProposal($input: EditOnceOffRequestProposalInput!) {
  submitEditOnceOffRequestProposal(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitEditOnceOffRequestProposalGQL extends Apollo.Mutation<SubmitEditOnceOffRequestProposalMutation, SubmitEditOnceOffRequestProposalMutationVariables> {
    document = SubmitEditOnceOffRequestProposalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitEditScheduledRequestProposalDocument = gql`
    mutation SubmitEditScheduledRequestProposal($input: EditScheduledRequestProposalInput!) {
  submitEditScheduledRequestProposal(input: $input) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitEditScheduledRequestProposalGQL extends Apollo.Mutation<SubmitEditScheduledRequestProposalMutation, SubmitEditScheduledRequestProposalMutationVariables> {
    document = SubmitEditScheduledRequestProposalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelFailureDocument = gql`
    mutation CancelFailure($failureId: ID!) {
  cancelFailure(input: {failureId: $failureId}) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelFailureGQL extends Apollo.Mutation<CancelFailureMutation, CancelFailureMutationVariables> {
    document = CancelFailureDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyAuthDetailsDocument = gql`
    query MyAuthDetails {
  myAuthDetails {
    id
    upn
    displayName
    distinctRoles
    flatPositions {
      role
      employer
      type
    }
    distinctPermissions
    distinctCountries
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyAuthDetailsGQL extends Apollo.Query<MyAuthDetailsQuery, MyAuthDetailsQueryVariables> {
    document = MyAuthDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyPermissionsDocument = gql`
    query MyPermissions {
  myAuthDetails {
    distinctPermissions
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyPermissionsGQL extends Apollo.Query<MyPermissionsQuery, MyPermissionsQueryVariables> {
    document = MyPermissionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FilteredSuppliersDocument = gql`
    query FilteredSuppliers($suppliersFiltersInput: SuppliersFiltersInput!) {
  suppliers(suppliersFiltersInput: $suppliersFiltersInput) {
    items {
      id
      organization {
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FilteredSuppliersGQL extends Apollo.Query<FilteredSuppliersQuery, FilteredSuppliersQueryVariables> {
    document = FilteredSuppliersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CustomerNameDocument = gql`
    query CustomerName($id: ID!) {
  customer(id: $id) {
    organization {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CustomerNameGQL extends Apollo.Query<CustomerNameQuery, CustomerNameQueryVariables> {
    document = CustomerNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SiteNameDocument = gql`
    query SiteName($id: ID!) {
  site(id: $id) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SiteNameGQL extends Apollo.Query<SiteNameQuery, SiteNameQueryVariables> {
    document = SiteNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ServiceLocationNameDocument = gql`
    query ServiceLocationName($siteId: ID!) {
  serviceLocations(
    serviceLocationsFiltersInput: {siteId: $siteId, limit: 999, offset: 0}
  ) {
    items {
      address
      name
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ServiceLocationNameGQL extends Apollo.Query<ServiceLocationNameQuery, ServiceLocationNameQueryVariables> {
    document = ServiceLocationNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SupplierNameDocument = gql`
    query SupplierName($id: ID!) {
  supplier(id: $id) {
    organization {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SupplierNameGQL extends Apollo.Query<SupplierNameQuery, SupplierNameQueryVariables> {
    document = SupplierNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }